import { Image } from "primereact/image";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { InputText } from "primereact/inputtext";
import Layout from "../../components/common/nav/initiator/nav.component";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Auth, DataStore, Predicates, SortDirection, Storage } from "aws-amplify";
import { ValidateAllRoleExceptAdmin } from "../../helper/validateRole";
import { Column } from "primereact/column";
import ReactFullscreen from "react-easyfullscreen";
import { Sidebar } from "primereact/sidebar";
import { Tag } from "primereact/tag";
import { Badge } from "primereact/badge";
import sideBarRight from "../../assets/images/sidebarright.svg";
import Editpopup from "../../components/popup/editpopup";
import { ConfirmPopup } from 'primereact/confirmpopup';
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { Dialog } from "primereact/dialog";
import Login from "../../setup/auth/login.component";
import sidebar from "../../assets/images/sidebarright.svg";
import { Dropdown } from "primereact/dropdown";
import { FilterMatchMode } from "primereact/api";
import { API, graphqlOperation } from 'aws-amplify';
import {
  ConvertResponseForSelectWithRefCodedropdown,
  ConvertResponseForSelect,
  graphQLGetAllData
} from "../../helper/commonfunctions";
import { groupBy, orderBy, range } from "lodash";
import moment from "moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AWS from "aws-sdk";
import awsmobile from "../../aws-exports";
import { Calendar } from "primereact/calendar";
import empDetailsImg from "../../assets/images/applicationImg.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { reactLocalStorage } from "reactjs-localstorage";
import { TabPanel, TabView } from "primereact/tabview";
import { USER_TYPES, USER_TYPES_NAMES,SIXTH_ARCHIVE_DESIG } from "../../helper/enum";
import HtmlToPdfSix from "../../components/popup/sixPeriodPDF/htmltopdf";
import SixperiodAgreement from "./agreement";
import { InputSwitch } from "primereact/inputswitch";
import SignatureDialog from "../../components/signature/SignatureDialog";
import { dataURLtoBlob } from "../../components/signature/signatureHelper";
import { Card } from 'primereact/card';
import { handleNotificationsOnStatusChange, handleNotificationsOnStatusChangeNotificationReminder } from "../../components/actions/notficationActions";
import { updateSixthPeriodAssignmentInitiateReport } from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import * as mutations from "../../graphql/mutations";
import SpinnerLoader from "../../components/common/SpinnerLoader";
import { Timeline } from 'primereact/timeline';
import { Employee } from "../../models";
import { Tooltip } from "primereact/tooltip";
import { designationForAllApps } from "../../helper/enum";
import capitalizeFirstChar from "../../components/common/capitalizeFirstChar";
import { GetValueFromArray } from '../../helper/commonfunctions';

import ReportDeleteDialog from '../../components/reportSoftDelete/index';
import CheckboxColumn from "../../components/reportArchive/CheckboxColumn";
import CheckboxHeader from "../../components/reportArchive/CheckboxHeader";
import CheckArchive from '../../components/common/CheckArchive';

import RestoreDialog from '../../components/reportArchive/RestoreDialog';
export default function SixPeriodReportList() {

  let [events, setEvents] = useState([]);
const [restoreData, setRestoreData] = useState(null);
  const location = useLocation();
  let navigateTo = useNavigate();
  const searchParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);
  const [sixPeriodIsInitiator, setSixPeriodIsInitiator] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [sixPeriodIsApprover, setSixPeriodIsApprover] = useState(0);
  const [sixPeriodIsPayroll, setSixPeriodIsPayroll] = useState(0);
  const [sixPeriodIsSuperadmin, setSixPeriodIsSuperadmin] = useState(0);

  //states start
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedBudgetClerk, setSelectedBudgetClerk] = useState(null);
  const [selectedBudgetManager, setSelectedBudgetManager] = useState(null);
  const [selectedHrDirector, setSelectedHrDirector] = useState(null);
  const [selectedPayroll, setSelectedPayroll] = useState(null);

  const [selectedReportingManagerEmployee, setSelectedReportingManagerEmployee] = useState(null);

  const [isVisibleDelete, setIsVisibleDelete] = useState(false);
  const [isVisibleDeleteID, setIsVisibleDeleteID] = useState(null);

  const [allEmployeeDetails, setAllEmployeeDetails] = useState([]);
  const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState(null);
  const [empCodeList, setEmpCodeList] = useState([]);
  const [empCodeListForRM, setEmpCodeListForRM] = useState([]);

  //set employe list for cognito users
  const [empCodeListForBC, setEmpCodeListForBC] = useState([]);
  const [empCodeListForBD, setEmpCodeListForBD] = useState([]);
  const [empCodeListForHRD, setEmpCodeListForHRD] = useState([]);
  const [empCodeListForHRT, setEmpCodeListForHRT] = useState([]);


  const [specificReportDetailsView, setSpecificReportDetailsView] = useState([]);
  const [specificReportDetailsEdit, setSpecificReportDetailsEdit] = useState([]);

  //count and active index states
  const [activeIndex, setActiveIndex] = useState(0);
  const [submitCount, setSubmitCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [rejectCount, setRejectCount] = useState(0);
  const [pendingForApprovalCountForReqReportsCount, setPendingForApprovalCountForReqReports] = useState(0);
  const [approvedCountForReqReportsCount, setApprovedCountForReqReports] = useState(0);
  const [rejectCountForReqReportsCount, setRejectCountForReqReports] = useState(0);

  //report list
  const [initiatorReportList, setInitiatorReportList] = useState([]);
  const [initiatorCSVData, setInitiatorCSVData] = useState([]);

  const [approvalReportRequestList, setApprovalReportRequest] = useState([]);
  const [payrollRequest, setPayrollRequest] = useState([]);

  const [fullViewEdit, setFullViewEdit] = useState(false);
  const [fullViewForView, setFullViewForView] = useState(false);

  const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
  const [showNextPopUp, setShowNextPopUp] = useState(false);
  const [confirmVisible2, setConfirmVisible2] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [groupName, setGroupName] = useState();
  const [accountCharged, setAccountCharged] = useState("");
  const [totalStaffingAllocationectedRole, setTotalStaffingAllocation] = useState("");
  const [subjectCode, setSubjectCode] = useState(null);
  const [fteUtilized, setFteUtilized] = useState("");
  //------------

  const [isAuthenticated, userHasAuthenticated] = useState(true);
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [visibleRequestedReportEdit, setVisibleRequestedReportEdit] = useState(false);
  const [visiblePayrollReportEdit, setVisiblePayrollReportEdit] = useState(false);
  const [checkedSignature, setCheckedSignature] = useState(false);
  const [needMoreApprovals, setNeedMoreApprovals] = useState(false);
  const [signature, setSignature] = useState(true);
  const [showNeedMoreApprovals, setShowNeedMoreApprovals] = useState(false);
  const [rejectVisible, setRejectVisible] = useState(false);
  const [rejectMsgValue, setRejectValueMsg] = useState("");
  const [sendMsg, setSendMsg] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [requestApprovalConfirmVisible, setRequestApprovalConfirmVisible] = useState(false);
  const [position, setPosition] = useState("center");
  const [visibleRight, setVisibleRight] = useState(false);
  const [visibleAgreementPopup, setVisibleAgreementPopup] = useState(false);
  const [activate, setActivate] = useState("");
  const [fallBackApprover, setFallBackApprover] = useState();
  const [fallBackApproverLevel, setFallBackApproverLevel] = useState();
  const [fallBackUsersList, setFallBackUsersList] = useState([]);
  const [signatureDialog, setSignatureDialog] = useState(false);
  const [signaturePath, setSignaturePath] = useState(null);
  const [signatureFileAwsPath, setSignatureFileAwsPath] = useState(null);
  const [addSignature, setAddSignature] = useState(false);
  const [currentEditRow, setCurrentEditRow] = useState(null);

  //pagination
  const [totalRecords, setTotalRecords] = useState(0); // Total number of records
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10; // Number of records per page

  const [openNewEmployee, setOpenNewEmployee] = useState(false);
  const [NewEmployeeSchool, setNewEmployeeSchool] = useState(null);
  // const [NewEmployeeName, setNewEmployeeName] = useState('');
  const [newEmpFirstName, setNewEmpFirstName] = useState('');
  const [newEmpLastName, setNewEmpLastName] = useState('');
  const rolesArray = [
    { name: 'Initiator', code: 'I' },
    { name: 'Approver', code: 'AP' },
    { name: 'Payroll', code: 'P' },
  ];
  const [newEmpSelectedRole, setNewEmpSelectedRole] = useState(null);
  const [newEmpSelectedDesignation, setNewEmpSelectedDesignation] = useState(null);
  const [NewEmployeeCode, setNewEmployeeCode] = useState('');
  const [NewEmployeeEmail, setNewEmployeeEmail] = useState('');
  const [userSub, setUserSub] = useState("");
  const [reportSubmitting, setReportSubmitting] = useState(false);
  const [sixPeriodEmployeeData, setSixPeriodEmployeeData] = useState([]);
  const sixPeriodIsSuperAdminRole = reactLocalStorage.get("isSixthPeriodSuperAdmin");

  console.log("sixPeriodIsSuperAdminRole",sixPeriodIsSuperAdminRole);

  const HREmail = process.env.REACT_APP_Sixperiod_Email;

  // Adding default fallback email for pay role cc
  let financeAnalystEmail = 'financeanalyst@innive.com';
  let executiveDirectorEmail = 'exedir@innive.com';
  let defaultCcEmail = "rajiba.tiria@gmail.com";

  if (window.location.hostname === 'gusd-k12forms.hexalytics.ai') {
    defaultCcEmail = "payroll.info@gusd.net";
    financeAnalystEmail = "clarimer@gusd.net";
    executiveDirectorEmail = "ccoulter@gusd.net";
  }

  const approverLevels = ["teacher", "site_admin", "budget_clerk", "budget_director", "hr_director", "financial_analyst", "executive_director", "payroll"];
  const approverDesignations = {
    initiator: "Initiator",
    teacher: "Teacher",
    site_admin: "Site Admin/ Dept Head",
    budget_clerk: "Budget Clerk",
    budget_director: "Budget Director",
    hr_director: "HR Director",
    financial_analyst: "Financial Analyst",
    executive_director: "Executive Director",
    payroll: "HR Technician"
  }
  const [pendingApprovers, setPendingApprovers] = useState(approverLevels);
  const [sendToCc, setSendToCc] = useState(undefined);

  const acceptFunc = (callback) => { callback() }
  const rejectFunc = (callback) => { }

  const confirm = (event, callback) => {
    if (loggedInUserData?.role !== 'Superadmin') {
      return callback?.();
    }
    const myConfirm = confirmPopup({
      target: event.currentTarget,
      message: 'Are you sure you want to proceed?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc(callback),
      reject: () => rejectFunc(callback)
    });
  }

  const cancelButton = (handler) => {
    return (
      <button
        onClick={handler}
        type="button"
        className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
        id="add-family-cancel-btn"
      >
        Cancel
      </button>
    )
  }

  const SaveUserToCognito = async (newEmployeeId) => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    const userPoolId = awsmobile.aws_user_pools_id;
    const username = NewEmployeeEmail
    const password = "Gusd@2023"
    const Permanent = true

    let attributes = [
      {
        Name: 'email',
        Value: NewEmployeeEmail
      },
      {
        Name: 'custom:firstName',
        Value: newEmpFirstName
      },
      {
        Name: 'custom:lastName',
        Value: capitalizeFirstChar(newEmpLastName)
      },
      {
        Name: 'name',
        // Value: NewEmployeeName
        Value: capitalizeFirstChar(newEmpLastName) + ", " + newEmpFirstName.toUpperCase()
      },
      {
        Name: 'custom:userCode',
        Value: NewEmployeeCode
      },
      // {
      //     Name: 'custom:city',
      //     Value: city
      // },
      // {
      //     Name: 'custom:mobileNumber',
      //     Value: phoneNo
      // },
      // {
      //     Name: 'custom:address',
      //     Value: addressOne
      // },
      // {
      //     Name: 'custom:stateId',
      //     Value: state
      // },
      // {
      //     Name: 'custom:countryId',
      //     Value: country
      // },
      // {
      //     Name: 'custom:userType',
      //     Value: userType.label
      // },
      {
        Name: 'custom:empId',
        Value: newEmployeeId
      },

    ];

    const params = {
      UserPoolId: userPoolId,
      Username: username,
      UserAttributes: attributes
    };

    const params2 = {
      UserPoolId: userPoolId,
      Username: username,
      Password: password,
      Permanent: Permanent,
    };

    let userSub;
    try {
      const createUserResponse = await cognito.adminCreateUser(params).promise();
      console.log('Employee confirmed and saved successfully', createUserResponse);
      userSub = createUserResponse.User?.Attributes?.find(attr => attr.Name === 'sub')?.Value;
      setUserSub(userSub)
      toast.success("Employee confirmed and saved successfully")

      // User Confirmation 
      cognito.adminSetUserPassword(params2, (err, data) => {
        if (err) {
          console.log('Error confirming user:', err);
        } else {
          console.log('User confirmed successfully:', data);
        }
      });

      // try {
      //   const cognito = new AWS.CognitoIdentityServiceProvider();

      //   const params = {
      //     UserPoolId: awsmobile.aws_user_pools_id,
      //     Limit: 60,
      //     Filter: `name ^= "${NewEmployeeName}"`,
      //   };

      //   const data = await cognito.listUsers(params).promise();
      //   const usersData = data.Users.map(user => {
      //     const role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
      //     const name = user.Attributes.find(attr => attr.Name === "name")?.Value;
      //     const sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
      //     const email = user.Attributes.find(attr => attr.Name === "email")?.Value;
      //     const userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
      //     const formattedName = userCode ? `${name} (${userCode})` : name;

      //     return {
      //       "code": sub,
      //       "name": formattedName,
      //       "email": email,
      //       "userCode": userCode,
      //       "role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
      //     };
      //   });

      //   const filteredUsersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);

      //   setEmpCodeList(filteredUsersData);
      //   const newEmpForRM = empCodeList.filter(item => item.code !== filteredUsersData[0].code);
      //   setEmpCodeListForRM(newEmpForRM);          
      //   setSelectedEmployee(filteredUsersData[0]);


      // } catch (e) {
      //   // Handle error or toast error message here
      //   // toast.error(e.message);
      // }




    } catch (error) {
      console.error('Error saving Cognito user:', error);
    }



    // if (userSub !== null) {
    //   //Update Employee with Cognito UserId
    //   const original = await DataStore.query(Employee, newEmployeeId);
    //   await DataStore.save(
    //     Employee.copyOf(original, (updated) => {
    //       updated.user_Id = userSub
    //     })
    //   );

    // }

    if (userSub !== null) {
      //Update Employee with Cognito UserId
      const original = await API.graphql(
        graphqlOperation(queries.getEmployee,
          { id: newEmployeeId }
        )
      );
      // await DataStore.query(Employee, newEmployeeId);
      await API.graphql(
        graphqlOperation(mutations.updateEmployee, {
          input: {
            id: original?.data?.getEmployee?.id,
            user_Id: userSub,
            _version: original?.data?.getEmployee?._version,
          }
        }))
    }

    return userSub;
  }

  //get unique emplyee lists
  const getUniqueEmployeeList = async (employeeResponses) => {
    // Grouping by email of employee in the school
    const groupedByEmail = employeeResponses.reduce((acc, obj) => {
      const email = obj.email;
      if (!acc[email]) {
        acc[email] = [];
      }
      acc[email].push(obj);

      return acc;
    }, {});

    //console.log(groupedByEmail,"groupedByEmail")
    // Order each group by createdAt date in descending order
    for (const email in groupedByEmail) {
      groupedByEmail[email].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }
    // Create a list with unique email addresses and the latest object for each email
    const uniqueEmailList = Object.keys(groupedByEmail).map((email) => groupedByEmail[email][0]);

    // Display the result
    //console.log(uniqueEmailList,"uniqueEmailList1");
    return uniqueEmailList;
  }

  //search cognitousers
  const AddNewEmployee = async () => {
    if (NewEmployeeSchool === "" || NewEmployeeSchool === null) {
      toast.error("Please Select School/Department");
      return;
    }
    // else if (NewEmployeeName === null || NewEmployeeName === "") {
    //   toast.error("Please Enter Employee Name");
    //   return;
    // }
    else if (newEmpFirstName === null || newEmpFirstName === "") {
      toast.error("Please Enter Employee First Name");
      return;
    }
    else if (newEmpLastName === null || newEmpLastName === "") {
      toast.error("Please Enter Employee Last Name");
      return;
    }
    // else if (newEmpSelectedRole === null) {
    //   toast.error("Please Select Employee Role");
    //   return;
    // }
    // else if (newEmpSelectedDesignation === null) {
    //   toast.error("Please Select Employee Designation");
    //   return;
    // }

    else if (NewEmployeeCode === "") {
      toast.error("Please Enter Employee Code");
      return;
    } else if (NewEmployeeEmail === null || NewEmployeeEmail === "") {
      toast.error("Please Enter Employee Email");
      return;
    }

    //first check typed email id is already present or not
    const matchedEmailRecord = await graphQLGetAllData("listEmployees", [{ email: { eq: NewEmployeeEmail } }])
    console.log(matchedEmailRecord.length, "matchedEmailRecord.length")
    const matchedEmailSchool = matchedEmailRecord.filter(item => item.school_id === NewEmployeeSchool?.code)
    console.log(matchedEmailSchool.length, "matchedEmailSchool.length")


    if (matchedEmailSchool.length === 0) {
      var AddedNewEmployee = await API.graphql(
        graphqlOperation(mutations.createEmployee,
          {
            input: {
              "school_id": NewEmployeeSchool?.code,
              firstName: newEmpFirstName.toUpperCase(),
              lastName: capitalizeFirstChar(newEmpLastName),
              employee_name: capitalizeFirstChar(newEmpLastName) + ", " + newEmpFirstName.toUpperCase(),
              // role: newEmpSelectedRole?.code,
              // designation: newEmpSelectedDesignation.code,
              "employee_code": NewEmployeeCode,
              "email": NewEmployeeEmail
            }
          }))

      let userSub;
      if (AddedNewEmployee?.data?.createEmployee?.id !== null) {
        if (matchedEmailRecord.length === 0) {
          //Save Cognito User
          // await SaveUserToCognito(AddedNewEmployee?.data?.createEmployee?.id);
          userSub = await SaveUserToCognito(AddedNewEmployee?.data?.createEmployee?.id);
        }
      }

      if (userSub)
        if (AddedNewEmployee) {
          try {
            // var employeeList = await graphQLGetAllData("listEmployees", [{ school_id: { eq: AddedNewEmployee.data.createEmployee.school_id } }])
            var employeeList = await graphQLGetAllData("listEmployees")
            employeeList = await getUniqueEmployeeList(employeeList)
            if (employeeList !== null) {
              let employeeData = employeeList;
              let employee = [];
              employeeData.map((item) => {
                let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                let obj = {
                  name: name,
                  // code: item.id,
                  code: userSub,
                  userCode: item?.employee_code
                }
                employee.push(obj);
              })

              // const newEmpForRM = empCodeList.filter(item => item.code !== e.value.code);
              setEmpCodeListForRM(employee);
              setEmpCodeList(employee);
            }
          }
          catch (error) {
            console.log('error --->', error);
          }

          let obj = {
            name: AddedNewEmployee?.data?.createEmployee?.employee_name + " (" + AddedNewEmployee?.data?.createEmployee?.employee_code + ")",
            code: userSub,
            userCode: AddedNewEmployee?.data?.createEmployee?.employee_code
          }
          setSelectedEmployeeDetails(obj);
          setSelectedEmployee(obj);
          toast.success('Data Added Successfully.');


          setOpenNewEmployee(false)
          setNewEmployeeSchool(null);
          setNewEmpFirstName("");
          setNewEmpLastName("");
          setNewEmpSelectedRole(null);
          setNewEmpSelectedDesignation(null);
          setNewEmployeeCode("");
          setNewEmployeeEmail("");
        }
    } else {
      toast.error("Please Use Another Email");
    }
  }
  //search cognitousers
  const setEmpList = async (e, listName) => {
    try {
      const cognito = new AWS.CognitoIdentityServiceProvider();

      const params = {
        UserPoolId: awsmobile.aws_user_pools_id,
        Limit: 60,
        Filter: `name ^= "${e.target.value}"`,
      };
      var employeeList = await fetchPaginatedRecords(
        queries.listEmployees,
        null,
        { field: "employee_name", direction: "asc" },
        1000,
        'listEmployees'
      );
      // await DataStore.query(Employee, Predicates.ALL, {
      //   sort: s => s.employee_name(SortDirection.ASCENDING)
      // });
      console.log('employeeList --->', employeeList);
      employeeList = await getUniqueEmployeeList(employeeList)

      // const data = await cognito.listUsers(params).promise();
      // const usersData = data.Users.map(user => {
      //   const role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
      //   const name = user.Attributes.find(attr => attr.Name === "name")?.Value;
      //   const sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
      //   const email = user.Attributes.find(attr => attr.Name === "email")?.Value;
      //   const userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
      //   const formattedName = userCode ? `${name} (${userCode})` : name;

      //   return {
      //     "code": sub,
      //     "name": formattedName,
      //     "email": email,
      //     "userCode": userCode,
      //     "role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
      //   };
      // });

      // const filteredUsersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
      let filteredUsersData = [];
      employeeList.map((item) => {
        let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
        let obj = {
          name: name,
          code: item.user_Id,
          email: item.email,
          userCode: item.employee_code,
          role: item.role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : item.role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : item.role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,

        }
        filteredUsersData.push(obj);

      })
      switch (listName) {
        case 'SiteAdmin':
          setEmpCodeListForRM(filteredUsersData);
          break;
        case 'BudgetClerk':
          setEmpCodeListForBC(filteredUsersData);
          break;
        case 'BudgetDirector':
          setEmpCodeListForBD(filteredUsersData);
          break;
        case 'HRdirector':
          setEmpCodeListForHRD(filteredUsersData);
          break;
        case 'HRtechnician':
          setEmpCodeListForHRT(filteredUsersData);
          break;
        case 'Employee':
        default:
          setEmpCodeList(filteredUsersData);
          break;
      }
    } catch (e) {
      // Handle error or toast error message here
      // toast.error(e.message);
    }
  };


  const setHRPayroll = async () => {

    try {
      const cognito = new AWS.CognitoIdentityServiceProvider();

      var params =
      {
        UserPoolId: awsmobile.aws_user_pools_id,
        Limit: 60,
        "Filter": "email ^= \"" + HREmail + "\""
      };

      await cognito.listUsers(params, (err, data) => {
        if (err) {
          //(err.message);
        } else {
          let usersData = []
          //let adminUsers = data.Users
          var name = "";
          var sub = "";
          var userCode = "";
          console.log(data.Users[0], 'name');

          data.Users.forEach((user, i) => {
            name = user.Attributes.find(attr => attr.Name === "name")?.Value;
            sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
            userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

            //{ name: name, code: sub }

            let objFirst = {
              name: name ? `${name} (${userCode})` : "",
              code: sub,
              label: name,
              userCode: userCode
            };
            setSelectedPayroll(objFirst)
            setEmpCodeListForHRT([objFirst])


          })
        }
      });

    } catch (e) {
      //toast.error(e.message);
    }
  }

  //notification remainder start
  const [ReminderDialog, setreminderDialog] = useState(false);
  const [ReminderData, setreminderData] = useState(null);
  const RemainderFunction = async (rowData) => {
    try {
      let status = 'REMINDER_PENDING_FOR_APPROVAL'
      handleNotificationsOnStatusChangeNotificationReminder(status, rowData, "SIX_PERIOD", loggedUserId);
      setreminderDialog(false);
      toast.success("Reminder Sent Successfully")
    } catch (err) {
      console.log("Error is :-", err);
    }
  }


  const setEmpListFromData = (listName) => {

    let filteredUsersData = [];
    sixPeriodEmployeeData.map((item) => {
      let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
      let obj = {
        name: name,
        code: item.user_Id,
        email: item.email,
        userCode: item.employee_code,
        role: item.role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : item.role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : item.role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,

      }
      filteredUsersData.push(obj);

    })

    switch (listName) {
      case 'SiteAdmin':
        setEmpCodeListForRM(filteredUsersData);
        break;
      case 'BudgetClerk':
        setEmpCodeListForBC(filteredUsersData);
        break;
      case 'BudgetDirector':
        setEmpCodeListForBD(filteredUsersData);
        break;
      case 'HRdirector':
        setEmpCodeListForHRD(filteredUsersData);
        break;
      case 'HRtechnician':
        setEmpCodeListForHRT(filteredUsersData);
        break;
      case 'Employee':
      default:
        setEmpCodeList(filteredUsersData);
        break;
    }

  }
  const handleClearButtonClick = (e, data, listName) => {
    console.log(e.value, "e.value")



    if ((e.value === null || e.value === undefined) && data.length <= 1) {
      setEmpListFromData(listName)
      //setEmpCodeListForRM(filteredUsersData)
      console.log(listName, "listName")
    }
  }

  const footerContentForReminder = (
    <div className="text-center">
      <div className="d-flex">
        <button
          onClick={() => { RemainderFunction(ReminderData) }}
          type="button"
          className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
        >
          Yes
        </button>
        <button
          onClick={() => { setreminderDialog(false) }}
          type="button"
          className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
          id="add-family-cancel-btn"
        >
          No
        </button>
      </div>
    </div>
  );


  //footer Content code start
  const footerContent = (
    <div className="text-center">
      <button
        className="border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded"
        onClick={() => {
          setConfirmVisible(false);
          setVisibleEdit(false);
        }}
      >
        Close
      </button>
    </div>
  );
  const footerContent1 = (
    <div className="text-center">
      <button
        className="border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded"
        onClick={() => {
          setConfirmVisible2(false);
          onHideEditPopUp();
          setVisibleCreteReportPopup(false);
          setShowPreviewPopUp(false);
          setAddSignature(false);
        }}
      >
        Close
      </button>
    </div>
  );

  const footerContentForReqApproval = (
    <div className="text-center">
      <button
        className="border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded"
        onClick={() => {
          processInitiatedReports(); processRequestedReports();
          setRequestApprovalConfirmVisible(false);
          setVisibleRequestedReportEdit(false);
          setAddSignature(false);
          if (visibleAgreementPopup) { setVisibleAgreementPopup(false); }
        }}
      >
        Close
      </button>
    </div>
  );

  const footerContentForReqReject = () => (
    <div className="text-center">
      {sendMsg ? (
        <>
          <button
            className="bg-[#113699] border border-[##113699] text-white px-8
           py-2 rounded"
            onClick={() => {
              processRequestedReports();
              setRejectVisible(false);
              setVisibleRequestedReportEdit(false);
              setSendMsg(false);
              setAddSignature(false);
              if (visibleAgreementPopup) { setVisibleAgreementPopup(false); }
            }}
          >
            Ok
          </button>
          {cancelButton(() => {
            setFallBackApprover(null);
            setRejectVisible(false);
          })}
        </>
      ) : (
        <>
          <button
            className="bg-[#113699] border border-[##113699] text-white px-8
           py-2 rounded"
            onClick={() => {
              rejectSelectedReport(specificReportDetailsEdit.id);
            }}
          >
            Send
          </button>
          {cancelButton(() => {
            setFallBackApprover(null);
            setRejectVisible(false);
          })}
        </>
      )}
    </div>
  );
  //footer Content code end

  //*state
  const [reportId, setReportId] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("");
  const [schoolList, setSchoolList] = useState("");
  const [schoolSelect, setSelectedSchool] = useState("");

  //*List
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeDetailsList, setEmployeeDetailsList] = useState([]);
  const [loggedInUserData, setLoggedInUserData] = useState([]);
  const [moreEmployeeList, setMoreEmployeeList] = useState([]);
  const [financeAnalyst, setFinanceAnalyst] = useState([]);
  const [executiveDirector, setExecutiveDirector] = useState([]);
  const [reportEmployeeList, setReportEmployeeList] = useState([]);
  const [users, setUsersList] = useState([]);
  const [absentCodeListDropdown, setSubjectListDropdown] = useState();
  const loggedUserId = reactLocalStorage.get("loggedUserId");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [assignmentTitle, setAssignmentTitle] = useState("");

  //edit form props fields

  const [editMode, setEditMode] = useState(false);
  const [editRequestID, setEditRequestID] = useState("");

  const [propsAssignmentTitle, setPropsAssignmentTitle] = useState("");
  const [propsSelectedEmployee, setPropsSelectedEmployee] = useState("");
  const [propsReportingManagerEmployee, setPropsReportingManagerEmployee] = useState("");

  const [propsSchoolSelect, setPropsSchoolSelect] = useState("");
  const [propsStartDate, setPropsStartDate] = useState("");
  const [propsSubjectCode, setPropsSubjectCode] = useState("");
  const [propsTotalStaffingAllocationectedRole, setPropsTotalStaffingAllocationectedRole] = useState("");
  // const [propsAccountCharge, setPropsAccountCharge] = useState("");
  const [propsFteUtilized, setPropsFteUtilized] = useState("");
  const [propsEndDate, setPropsEndDate] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");
  const [enableApprover, setEnableApprover] = useState(false);
  const [isClickedApprove, setIsClickedApprove] = useState(false);

  const [editRemark, setEditRemark] = useState("");

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    assignmentTitle: { value: null, matchMode: FilterMatchMode.CONTAINS },
    period: { value: null, matchMode: FilterMatchMode.CONTAINS },
    submittedOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    pretexts: { value: null, matchMode: FilterMatchMode.EQUALS },
    remark: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Assignee: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [statuses] = useState(["Acknowledged by HR Technician", 'Pending for Approval Teacher', 'Pending for Approval Site Admin/ Dept Head', 'Pending for Approval Budget Clerk', 'Pending for Approval Budget Director', 'Pending for Approval HR Director', 'Pending for Approval HR Technician', 'Pending for Approval Financial Analyst', 'Pending for Approval Executive Director', "Rejected"])
  const [statusesPayrolls] = useState(['Acknowledged', 'Pending for Acknowledgement']);

  const [approverLevelOptions, setApproverLevelOptions] = useState(null);
  const approverLevelTypeDic = { 0: 'Initiator', 1: 'Teacher', 2: 'Site Admin/ Dept Head', 3: 'Budget Clerk', 4: 'Budget Director', 5: 'HR Director', 6: 'HR Technician', 7: 'Financial Analyst', 8: 'Executive Director', 9: 'HR Technician' };
  const [initiatorReportsLoading, setInitiatorReportsLoading] = useState(true);
  const [requestedReportsLoading, setRequestedReportsLoading] = useState(true);
  const [payrollReportsLoading, setPayrollReportsLoading] = useState(true);
  const toastId = React.useRef(null);

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region
  });

  //status format and layout code start
  const TaskStatusSL = product => {
    switch (product.status) {
      case "Pending for Approval":
        return "warning";
      case "Pending for Approval Teacher":
        return "warning";
      case "Pending for Approval Site Admin/ Dept Head":
        return "warning";
      case "Pending for Approval Budget Clerk":
        return "warning";
      case "Pending for Approval Budget Director":
        return "warning";
      case "Pending for Approval HR Director":
        return "warning";
      case "Pending for Approval HR Technician":
        return "warning";
      case "Pending for Approval Financial Analyst":
        return "warning";
      case "Pending for Approval Executive Director":
        return "warning";
      case "Pending for Acknowledgement":
        return "warning";
      case "Rejected":
        return "danger";
      case "Pending":
        return "warning";
      case "Submitted":
        return "info";
      case "Approved":
        return "success";
      case "Approved (P)":
        return "success";
      case "Acknowledge":
        return "success";
      case "Acknowledged by HR Technician":
        return "success";
      case "Reviewed & resubmitted":
        return "info";
      default:
        return null;
    }
  };

  const TaskStatusSLA = product => {
    return <><Badge value="" severity={TaskStatusSL(product)}></Badge> {product.pretexts}</>;

    let prodStatus = product.status;
    let designation = product.designation;

    let pendingText = "Pending for Approval ";
    if (designation === approverDesignations.payroll) {
      pendingText = 'Pending for Acknowledgement ';
    }

    switch (product.status) {
      case "Reviewed & resubmitted":
        prodStatus = pendingText + designation;
        break;
      case "Rejected":
        prodStatus = product.status;
        break;
      case "Pending":
        prodStatus = "Pending ";
        break;
      case "Submitted":
        prodStatus = pendingText + designation;
        break;
      case "Acknowledge":
        prodStatus = "Acknowledge";
        break;
      default:
        prodStatus = product.status;
        break;
    }

    return <Tag value={prodStatus} severity={TaskStatusSL(product)}></Tag>;
  };

  const requestReportStatusOptions = product => {
    switch (product.status) {
      case "Rejected":
        return "danger";

      case "Pending for Approval":
        return "warning";

      case "SUBMITTED":
        return "info";
      case "Approved":
        return "success";

      case "Acknowledge":
        return "success";


      default:
        return null;
    }
  };

  const approveStatusOptions = product => {
    console.log("product", product)
    switch (product.status) {
      case "Rejected":
        return "danger";

      case "Pending For Approval":
        return "warning";

      case "Submitted":
        return "info";

      case "Closed":
        return "success";
      case "ReviewedResubmitted":
        return "info";
      case "site_admin":
        return "info";
      case "Pending":
        return "warning";
      case "Approved":
        return "success";
      default:
        return null;
    }
  };

  const payrollStatusOptions = product => {
    switch (product.status) {
      case "Pending for Acknowledgement":
        return "warning";
      case "Acknowledged":
        return "success";
      default:
        return null;
    }
  };

  const requestReportStatus = product => {
    return <><Badge value={""} severity={requestReportStatusOptions(product)}></Badge> {product.pretexts}</>;
  };

  const approvalStatusBody = product => {
    return <Tag value={product.status} severity={approveStatusOptions(product)}></Tag>;
  };

  const payrollStatusBody = product => {
    return <><Badge value="" severity={payrollStatusOptions(product)}></Badge> {product.status}</>;
  };

  const fetchPaginatedRecords = async (query, filter, sort, limit, resultKey, checkDeleted = true) => {
    let allRecords = [];
    let nextToken = null;
    let variables = checkDeleted ? { _deleted: { eq: null } } : {};
    // Add to query variables that are not null
    filter && (variables.filter = filter);
    limit && (variables.limit = 3000);
    sort && (variables.sort = sort);
    do {
      variables.nextToken = nextToken;
      const result = await API.graphql(graphqlOperation(query, variables));
      const { items, nextToken: newNextToken } = result.data[resultKey];

      allRecords = [...allRecords, ...items];
      nextToken = newNextToken;
    } while (nextToken);
    return allRecords.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
  };

  async function updateEditable(original, flag) {
    const inputData = {
      id: original.id,
      editable: flag,
      _version: original._version
    };

    await API.graphql({
      query: updateSixthPeriodAssignmentInitiateReport,
      variables: {
        input: inputData
      }
    });
  }

  const fetchInitiateReport = async (id) => {
    try {
      const result = await API.graphql(
        graphqlOperation(queries.getSixthPeriodAssignmentInitiateReport,
          { id: id }
        )
      );

      return result.data.getSixthPeriodAssignmentInitiateReport;
    } catch (error) {
      console.error('Error fetching original item:', error);
      return null;
    }
  }

  const loadMoreUser = async idArray => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    const params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };

    try {
      const data = await cognito.listUsers(params).promise();

      const usersMap = data.Users.map(user => getUserMap(user));

      const usersWithoutAdminAndLoggedUser = usersMap.filter(
        currentItem =>
          currentItem.role !== USER_TYPES_NAMES.A &&
          !idArray.includes(currentItem.userId)
      );

      const finalEmployeeList = [
        { name: 'No Approval Needed', code: 'no_approval_needed' },
        ...usersWithoutAdminAndLoggedUser.map(currentItem => ({
          name: currentItem.name,
          code: currentItem.userId,
          email: currentItem.email
        }))
      ];

      finalEmployeeList.sort((a, b) => a.name.localeCompare(b.name));
      setMoreEmployeeList(finalEmployeeList);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  const getUserRoleName = (userRole) => {
    switch (userRole) {
      case USER_TYPES.SUPERADMIN:
        return USER_TYPES_NAMES.SA;
      case USER_TYPES.ADMIN:
        return USER_TYPES_NAMES.A;
      case USER_TYPES.APPROVER:
        return USER_TYPES_NAMES.AP;
      case USER_TYPES.PAYROLL:
        return USER_TYPES_NAMES.P;
      default:
        return USER_TYPES_NAMES.I;
    }
  };

  function getUserProps(name, userCode, approverId) {
    return {
      name: name ? `${name} (${userCode})` : "",
      code: approverId,
      label: name,
      userCode: userCode
    };
  }

  const fetchUser = async (userId) => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    let user;
    if (userId) {
      try {
        user = await cognito
          .adminGetUser({
            UserPoolId: awsmobile.aws_user_pools_id,
            Username: userId
          })
          .promise();
      } catch (e) {
        console.log("Error is ", e);
      }
    }
    return user;
  }

  const getGraphqlFormattedDate = (date) => {
    return date.toISOString(true).split("T")[0]
  }

  const onClickHandleEdit = async (requestData, currentstatus) => {

    setCurrentEditRow(requestData);
    const original = await fetchInitiateReport(requestData.id);

    const isEditable = original?.editable;
    if (sixPeriodIsSuperadmin) {
      await updateEditable(original, false);
    } else if (!isEditable) {
      toast.error('The form is being edited by SuperAdmin, please try after some time!');
      return;
    }
    let latestTransactionCycle = await fetchLatestTransactionCycle(requestData.id);
    if (currentstatus === "Pending for approval") { //Only when approver is editing the report
      let latestApproverIndex = approverLevels.indexOf(latestTransactionCycle.approver_level);
      let pendingApprovers = approverLevels.slice(latestApproverIndex + 1);
      setPendingApprovers(pendingApprovers);
    }
    setShowPreviewPopUp(false);
    setConfirmVisible2(false);
    setEditMode(true);
    setEditRequestID(requestData.id);
    setCurrentStatus(currentstatus);

    //create form empty data set
    setAssignmentTitle("");
    setSelectedEmployee("");
    setSelectedReportingManagerEmployee("");
    setSelectedSchool("");
    setStartDate("");
    setEndDate("");
    setSubjectCode("");
    setTotalStaffingAllocation("");
    setAccountCharged("");
    setFteUtilized("");
    setSelectedBudgetClerk("");
    setSelectedBudgetManager("");
    setSelectedHrDirector("");
    setSelectedPayroll("");

    setEditRemark("");

    if (requestData) {
      setEditRemark(requestData.remark);



      var employeeList = sixPeriodEmployeeData;

      // const filteredUsersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
      let filteredUsersData = [];
      employeeList.map((item) => {
        let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
        let obj = {
          name: name,
          code: item.user_Id,
          email: item.email,
          userCode: item.employee_code,
          role: item.role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : item.role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : item.role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,

        }
        filteredUsersData.push(obj);

      })
      const finalEmpList = filteredUsersData;
      //set manager data employee
      const usersMap = users.map(user => getUserMap(user));

      const usersWithoutAdmin = filteredUsersData.filter(currentItem =>
        currentItem.role !== "Admin" && currentItem.userId !== loggedUserId
      );

      // Set employee list
      //comment for mis match issue 

      // const finalEmpList = users.map(currentItem => {
      // const userCode = currentItem.Attributes.find(attr => attr.Name === 'custom:userCode')?.Value || "";
      // const userId = currentItem.Attributes.find(attr => attr.Name === 'sub')?.Value || "";
      // return getUserProps(`${getFullName(currentItem.Attributes)}`, userCode, userId);
      // });
      setEmpCodeList(finalEmpList);
      setAllEmployeeDetails(usersWithoutAdmin);

      let employeeUser = requestData.employeeCode ? await fetchUser(requestData.employeeCode) : "";
      // let employeeUser = requestData.employeeCode ? await fetchUser('9afb035b-dcb7-4147-be34-7d6e6c7799ff') : "";

      let managerUserId = requestData.particular_emp_reporting_manager || "";
      let managerUser = managerUserId ? await fetchUser(managerUserId) : "";
      let managerName = "";
      let managerusercode = "";

      if (managerUser) {
        managerName = getFullName(managerUser.UserAttributes);
        managerusercode = managerUser.UserAttributes.find(attr => attr.Name === "custom:userCode")?.Value || "";
      }

      const newEmpForRM = finalEmpList.filter(emp => emp.code !== requestData.employeeCode);

      setEmpCodeListForRM(newEmpForRM);
      //set selected id employee data
      console.log(requestData, "employeeCode")
      const selectedEmployee = usersWithoutAdmin.find(item => item.code === requestData.employeeCode);
      //console.log(selectedEmployee,"selectedEmployee")
      if (selectedEmployee) {
        setSelectedEmployeeDetails(selectedEmployee);
        if (selectedEmployee.userReportingManager) {
          const reportingManager = finalEmpList.find(item => item.code === selectedEmployee.userReportingManager);
          setSelectedReportingManagerEmployee(reportingManager);
        } else {
          setSelectedReportingManagerEmployee(null);
        }
      }

      const employeeName = getFullName(employeeUser?.UserAttributes);
      const userCode = employeeUser?.UserAttributes.find(attr => attr.Name === "custom:userCode")?.Value || "";

      let subjectCodeResponses;

      let getSchool = await fetchPaginatedRecords(
        queries.listSchools,
        { name: { eq: requestData.assignmentAt } },
        null,
        null,
        "listSchools"
      );


      let schooll = getSchool && getSchool.length ? { code: getSchool[0].id, name: getSchool[0].name } : "";

      let subjectFilter = { name: { eq: requestData.subjectData } };
      subjectCodeResponses = await fetchPaginatedRecords(
        queries.listSubjects,
        subjectFilter,
        null,
        null,
        "listSubjects"
      );

      const subjectt = subjectCodeResponses && subjectCodeResponses.length ? subjectCodeResponses[0].name : requestData.subjectData;

      const commonEmployeeProps = getUserProps(employeeName, userCode, requestData.employeeCode);


      //set employe with employee table data mis match issue
      if (selectedEmployee) {
        setSelectedEmployee(selectedEmployee);
        let a = [...empCodeList, selectedEmployee]
        setEmpCodeList(a);
      } else {
        let a = [...empCodeList, commonEmployeeProps]
        setEmpCodeList(a);
        setSelectedEmployee(commonEmployeeProps);
      }

      if (managerUserId) {
        let managerProps = getUserProps(managerName, managerusercode, managerUserId);
        //mis match issue code changed
        managerProps = usersWithoutAdmin.find(item => item.code === managerUserId);
        setSelectedReportingManagerEmployee(managerProps);
        setEmpCodeListForRM([managerProps]);
      }

      //set budget clerk code shailesh from line 509 to 532

      let budgetUserId = employeeUser
        ? employeeUser.UserAttributes.find(attr => attr.Name === "custom:budgetClerkId")
        : "";
      budgetUserId = budgetUserId ? budgetUserId.Value : requestData.budgetClerkId;

      if (budgetUserId) {
        let budgetUser = requestData.budgetClerkId ? await fetchUser(requestData.budgetClerkId) : "";

        const budgetName = getFullName(budgetUser?.UserAttributes);
        const budgetusercode = budgetUser?.UserAttributes.find(attr => attr.Name === "custom:userCode")?.Value || "";

        if (budgetUser) {
          let budgetClerkProps = getUserProps(budgetName, budgetusercode, budgetUserId);
          //mis match issue code changed
          budgetClerkProps = usersWithoutAdmin.find(item => item.code === budgetUserId);
          setSelectedBudgetClerk(budgetClerkProps);
          setEmpCodeListForBC([budgetClerkProps]);
        }
      }

      //-----------------------------------------
      //set budget manager code
      let budgetManagerUserId = requestData.budgetManagerId;
      if (budgetManagerUserId) {
        let budgetManagerUser = await fetchUser(requestData.budgetManagerId);

        const budgetManagerName = getFullName(budgetManagerUser?.UserAttributes);
        const budgetManagerUserCode = budgetManagerUser?.UserAttributes.find(attr => attr.Name === "custom:userCode")?.Value || "";
        let budgetManagerProps = getUserProps(budgetManagerName, budgetManagerUserCode, budgetManagerUserId);

        //mis match issue code changed
        budgetManagerProps = usersWithoutAdmin.find(item => item.code === budgetManagerUserId);
        setSelectedBudgetManager(budgetManagerProps);
        setEmpCodeListForBD([budgetManagerProps]);
      }


      //set hr director code
      let hrDirectorId = requestData.hrDirectorId;

      if (hrDirectorId) {
        let hrDirectorUser = await fetchUser(hrDirectorId);
        const hrDirectorName = getFullName(hrDirectorUser?.UserAttributes);
        const hrDirectorUserCode = hrDirectorUser?.UserAttributes.find(attr => attr.Name === "custom:userCode")?.Value || "";

        let hrDirectorProps = getUserProps(hrDirectorName, hrDirectorUserCode, hrDirectorId);

        //mis match issue code changed
        hrDirectorProps = usersWithoutAdmin.find(item => item.code === hrDirectorId);
        setSelectedHrDirector(hrDirectorProps);
        setEmpCodeListForHRD([hrDirectorProps]);
      }


      //set payroll code
      let payrollId = requestData.payrollId;
      if (payrollId) {
        let payrollUser = await fetchUser(payrollId);
        const payrollName = getFullName(payrollUser?.UserAttributes);
        const payrollUserCode = payrollUser?.UserAttributes.find(attr => attr.Name === "custom:userCode")?.Value || "";
        const payrollProps = getUserProps(payrollName, payrollUserCode, payrollId);

        setSelectedPayroll(payrollProps);
        setEmpCodeListForHRT([payrollProps]);
      }

      //-----------------------------------------
      setAssignmentTitle(requestData.assignmentTitle);
      setSelectedSchool(schooll);
      setStartDate(new Date(requestData.fromDate));
      setEndDate(new Date(requestData.toDate));
      setSubjectCode(subjectt);
      setTotalStaffingAllocation(requestData.totalStaffAllocation);
      setAccountCharged(requestData.accountCharged);
      setFteUtilized(requestData.currentFTEUtilized);

      setShowNextPopUp(true);
    }
  };
  
  const initiateReportAction = (row) => {
        return (
            <div className="flex w-full items-center" >
                <Link to='#' className="py-2 px-2.5" onClick={() => onClickInitiateRequestViewPopup(row, "right")}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link>

                    <Link to='#'  title="restore" className="py-2 px-2.5 cursor-pointer" onClick={() => {
						setRestoreData(row);
                            setIsVisibleDelete(true)
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="18" viewBox="0 0 30 30">
              <path d="M 15 3 C 12.053086 3 9.3294211 4.0897803 7.2558594 5.8359375 A 1.0001 1.0001 0 1 0 8.5449219 7.3652344 C 10.27136 5.9113916 12.546914 5 15 5 C 20.226608 5 24.456683 8.9136179 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.441216 7.8348596 21.297943 3 15 3 z M 4.3007812 9 L 0.30078125 15 L 3 15 C 3 21.635519 8.3644809 27 15 27 C 17.946914 27 20.670579 25.91022 22.744141 24.164062 A 1.0001 1.0001 0 1 0 21.455078 22.634766 C 19.72864 24.088608 17.453086 25 15 25 C 9.4355191 25 5 20.564481 5 15 L 8.3007812 15 L 4.3007812 9 z" fill="#667085"></path>
            </svg>
							</Link>
            </div>
        );
    };
	
  //action layout code start
  const initiateReportAction_old = row => {
    let editable = row.pstatus === "Submitted" || row.pstatus === "Pending" || (row.pstatus === "Rejected");
    const commonProps = {
      className: "py-2 px-2.5",
      onClick: () => {
        if (editable) {
          onClickHandleEdit(row, row.pstatus);
        } else {
          onClickInitiateRequestViewPopup(row, "right");
        }
      }
    };

    let iconClass = (row.pstatus === "Approved" || row.pstatus === "Acknowledge")
      ? "gusd-eye text-[#667085] text-[20px] font-medium"
      : "gusd-edit text-[#667085] text-[20px] font-medium";

    console.log("row", row);
    return (
      <div className="flex justify-center w-full gap-1">
        <Link to="#" {...commonProps}><i className={iconClass}></i></Link>

        {row?.Assignee !== "-" && row?.pstatus != 'Rejected' ?
          <Link
            to="#"
            className="py-2 px-2.5 mt-1"
            onClick={() => {
              setreminderDialog(true);
              setreminderData(row);
            }}
          >
            <i className="gusd-notification text-[#667085] printicon text-[20px] xl:text-[1.250vw] mt-[5vw]"></i>
          </Link>
          : <div className="ml-[2.5vw]"></div>
        }

        {
          row.pstatus !== "Acknowledge" ?
            <Button
              icon="pi pi-trash pb-2"
              className="p-button-rounded p-button-text p-button-plain"
              onClick={() => {
                setIsVisibleDeleteID(row.id);
                setIsVisibleDelete(true)
              }}
            /> : <div className="ml-[2.5vw]"></div>
        }



      </div>
    );
  };


  const superAdminActions = row => {
    return [
      <Link to="#" className="py-2 px-2.5" onClick={() => onClickInitiateRequestViewPopup(row, "right")}>
        <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
      </Link>,
      <Link to="#" className="py-2 px-2.5" onClick={() => onClickHandleEdit(row, row.pstatus)}>
        <i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i>
      </Link>
    ]
  }

  const requestedReportAction = row => {
    return (
      <div className="flex justify-center w-full gap-2">

        {row.status === "Pending for Approval" ? (
          <Link
            to=""
            className="py-2 px-2.5"
            // onClick={() => { setVisibleRight(true); onClickPopup(row); }}
            onClick={() => onClickRequestedReportEditPopUp(row)}
          >
            <i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i>
          </Link>
        ) : row.status === "Approved" ? (
          <Link to="" className="py-2 px-2.5" onClick={async () => await onClickRequestedReportViewPopup(row, "right")}>
            <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
          </Link>
        ) : row.status === "Rejected" ? (
          <Link to="" className="py-2 px-2.5" onClick={async () => await onClickRequestedReportViewPopup(row, "right")}>
            <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
          </Link>
        ) : <Link to="" className="py-2 px-2.5" onClick={async () => await onClickRequestedReportViewPopup(row, "right")}>
          <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
        </Link>}
      </div>
    );
  };

  const payrollReportAction = row => {
    return (
      <div className="flex justify-center w-full gap-2">
        {row.status === "Pending for Acknowledgement" ? (
          <Link to="" className="py-2 px-2.5" onClick={() => onClickPayrollReportEditPopUp(row)}>
            <i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i>
          </Link>
        ) : row.status === "Acknowledged" ? (
          <Link to="" className="py-2 px-2.5" onClick={() => onClickRequestedReportViewPopup(row, "right")}>
            <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
          </Link>
        ) : // row.status === 'Rejected' ?
          //     <Link to='' className="py-2 px-2.5" onClick={() => onClickRequestedReportViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
          null}
      </div>
    );
  };
  //action layout code end
  const userPreciseInfo = (user) => {
    return { empName: user.name, empCode: user.userCode };
  }

  //* onclick view popup
  const onClickInitiateRequestViewPopup = async (requestData, position) => {


    //fetch user data
    const usersMap = users.map(user => getUserMap(user));

    //---Start Approval Status-----
    //get particular report id data from transaction cycle.
    let approvalFinalData = [];
    try {
      const particularReportTransactionCycleResponse = await fetchPaginatedRecords(
        queries.listSixthPeriodReportTransactionCycles,
        { report_Id: { eq: requestData.id } },
        { field: 'createdAt', direction: 'desc' },
        1000,
        'listSixthPeriodReportTransactionCycles')

      if (particularReportTransactionCycleResponse) {
        const approvalFinalDataPromises = particularReportTransactionCycleResponse.map(async item => {
          let toEmployeeInfo = usersMap.find(user => user.userId === item.to_Employee_Id)
          toEmployeeInfo = toEmployeeInfo || await fetchSpecificUserData(item.to_Employee_Id);
          if (toEmployeeInfo) {
            const status = item.status === 'Open' ? 'Pending For Approval' : item.status;
            const approvedDate = moment(item.createdAt).format('MM-DD-YYYY HH:mm');
            return {
              empName: toEmployeeInfo.name,
              empTitle: approverDesignations[item.approver_level],
              empCode: toEmployeeInfo.sub,
              status: status,
              approvedDate: approvedDate,
              empId: item.to_Employee_Id,
              approverLevel: item.approver_level,
            };
          }

          return null;
        }).filter(item => item !== null);
        approvalFinalData = await Promise.all(approvalFinalDataPromises);
      }
    } catch (error) {
      console.error('Error in fetching transaction cycles:', error);
    }
    let empData = usersMap.filter(currentItem => currentItem.userId === requestData.employeeCode);

    // mis match issue handle employee
    empData = sixPeriodEmployeeData.filter(currentItem => currentItem.user_Id === requestData.employeeCode);

    let empname = empData[0]?.employee_code ? `${empData[0]?.employee_code} (${empData[0]?.employee_name})` : empData[0]?.name;


    //---End Approval Status-------

    setPosition(position);
    setVisible(true);
    //set Data for View Popup
    let obj = {
      employeeName: empname,//empData[0].name,
      employee_id: empData[0]?.employee_code,//empData[0].userCode,
      assighment_at: requestData.assignmentAt,
      from_date: requestData.fromDate,
      to_date: requestData.toDate,
      subject_area: requestData.subjectData,
      total_staffing_allocation: requestData.totalStaffAllocation,
      account_charged: requestData.accountCharged,
      current_fte_utilized: requestData.currentFTEUtilized,
      initiator_id: requestData.submited_by,
      approvalFinalData: approvalFinalData,
    };
    setSpecificReportDetailsView(obj);

    //get Initiator name
    let initiatorEmp = await fetchSpecificUserData(requestData.submited_by);
    if (initiatorEmp) {
      let obj = {
        empName: initiatorEmp.name,
        empTitle: 'Initiator',
        empCode: initiatorEmp.sub,
        status: 'Submitted',
        approvedDate: requestData.submittedOn
      }

      let newEventArray = approvalFinalData.concat(obj);
      setEvents(newEventArray.reverse());
    }

  };

  //onclick requested report popups
  //onclick edit popup
  const onClickRequestedReportEditPopUp = async requestData => {
    setCurrentEditRow(requestData);
    setEditRequestID(requestData.id);
    //get employee data List sixPeriodEmployeeData

    //fetch user data
    const usersMap = users.map(user => getUserMap(user));

    try {
      const particularReportMetaData = fetchInitiateReport(requestData.id);

      if (particularReportMetaData && particularReportMetaData.hrDirectorI === loggedUserId) {
        setShowNeedMoreApprovals(true);
      }
    } catch (err) {
      console.log("Error when checking", err);
    }

    //---Start Approval Status-----
    //get particular report id data from transaction cycle.
    let approvalFinalData = [];
    try {
      const particularReportTransactionCycleResponse = await fetchPaginatedRecords(
        queries.listSixthPeriodReportTransactionCycles,
        { report_Id: { eq: requestData.id } },
        { field: 'createdAt', direction: 'desc' },
        1000,
        'listSixthPeriodReportTransactionCycles'
      )

      if (particularReportTransactionCycleResponse) {
        const approvalFinalDataPromises = particularReportTransactionCycleResponse.map(async transaction => {
          let matchingUser = usersMap.find(user => user.userId === transaction.to_Employee_Id);
          if (!matchingUser) {
            matchingUser = await fetchSpecificUserData(transaction.to_Employee_Id);
          }
          const empName = matchingUser ? matchingUser.name : "";
          const empCode = matchingUser ? matchingUser.userCode : ""
          const empTitle = approverDesignations[transaction.approver_level];

          const status = transaction.status === "Open"
            ? "Pending For Approval"
            : transaction.status;
          const approvedDate = moment(transaction.createdAt).format('MM-DD-YYYY HH:mm');
          return {
            empName: empName,
            empCode: empCode,
            empTitle: empTitle,
            status: status,
            approvedDate: approvedDate,
            empId: transaction.to_Employee_Id,
            approverLevel: transaction.approver_level,
          };
        });
        approvalFinalData = await Promise.all(approvalFinalDataPromises);
      }
    } catch (err) {
      console.log("Error in onClickInitiateRequestEditPopUp", err);
    }
    //---End Approval Status-------

    let empData = usersMap.filter(currentItem => currentItem.userId === requestData.employeeCode);
    // mis match issue
    empData = sixPeriodEmployeeData.filter(currentItem => currentItem.user_Id === requestData.employeeCode);
    //console.log(sixPeriodEmployeeData,"sixPeriodEmployeeData")
    //check logged user equal to first Approver which employee then open teacher acknowledge popup
    try {
      const particularReportResponse = fetchInitiateReport(requestData.id);

      if (particularReportResponse) {
        if (particularReportResponse.employee_id === loggedUserId) {
          setVisibleAgreementPopup(true);
        } else {
          setVisibleRequestedReportEdit(true);
        }
      }
    } catch (err) {
      console.log("Error in onRequestEdit popup Open:", err);
    }

    let empname = empData[0]?.employee_code ? `${empData[0]?.employee_code} (${empData[0]?.employee_name})` : empData[0]?.name;

    //get selected report id
    //set Data for View Popup
    let obj = {
      id: requestData.id,
      employeeName: empname,
      employee_id: empData[0]?.employee_code,  //empData[0]?.userCode,
      assighment_at: requestData.assignmentAt,
      from_date: requestData.fromDate,
      to_date: requestData.toDate,
      subject_area: requestData.subjectData,
      total_staffing_allocation: requestData.totalStaffAllocation,
      account_charged: requestData.accountCharged,
      current_fte_utilized: requestData.currentFTEUtilized,
      initiator_id: requestData.submited_by,

      approvalFinalData: approvalFinalData,
      submittedOn: requestData.submittedOn
    };
    setSpecificReportDetailsEdit(obj);

    //get Initiator name
    let initiatorEmp = await fetchSpecificUserData(requestData.submited_by);
    if (initiatorEmp) {
      let obj = {
        empName: initiatorEmp.name,
        empTitle: 'Initiator',
        empCode: initiatorEmp.sub,
        status: 'Submitted',
        approvedDate: requestData.submittedOn
      }

      let newEventArray = approvalFinalData.concat(obj);
      setEvents(newEventArray.reverse());
    }

    //check specific report =>transaction cycle length is greter than 3
    try {
      const transactions = await fetchPaginatedRecords(
        queries.listSixthPeriodReportTransactionCycles,
        { report_Id: { eq: requestData.id } },
        null,
        1000,
        'listSixthPeriodReportTransactionCycles'
      )

      if (transactions.length >= 3) {
        const reviewedResubmittedTransactions = transactions.slice(0, 3).filter(transaction =>
          transaction.status === "ReviewedResubmitted"
        );

        if (reviewedResubmittedTransactions.length > 0) {
          if (reviewedResubmittedTransactions.length === 3) {
            setNeedMoreApprovals(true);
          } else {
            setNeedMoreApprovals(false);
            setSignature(false);
            setCheckedSignature(true);
          }
        }

        if (reviewedResubmittedTransactions.length >= 1) {
          //setSignature(false);
          //setCheckedSignature(true);
        }

        if (reviewedResubmittedTransactions.length === 3) {
          setSignature(true);
          setCheckedSignature(false);
        }
      }
    } catch (err) {
      console.log("ERROR in request Edit function", err);
    }


    const sixthPeriodAssignmentInitiateReport = fetchInitiateReport(requestData.id);

    const {
      particular_emp_reporting_manager: secondApprover,
      budgetClerkId: thirdApprover,
      budgetManagerId: fourthApprover,
      employee_id: teacher,
      payrollId: payroll,
      hrDirectorI: fifthApprover
    } = sixthPeriodAssignmentInitiateReport;

    if (loggedUserId === fifthApprover) {
      setShowNeedMoreApprovals(true);
      setNeedMoreApprovals(true);
      await loadMoreUser([teacher, secondApprover, thirdApprover, fourthApprover, payroll]);
    } else if (![secondApprover, thirdApprover, fourthApprover].includes(loggedUserId)) {
      await loadMoreUser([teacher, secondApprover, thirdApprover, fourthApprover, payroll]);
      setShowNeedMoreApprovals(true);
      setNeedMoreApprovals(true);
    }
    let latestTransactionCycle = await fetchLatestTransactionCycle(requestData.id);
    let latestApproverIndex = approverLevels.indexOf(latestTransactionCycle.approverLevel);
    let pendingApprovers = approverLevels.slice(latestApproverIndex + 1);
    console.log("pendingApprovers", pendingApprovers);
    setPendingApprovers(pendingApprovers);
  };

  function getUserMap(user) {
    const sub = user.Attributes.find(attr => attr.Name === "sub")
    const userNameAttribute = getFullName(user.Attributes);
    const userEmailAttribute = user.Attributes.find(attr => attr.Name === 'email');
    const userCodeAttribute = user.Attributes.find(attr => attr.Name === 'custom:userCode');
    const signatureAttribute = user.Attributes.find(attr => attr.Name === 'custom:userSignature');
    const userRoleAttribute = user.Attributes.find(attr => attr.Name === 'custom:role');
    const userReportingManager = user.Attributes.find(attr => attr.Name === "custom:SPReportingManager")?.Value;

    return ({
      userId: sub?.Value,
      name: userNameAttribute,
      email: userEmailAttribute?.Value,
      userCode: userCodeAttribute?.Value,
      signature: signatureAttribute?.Value,
      role: getUserRoleName(userRoleAttribute?.Value),
      userReportingManager: userReportingManager,
    });
  }

  //* onclick view popup
  const onClickRequestedReportViewPopup = async (requestData, position) => {
    //fetch user data
    const usersMap = users.map(user => {
      return getUserMap(user);
    });
    //---Start Approval Status-----
    //get particular report id data from transaction cycle.
    let approvalFinalData = [];
    let formHistoryFinalData = [];
    try {
      const particularReportTransactionCycleResponse = await fetchReportTransactionCycles(requestData.id)

      if (particularReportTransactionCycleResponse) {
        const approvalFinalDataPromises = particularReportTransactionCycleResponse.map(async transaction => {
          let correspondingUser = usersMap.find(user => user.userId === transaction.to_Employee_Id);
          if (!correspondingUser) {
            correspondingUser = await fetchSpecificUserData(transaction.to_Employee_Id);
          }
          const empName = correspondingUser ? correspondingUser.name : "";
          const empCode = correspondingUser ? correspondingUser.userCode : "";
          const empTitle = approverDesignations[transaction.approver_level]

          const status = transaction.status === "Open" ? "Pending For Approval" : transaction.status;
          const approvedDate = moment(transaction.createdAt).format("MM-DD-YYYY HH:mm");

          if (transaction.status === "Rejected") {
            const remarkObj = {
              empName: empName,
              remarkType: "Rejected",
              empRemark: transaction.remark
            };
            formHistoryFinalData.push(remarkObj);
          }
          return {
            empName: empName,
            empCode: empCode,
            empTitle: empTitle,
            status: status,
            approvedDate: approvedDate,
            empId: transaction.to_Employee_Id,
            approverLevel: transaction.approver_level,
          };
        });

        approvalFinalData = await Promise.all(approvalFinalDataPromises);

      }

    } catch (err) {
      console.log("Error in onClickInitiateRequestViewPopup", err);
    }
    //---End Approval Status-------

    let empData = usersMap.filter(currentItem => currentItem.userId === requestData.employeeCode);
    // mis match issue handle employee
    empData = sixPeriodEmployeeData.filter(currentItem => currentItem.user_Id === requestData.employeeCode);


    let empname = empData[0]?.employee_code ? `${empData[0]?.employee_code} (${empData[0]?.employee_name})` : empData[0]?.name;


    //---------------

    setPosition(position);
    setVisible(true);
    //set Data for View Popup
    let obj = {
      employeeName: empname,//empData[0].name,
      employee_id: empData[0]?.employee_code, //empData[0].userCode,
      assighment_at: requestData.assignmentAt,
      from_date: requestData.fromDate,
      to_date: requestData.toDate,
      subject_area: requestData.subjectData,
      total_staffing_allocation: requestData.totalStaffAllocation,
      account_charged: requestData.accountCharged,
      current_fte_utilized: requestData.currentFTEUtilized,
      initiator_id: requestData.submited_by,

      approvalFinalData: approvalFinalData,
      formHistoryFinalData: formHistoryFinalData
    };
    setSpecificReportDetailsView(obj);

    //get Initiator name
    let initiatorEmp = await fetchSpecificUserData(requestData.submited_by);
    if (initiatorEmp) {
      let obj = {
        empName: initiatorEmp.name,
        empTitle: 'Initiator',
        empCode: initiatorEmp.sub,
        status: 'Submitted',
        approvedDate: requestData.submittedOn
      }

      let newEventArray = approvalFinalData.concat(obj);
      setEvents(newEventArray.reverse());
    }
  };

  // onClick payroll popup :edit
  const onClickPayrollReportEditPopUp = async requestData => {
    //fetch user data
    const usersMap = users.map(getUserMap);
    //if logged user is fifthApprover(HR Director) them show Need More Approval.
    try {
      const particularReportMetaData = await fetchInitiateReport(requestData.id);

      if (particularReportMetaData?.hrDirectorI === loggedUserId) {
        setShowNeedMoreApprovals(true);
      }
    } catch (err) {
      console.log("Error when checking:", err);
    }

    //---Start Approval Status-----
    //get particular report id data from transaction cycle.
    let approvalFinalData = [];
    try {
      const particularReportTransactionCycleResponse = await fetchReportTransactionCycles(requestData.id)

      if (particularReportTransactionCycleResponse) {
        const approvalFinalDataPromises = particularReportTransactionCycleResponse.map(async transactionCycle => {
          let correspondingUser = usersMap.find(user => user.userId === transactionCycle.to_Employee_Id);
          correspondingUser = correspondingUser || await fetchSpecificUserData(transactionCycle.to_Employee_Id);
          const empName = correspondingUser ? correspondingUser.name : "";
          const empCode = correspondingUser ? correspondingUser.userCode : "";
          const empTitle = approverDesignations[transactionCycle.approver_level]
          const status = transactionCycle.status === "Open" ? "Pending For Approval" : transactionCycle.status;
          return {
            empName,
            empCode,
            empTitle,
            status,
            approvedDate: moment(transactionCycle.createdAt).format("MM-DD-YYYY HH:mm"),
            empId: transactionCycle.to_Employee_Id,
            approverLevel: transactionCycle.approver_level,
          };
        });
        approvalFinalData = await Promise.all(approvalFinalDataPromises);
      }
    } catch (err) {
      console.log("Error:", err);
    }

    //---End Approval Status-------

    let empData = usersMap.filter(currentItem => currentItem.userId === requestData.employeeCode);

    empData = sixPeriodEmployeeData.filter(currentItem => currentItem.user_Id === requestData.employeeCode);


    let empname = empData[0]?.employee_code ? `${empData[0]?.employee_code} (${empData[0]?.employee_name})` : empData[0]?.name;


    setVisiblePayrollReportEdit(true);

    //get Initiator name
    let initiatorEmp = await fetchSpecificUserData(requestData.submited_by);
    if (initiatorEmp) {
      let obj = {
        empName: initiatorEmp.name,
        empTitle: 'Initiator',
        empCode: initiatorEmp.sub,
        status: 'Submitted',
        approvedDate: requestData.submittedOn
      }

      let newEventArray = approvalFinalData.concat(obj);
      setEvents(newEventArray.reverse());
    }

    //get selected report id
    //set Data for View Popup
    let obj = {
      id: requestData.id,
      employeeName: empname, //empData[0].name,
      employee_id: empData[0]?.employee_code,//empData[0].userCode,
      assighment_at: requestData.assignmentAt,
      from_date: requestData.fromDate,
      to_date: requestData.toDate,
      subject_area: requestData.subjectData,
      total_staffing_allocation: requestData.totalStaffAllocation,
      account_charged: requestData.accountCharged,
      current_fte_utilized: requestData.currentFTEUtilized,
      initiator_id: requestData.created_by,

      approvalFinalData: approvalFinalData
    };
    setSpecificReportDetailsEdit(obj);

    //check specific report =>transaction cycle length is greter than 3
    try {
      const sixthPeriodReportTransactionCycleResponseLate = await fetchReportTransactionCycles(requestData.id)

      const sixthPeriodReportTransactionCycleResponse = await fetchPaginatedRecords(
        queries.listSixthPeriodReportTransactionCycles,
        { report_Id: { eq: requestData.id } },
        null,
        3000,
        'listSixthPeriodReportTransactionCycles'
      )

      if (sixthPeriodReportTransactionCycleResponse.length >= 3) {
        let countCycle = false;
        for (let i = 0; i < 3; i++) {
          if (sixthPeriodReportTransactionCycleResponseLate[i].status === "ReviewedResubmitted") {
            if (i === 2) {
              setNeedMoreApprovals(true);
              countCycle = true;
            } else {
              setNeedMoreApprovals(false);
              setSignature(false);
              setCheckedSignature(true);
            }
          }
        }

        const reviewList = sixthPeriodReportTransactionCycleResponseLate.filter(
          item => item.status === "ReviewedResubmitted"
        );
        if (reviewList.length >= 1) {
          //setSignature(false)
          //setCheckedSignature(true)
        }

        if (countCycle) {
          setSignature(true);
          setCheckedSignature(false);
        }
      }
    } catch (err) {
      console.log("ERROR in request Edit function");
    }
  };

  const toggleActive = () => {
    setActivate(activate === "actives" ? "" : "actives");
  };

  async function onLoad() {
    try {
      await Auth.currentSession();
      if (!ValidateAllRoleExceptAdmin()) {
        userHasAuthenticated(false);
      }
    } catch (e) {
      userHasAuthenticated(false);
    }
  }

  const convertArrayOfObjectsToCSV = (data) => {
    const csvRows = [];
    const headers = Object.keys(data[0]);

    csvRows.push(headers.join(','));

    for (const row of data) {
      const values = headers.map((header) => row[header]);
      csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
  };

  const downloadCSV = (data, filename) => {
    const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  async function fetchAllDetailsAndSetObjects(target_user_id, approver_id, next_approver_id, initiator_id) {
    const targetPromise = fetchSpecificUserData(target_user_id);
    const approverPromise = fetchSpecificUserData(approver_id);
    let nextApproverPromise = fetchSpecificUserData(next_approver_id);
    const initiatorPromise = fetchSpecificUserData(initiator_id);

    try {
      let [targetData, approverData, nextApproverData, initiatorData] = await Promise.all([
        targetPromise,
        approverPromise,
        nextApproverPromise,
        initiatorPromise
      ]);

      if (!nextApproverPromise) {
        nextApproverData = await fetchSpecificUserData(next_approver_id);
      }

      return {
        targetDetailsObj: targetData,
        approverDetailsObj: approverData,
        nextApproverDetailsObj: nextApproverData,
        initiatorDetailsObj: initiatorData
      };
    } catch (error) {
      console.error('Error fetching and setting user data:', error);
      return null;
    }
  }

  const updateReport = async (reportId, updateData) => {
    const updatedReport = await API.graphql(graphqlOperation(updateSixthPeriodAssignmentInitiateReport, {
      input: {
        id: reportId,
        ...updateData
      }
    }));
    return updateReport?.data?.updateSixthPeriodAssignmentInitiateReport;
  };

  const fetchReportTransactionCycles = async (reportId) => {
    return await fetchPaginatedRecords(
      queries.listSixthPeriodReportTransactionCycles,
      { report_Id: { eq: reportId } },
      { field: "createdAt", direction: "desc" },
      1000,
      'listSixthPeriodReportTransactionCycles'
    )
  };

  const fetchLatestTransactionCycle = async (reportId) => {
    const transactionCycles = await fetchReportTransactionCycles(reportId);
    return transactionCycles[0];
  };

  const buildReportDetails = async (newSixthPeriodReportTransactionCycle, title, status, initiator_id, target_user_id, approver_id, next_approver_id) => {
    try {
      const details = await fetchAllDetailsAndSetObjects(target_user_id, approver_id, next_approver_id, initiator_id);
      let cc_user_details = null;

      if (sendToCc?.trim() !== "") {
        const cc_user_data = await fetchUsersByEmail(cc_user_details);
        cc_user_details = buildUserDataFromCongntioResponse(cc_user_data?.Users);
      }

      if (details !== null) {
        const {
          targetDetailsObj,
          approverDetailsObj,
          nextApproverDetailsObj,
          initiatorDetailsObj
        } = details;

        return {
          id: newSixthPeriodReportTransactionCycle.report_Id,
          initiated_date: moment(newSixthPeriodReportTransactionCycle.date).format('MM-DD-YYYY'),
          previous_status: status,
          title: title,
          new_status: newSixthPeriodReportTransactionCycle.status,
          approverDetails: {
            approver_id: approverDetailsObj?.userId,
            approver_name: approverDetailsObj?.name,
            approver_email: approverDetailsObj?.email,
            approver_user_code: approverDetailsObj?.userCode
          },
          initiatorDetails: {
            initiator_id: initiatorDetailsObj?.userId,
            initiator_name: initiatorDetailsObj?.name,
            initiator_email: initiatorDetailsObj?.email,
            initiator_user_code: initiatorDetailsObj?.userCode
          },
          targetUserDetails: {
            target_user_id: targetDetailsObj?.userId,
            target_user_name: targetDetailsObj?.name,
            target_user_email: targetDetailsObj?.email,
            target_user_code: targetDetailsObj?.userCode
          },
          nextApproverDetails: {
            next_approver_id: nextApproverDetailsObj?.userId,
            next_approver_name: nextApproverDetailsObj?.name,
            next_approver_email: nextApproverDetailsObj?.email,
            next_approver_code: nextApproverDetailsObj?.userCode
          },
          ccUserDetails: cc_user_details?.[0]
        };
      } else {
        console.error('Details fetching failed.');
        return {};
      }
    } catch (error) {
      console.error('Error building report details:', error);
      return {};
    }
  };

  const buildUserDetails = (userDetailsObj) => {
    if (userDetailsObj) {
      return {
        id: userDetailsObj.userId,
        name: userDetailsObj.name,
        email: userDetailsObj.email,
        user_code: userDetailsObj.userCode
      };
    } else {
      return {};
    }
  };

  const isReportValid = () => {

    // if (assignmentTitle === "") {
    // toast.error("Please enter assignment title");
    // return false;
    // } else 

    if (!startDate) {
      toast.error("Please enter From Date");
      return false;
    } else if (!endDate) {
      toast.error("Please enter To Date");
      return false;
    } else if (!selectedEmployee) {
      toast.error("Please select Teacher");
      return false;
    }
    else if (!selectedReportingManagerEmployee) {
      toast.error("Please select Site Admin");
      return false;
    } else if (!selectedHrDirector) {
      toast.error("Please select HR Director");
      return false;
    } else if (!selectedPayroll) {
      toast.error("Please select HR Technician");
      return false;
    }
    return true;
  }
  const updateLastTransactionCycleToOpen = async (reportId) => {
    const transactionCycle = await fetchLatestTransactionCycle(reportId);
    const updatedTransactionCycle = await API.graphql({
      query: mutations.updateSixthPeriodReportTransactionCycle,
      variables: {
        input: {
          id: transactionCycle.id,
          status: "Open",
          _version: transactionCycle._version
        },
      },
    });
    console.log("Updated transaction cycle:", updatedTransactionCycle);
    return updatedTransactionCycle?.data?.updateSixthPeriodReportTransactionCycle;
  }

  const handleAfterSuccessfulSubmit = (loading) => {
    setTimeout(() => {
      toast.update(loading, {
        className: "Success",
        closeOnClick: true,
        render: `Submitted Successfully!`,
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });
    }, 1000);
    setShowNextPopUp(false);
    setShowPreviewPopUp(false);
    setReportSubmitting(false);
  }

  function saveSuccessToast(loading) {
    setTimeout(() => {
      toast.update(loading, {
        className: "Success",
        closeOnClick: true,
        render: `Saved Successfully!`,
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });
    }, 1000);
  }


  const saveBasicEditInfo = async (e, type, currentStatus) => {
    if (!isReportValid() || reportSubmitting) {
      return;
    }
    let loading;
    const original = await fetchInitiateReport(editRequestID);

    try {
      if (type === "save") { // When user clicks on Submit button in Edit popup
        setReportSubmitting(true);
        const isEditable = original?.editable;
        if (!isEditable && sixPeriodIsSuperadmin !== '1') {
          toast.error("The form is being edited by SuperAdmin, please try after some time!");
          return;
        }
        loading = toast.loading("Submitting the report, please wait...");
        let to_id = selectedEmployee?.code
        let lastApproverLevel, latestReportTransactionCycle;
        if (editMode) {
          latestReportTransactionCycle = await fetchLatestTransactionCycle(editRequestID);
          lastApproverLevel = latestReportTransactionCycle?.approver_level || selectedEmployee?.code;
          switch (lastApproverLevel) {
            case "teacher":
              to_id = selectedEmployee?.code;
              break;
            case "site_admin":
              to_id = selectedReportingManagerEmployee.code;
              break;
            case "budget_clerk":
              to_id = selectedBudgetClerk?.code;
              break;
            case "budget_manager":
              to_id = selectedBudgetManager?.code;
              break;
            case "hr_director":
              to_id = selectedHrDirector.code;
              break;
            case "finance_analyst":
              to_id = financeAnalyst?.userId;
              break;
            case "executive_director":
              to_id = executiveDirector?.userId;
              break;
            case "payroll":
              to_id = selectedPayroll.code;
              break;
            default:
              break;
          }
        }
        const updateData = {
          assignment_title: assignmentTitle,
          employee_id: selectedEmployee?.code,
          assighment_at: schoolSelect?.name,
          from_date: startDate ? getGraphqlFormattedDate(moment(startDate)) : null,
          to_date: endDate ? getGraphqlFormattedDate(moment(endDate)) : null,
          subject_area: subjectCode,
          total_staffing_allocation: totalStaffingAllocationectedRole,
          account_charged: accountCharged,
          current_fte_utilized: fteUtilized,
          submited_by: loggedUserId,
          submited_at: getGraphqlFormattedDate(moment()),
          particular_emp_reporting_manager: selectedReportingManagerEmployee.code,
          budgetClerkId: selectedBudgetClerk ? selectedBudgetClerk?.code : '',
          budgetManagerId: selectedBudgetManager ? selectedBudgetManager?.code : '',
          hrDirectorI: selectedHrDirector.code,
          payrollId: selectedPayroll.code,
          _version: original._version,
          editable: true,
        };
        await updateReport(editRequestID, updateData);
        if (currentStatus === "Pending for approval") { //This block is for approver flow
          if (latestReportTransactionCycle.to_Employee_Id !== to_id) { //If user changes the approver, then create a new transaction cycle
            const newSixthPeriodReportTransactionCycle = await API.graphql(
              graphqlOperation(mutations.createSixthPeriodReportTransactionCycle,
                {
                  input: {
                    report_Id: editRequestID,
                    from_Employee_Id: loggedUserId,
                    to_Employee_Id: to_id,
                    status: 'Open',
                    isApproved: false,
                    remark: "",
                    approver_level: lastApproverLevel,
                    date: getGraphqlFormattedDate(moment()),
                  }
                })
            );
            if (newSixthPeriodReportTransactionCycle) {
              const reportDetails = await buildReportDetails(newSixthPeriodReportTransactionCycle?.data?.createSixthPeriodReportTransactionCycle, assignmentTitle, "Open", loggedUserId, selectedEmployee?.code, to_id, to_id);
              await handleNotificationsOnStatusChange(currentStatus, reportDetails, "SIX_PERIOD");
            }
            setVisibleRequestedReportEdit(false);
          }
          await processRequestedReports();
          handleAfterSuccessfulSubmit(loading);
          return;
        }
        if (currentStatus !== 'Submitted') {
          if (currentStatus === 'Pending') { //If user didn't submit at first time, then edits and clicks on Submit
            const updatedTransaction = await updateLastTransactionCycleToOpen(editRequestID)
            if (updatedTransaction) {
              const reportDetails = await buildReportDetails(updatedTransaction, assignmentTitle, "Open", loggedUserId, selectedEmployee?.code, to_id, to_id);
              await handleNotificationsOnStatusChange(currentStatus, reportDetails, "SIX_PERIOD");
            }
          } else {
            const newSixthPeriodReportTransactionCycle = await API.graphql(
              graphqlOperation(mutations.createSixthPeriodReportTransactionCycle,
                {
                  input: {
                    report_Id: editRequestID,
                    from_Employee_Id: loggedUserId,
                    to_Employee_Id: to_id,
                    status: (sixPeriodIsSuperadmin ? currentStatus : (currentStatus === "Rejected" ? "ReviewedResubmitted" : "Open")),
                    isApproved: false,
                    remark: "",
                    approver_level: lastApproverLevel,
                    date: getGraphqlFormattedDate(moment()),
                  }
                })
            );
            if (newSixthPeriodReportTransactionCycle) {
              const reportDetails = await buildReportDetails(newSixthPeriodReportTransactionCycle?.data?.createSixthPeriodReportTransactionCycle, assignmentTitle, "Open", loggedUserId, selectedEmployee?.code, to_id, to_id);
              await handleNotificationsOnStatusChange(currentStatus, reportDetails, "SIX_PERIOD");
            }
          }
        }
        if (sixPeriodIsSuperadmin === '1') {
          await updateEditable(original, true)
        }
        await processInitiatedReports();
        handleAfterSuccessfulSubmit(loading);
      } else { //When user clicks on Save button in Edit popup

        const loading = toast.loading("Saving the report, please wait...");
        const updateData = {
          assignment_title: assignmentTitle,
          employee_id: selectedEmployee?.code,
          assighment_at: schoolSelect?.name,
          from_date: startDate ? getGraphqlFormattedDate(moment(startDate)) : null,
          to_date: endDate ? getGraphqlFormattedDate(moment(endDate)) : null,
          subject_area: subjectCode,
          total_staffing_allocation: totalStaffingAllocationectedRole,
          account_charged: accountCharged,
          current_fte_utilized: fteUtilized,
          particular_emp_reporting_manager: selectedReportingManagerEmployee.code,
          budgetClerkId: selectedBudgetClerk ? selectedBudgetClerk?.code : '',
          budgetManagerId: selectedBudgetManager ? selectedBudgetManager?.code : '',
          hrDirectorI: selectedHrDirector.code,
          payrollId: selectedPayroll.code,
          _version: original._version,
          editable: true,
        };

        await updateReport(editRequestID, updateData);

        await processInitiatedReports();

        if (type !== 'saveas') {
          await onHideEditPopUp()
        }

        saveSuccessToast(loading);
        setShowPreviewPopUp(false);
        //wait for requested reportss
        await processRequestedReports();
      }
    } catch (err) {
      console.log(err);
      setReportSubmitting(false);
      setTimeout(() => {
        toast.update(loading, {
          className: "Danger",
          closeOnClick: true,
          render: `Error saving the report. Please reach out to site admin`,
          type: "error",
          isLoading: false,
          autoClose: 1500,
        });
      }, 1000);
    }
  };

  const saveBasicInfo = async (type) => { //Initiate Report
    if (!isReportValid() || reportSubmitting) {
      return;
    }
    let loading;
    try {
      if (editRequestID && editRequestID.trim() !== '') { //On Submit Click. If user click 'Save First and Then Submit' button
        loading = toast.loading("Submitting the report, please wait...");
        setReportSubmitting(true);
        const original = await fetchInitiateReport(editRequestID);
        if (original) {
          await API.graphql(
            graphqlOperation(mutations.updateSixthPeriodAssignmentInitiateReport, {
              input: {
                id: original.id,
                assignment_title: assignmentTitle,
                employee_id: selectedEmployee.code,
                assighment_at: schoolSelect.name,
                from_date: getGraphqlFormattedDate(moment(startDate)),
                to_date: getGraphqlFormattedDate(moment(endDate)),
                subject_area: subjectCode,
                total_staffing_allocation: totalStaffingAllocationectedRole,
                account_charged: accountCharged,
                current_fte_utilized: fteUtilized,
                particular_emp_reporting_manager: selectedReportingManagerEmployee?.code,
                budgetClerkId: selectedBudgetClerk?.code,
                budgetManagerId: selectedBudgetManager?.code,
                hrDirectorI: selectedHrDirector.code,
                payrollId: selectedPayroll.code,
                submited_by: (type === "save" ? null : loggedUserId),
                submited_at: (type === "save" ? null : getGraphqlFormattedDate(moment())),
                _version: original._version,
                editable: true,
              }
            })
          );
        }
        await updateLastTransactionCycleToOpen(editRequestID); //set the status to 'Open' in transaction cycle
        setTimeout(() => {
          toast.update(loading, {
            className: "Success",
            closeOnClick: true,
            render: `Submitted Successfully!`,
            type: "success",
            isLoading: false,
            autoClose: 1500,
          });
        }, 1000);
        await processInitiatedReports();
        await onHideEditPopUp();
        setShowPreviewPopUp(false);
        setReportSubmitting(false);
        const reportDetails = await buildReportDetails(original, assignmentTitle, "Open", loggedUserId, selectedEmployee.code, selectedEmployee.code, selectedEmployee.code);
        handleNotificationsOnStatusChange("Open", reportDetails, "SIX_PERIOD");
        //wait for request reports
        await processRequestedReports();
        return;
      }
      let variables = {
        assignment_title: assignmentTitle,
        employee_id: selectedEmployee.code,
        assighment_at: schoolSelect.name,
        from_date: getGraphqlFormattedDate(moment(startDate)),
        to_date: getGraphqlFormattedDate(moment(endDate)),
        subject_area: subjectCode,
        total_staffing_allocation: totalStaffingAllocationectedRole,
        account_charged: accountCharged,
        current_fte_utilized: fteUtilized,
        submited_by: (type === "save" ? null : loggedUserId),
        created_by: loggedUserId,
        submited_at: (type === "save" ? null : getGraphqlFormattedDate(moment())),
        particular_emp_reporting_manager: selectedReportingManagerEmployee.code,
        budgetClerkId: selectedBudgetClerk?.code,
        budgetManagerId: selectedBudgetManager?.code,
        hrDirectorI: selectedHrDirector.code,
        payrollId: selectedPayroll.code,
        editable: true
      }
      const response = await API.graphql(
        graphqlOperation(mutations.createSixthPeriodAssignmentInitiateReport, {
          input: variables
        }));

      const newSixthPeriodAssignmentInitiateReport = response.data.createSixthPeriodAssignmentInitiateReport;

      if (newSixthPeriodAssignmentInitiateReport) {
        const createdReportId = newSixthPeriodAssignmentInitiateReport.id;
        if (type === "save") { // If user clicks on Save button
          loading = toast.loading("Saving the report, please wait...");
          setEditRequestID(createdReportId);
          const createResponse = await API.graphql(graphqlOperation(
            mutations.createSixthPeriodReportTransactionCycle, {
            input: {
              report_Id: createdReportId,
              from_Employee_Id: loggedUserId,
              to_Employee_Id: selectedEmployee.code,
              status: "Pending",
              isApproved: false,
              remark: "",
              approver_level: approverLevels[0],
              date: getGraphqlFormattedDate(moment()),
            }
          }
          ));
          if (createResponse) {
            saveSuccessToast(loading);
          }
        } else { // If user clicks on Submit button
          setReportSubmitting(true);
          loading = toast.loading("Saving the report, please wait...");
          const newSixthPeriodReportTransactionCycle = await API.graphql(
            graphqlOperation(mutations.createSixthPeriodReportTransactionCycle, {
              input: {
                report_Id: createdReportId,
                from_Employee_Id: loggedUserId,
                to_Employee_Id: selectedEmployee.code,
                status: "Open",
                isApproved: false,
                remark: "",
                approver_level: approverLevels[0],
                date: getGraphqlFormattedDate(moment()),
              }
            })
          );

          if (newSixthPeriodReportTransactionCycle) {
            const reportDetails = await buildReportDetails(newSixthPeriodReportTransactionCycle?.data?.createSixthPeriodReportTransactionCycle, assignmentTitle, "Open", loggedUserId, selectedEmployee.code, selectedEmployee.code, selectedEmployee.code);
            await handleNotificationsOnStatusChange("Open", reportDetails, "SIX_PERIOD");
          }
          handleAfterSuccessfulSubmit(loading);
        }
      }
      await processInitiatedReports();
      setShowPreviewPopUp(false);
      //wait fro requested reports
      await processRequestedReports();
    } catch (err) {
      setReportSubmitting(false);
      setTimeout(() => {
        toast.update(loading, {
          className: "Danger",
          closeOnClick: true,
          render: `Error saving the report. Please reach out to site admin`,
          type: "error",
          isLoading: false,
          autoClose: 1500,
        });
      }, 1000);
    }
  };

  // Call the function to find the email
  function findEmail(attributes) {
    const emailAttribute = attributes.find(attribute => attribute.Name === "email");
    return emailAttribute ? emailAttribute.Value : null;
  }

  const fetchCognitoUsersByParams = async (params) => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    params['UserPoolId'] = awsmobile.aws_user_pools_id;

    if (!params.hasOwnProperty('Limit')) {
      params['Limit'] = 60;
    }

    try {
      return (await cognito.listUsers(params).promise());
    } catch (e) {
      console.info("Error while fetching users from cognito");
      return [];
    }
  }

  const buildUserDataFromCongntioResponse = (users) => {
    return users.map(getUserMap);
  }

  const fetchUsersByEmail = async (email) => {
    const params = {
      Limit: 1,
      Filter: `email="${email}"`
    };
    return await fetchCognitoUsersByParams(params);
  };

  const fetchSpecificUserData = async (userId) => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 1
    };

    params['Filter'] = "sub ^=\"" + userId + "\""

    try {
      const data = await cognito.listUsers(params).promise();
      if (data.Users.length > 0) {
        const user = data.Users[0];
        return getUserMap(user);
      }
    } catch (error) {
      toast.error(error.message);
      return null;
    }
    return null;
  }

  const loadUsers = async () => {
    //------------------------------- load users-------------
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };

    cognito.listUsers(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        setUsersList(data.Users);

        const usersMap = data.Users.map(user => getUserMap(user));

        //get only those users are without admin
        let usersWithoutAdminAndLoggedUser = [];
        const loggedUserId = reactLocalStorage.get("loggedUserId");

        usersMap.map(currentItem => {
          if (currentItem.role !== "Admin" && currentItem.userId !== loggedUserId) {
            usersWithoutAdminAndLoggedUser.push(currentItem);
          }
        });

        fetchSpecificUserData(loggedInUserData).then((data) => {
          setLoggedInUserData(data);
        });
        setEmployeeDetailsList(usersMap);

        //set employee list
        let finalEmployeeList = [{ name: "No Approval Needed", code: "no_approval_needed" }];

        usersWithoutAdminAndLoggedUser.map(currentItem => {
          let obj = { name: currentItem.name, code: currentItem.userId };
          finalEmployeeList.push(obj);
        });

        setEmployeeList(finalEmployeeList);
      }
    });
    //-------------------------------------------------------
  };

  const getFullName = (attributes) => {
    if (attributes) {
      const { fullName } = getFirstAndLastName(attributes);
      // return firstName + (lastName ? ' ' : '') + (lastName || '');
      return fullName;
    }
  }

  const getFirstAndLastName = (attributes) => {
    if (attributes) {
      // const fnameAttribute = attributes.find(attr => attr.Name === 'custom:firstName');
      // const lnameAttribute = attributes.find(attr => attr.Name === 'custom:lastName');
      const fnameAttribute = attributes.find(attr => attr.Name === 'name');
      const fullName = fnameAttribute ? fnameAttribute.Value : '';

      // const firstName = fnameAttribute ? fnameAttribute.Value : '';
      // const lastName = lnameAttribute ? lnameAttribute.Value : '';
      // return { firstName, lastName };
      return { fullName };

    }
  }

  const getAssigneeName = (data) => {
    try {
      const assigneeId = data[0]?.to_Employee_Id;
      const x = users.find(u => u.Username === assigneeId);

      if (x) {
        return getFullName(x.Attributes);
      } else {
        return '-';
      }
    } catch (e) {
      console.error(e);
      return '-';
    }
  }

  function getPretextAndStatus(pstatus, status, designation) {
    let pretexts;
    if (status === 'Acknowledge') {
      pstatus = 'Acknowledge';
      pretexts = "Acknowledged by HR Technician";
    } else if (status === 'Pending' || status === 'Rejected') {
      pretexts = status;
    } else if (designation === approverDesignations.payroll) {
      pstatus = 'Acknowledge';
      pretexts = "Pending for Acknowledgement";
    } else if (designation) {
      pretexts = "Pending for Approval " + designation;
    } else {
      pretexts = "Pending for Approval";
    }

    return { pstatus, pretexts };
  }

  async function fetchSixPeriodInitiatorReportResponse(isSuperadmin, userId) {
    // const filter = {
    //   _deleted: { eq: false }
    // };
    let filter = {};
    if (isSuperadmin == '0') { //deliberately using == instead of === to avoid type check
      //filter.created_by = { eq: userId };
    }
    return await fetchPaginatedRecords(
      queries.listSixthPeriodAssignmentInitiateReports,
      filter,
      { field: "updatedAt", direction: "desc" },
      1000,
      'listSixthPeriodAssignmentInitiateReports'
    )

  }

  const getAttributes = (username, attributeKey) => {
    const user = users.find(u => u.Username === username);
    const attribute = user?.Attributes.find(u => u?.Name === attributeKey);
    return attribute?.Value || "";
  };
  const processPayrollReports = async (report_Id) => {
    const loggedUserId = reactLocalStorage.get("loggedUserId");
    let payRollFilter = sixPeriodIsSuperadmin ? null : { to_Employee_Id: { eq: loggedUserId } };

    let reportTransactionCycles = await fetchReportTransactionCycles(report_Id);

    console.log("reportTransactionCycles Payroll", reportTransactionCycles);

    const sixthPeriodReportTransactionCycleResponseForPayroll = await fetchPaginatedRecords(
      queries.listSixthPeriodReportTransactionCycles,
      payRollFilter,
      { field: "updatedAt", direction: "desc" },
      1000,
      'listSixthPeriodReportTransactionCycles'
    )
    if (sixthPeriodReportTransactionCycleResponseForPayroll) {
      let payrollFinalData = [];

      for (let i = 0; i < sixthPeriodReportTransactionCycleResponseForPayroll.length; i++) {
        let currentItem = sixthPeriodReportTransactionCycleResponseForPayroll[i];
        const sixthPeriodReport = await fetchInitiateReport(currentItem.report_Id);
        if (sixthPeriodReport && sixthPeriodReport.isSoftDelete !== true) {
          let fromDate = moment(sixthPeriodReport.from_date, "YYYY-MM-DD").format("MM/DD/YYYY");
          let toDate = moment(sixthPeriodReport.to_date, "YYYY-MM-DD").format("MM/DD/YYYY");
          const period = `${fromDate} to ${toDate}`;
          let status = currentItem.status === "Closed" ? "Acknowledged" : "Pending for Acknowledgement";
          let remark = "-";
          let teacherName = "";
          let initiator = "";
          try {
            teacherName = `${getAttributes(sixthPeriodReport.employee_id, 'custom:firstName')} ${getAttributes(sixthPeriodReport.employee_id, 'custom:lastName')}`;
            initiator = `${getAttributes(sixthPeriodReport.created_by, 'custom:firstName')} ${getAttributes(sixthPeriodReport.created_by, 'custom:lastName')}`;
          } catch (e) {
            console.info(e);
          }

          let adminUsers;
          let Assignee = "";
          if (reportTransactionCycles.length) {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            try {
              adminUsers = await cognito.adminGetUser({
                UserPoolId: awsmobile.aws_user_pools_id,
                Username: reportTransactionCycles[0].status === "Rejected" ? sixthPeriodReport.submited_by : reportTransactionCycles[0].to_Employee_Id,
              }).promise();
            } catch (e) {
              //console.log(e)
            }

            let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
            let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
            Assignee = userFirstName + " " + userLastName

          }

          let NewAssignee = status === "Acknowledged" || status === "Pending" ? "-" : Assignee;

          let obj = {
            id: sixthPeriodReport.id,
            assignmentTitle: sixthPeriodReport.assignment_title,
            period: period,
            submittedOn: sixthPeriodReport.submited_at ? moment(sixthPeriodReport.submited_at, "YYYY-MM-DD").format("MM/DD/YYYY") : '-',
            status: status,
            remark: remark,
            teacherName: teacherName,
            assigneeName: getAssigneeName(currentItem),
            initiator: initiator,
            employeeName: "Empoyee NAme",
            employeeCode: sixthPeriodReport.employee_id,
            assignmentAt: sixthPeriodReport.assighment_at,
            toDate: sixthPeriodReport.to_date,
            fromDate: sixthPeriodReport.from_date,
            subjectData: sixthPeriodReport.subject_area,
            totalStaffAllocation: sixthPeriodReport.total_staffing_allocation,
            accountCharged: sixthPeriodReport.account_charged,
            currentFTEUtilized: sixthPeriodReport.current_fte_utilized,
            particular_emp_reporting_manager: sixthPeriodReport.particular_emp_reporting_manager,
            budgetClerkId: sixthPeriodReport.budgetClerkId,
            budgetManagerId: sixthPeriodReport.budgetManagerId,
            submited_by: sixthPeriodReport.submited_by,
            Assignee: NewAssignee,
          };
          payrollFinalData.push(obj);
        }
      }

      setPayrollRequest(payrollFinalData);
      setPayrollReportsLoading(false); //required for loader in payroll reports tab
    }
  }
  const processRequestedReports = async () => {
    const loggedUserId = reactLocalStorage.get("loggedUserId");
    let requestedTransactionCycles = await fetchPaginatedRecords(
      queries.listSixthPeriodReportTransactionCycles,
      { to_Employee_Id: { eq: loggedUserId } },
      { field: "updatedAt", direction: "desc" },
      1000,
      'listSixthPeriodReportTransactionCycles'
    )

    let groupedTransactionCycles = groupBy(requestedTransactionCycles, "report_Id");
    if (groupedTransactionCycles) {
      let pendingCount = 0;
      let approvedCount = 0;
      let rejectCount = 0;
      let approvalFinalData = [];
      let i = 0;
      for (let report_Id in groupedTransactionCycles) {
        const latestTargetedTransaction = groupedTransactionCycles[report_Id][0];

        //get Report data using report id
        const sixthPeriodReport = await fetchInitiateReport(report_Id);

        //check if report exists
        if (sixthPeriodReport && sixthPeriodReport.submited_by && sixthPeriodReport.isSoftDelete !== true) {
          let reportTransactionCycles = await fetchReportTransactionCycles(report_Id);
          let latestTransaction = reportTransactionCycles[0];
          const secondLastTransaction = reportTransactionCycles[1];

          let fromDate = moment(sixthPeriodReport.from_date, "YYYY-MM-DD").format("MM/DD/YYYY");
          let toDate = moment(sixthPeriodReport.to_date, "YYYY-MM-DD").format("MM/DD/YYYY");

          const period = `${fromDate} to ${toDate}`;
          let status = latestTargetedTransaction.isApproved ? "Approved" : latestTargetedTransaction.remark ? "Rejected" : "Pending for Approval";
          let remark = latestTargetedTransaction.remark ? latestTargetedTransaction.remark : "-";

          if (latestTransaction) {
            // if(latestTransaction.approver_level === "initiator"){ //if report was sent back to initiator after rejection
            //   latestTransaction = secondLastTransaction; // we need to track the second last transaction
            // }
            status = latestTransaction.remark && latestTransaction.status === 'Rejected' ? 'Rejected' : status
            remark = latestTransaction.remark && latestTransaction.status === 'Rejected' ? latestTransaction.remark : remark
            if (latestTransaction.status === 'Closed') {
              status = 'Acknowledge';
            }
          }

          //line set designation  for each Report code start here
          let secondApprover = sixthPeriodReport.particular_emp_reporting_manager;
          let thirdApprover = sixthPeriodReport.budgetClerkId;
          let fourthApprover = sixthPeriodReport.budgetManagerId;

          let teacher = sixthPeriodReport.employee_id;
          let payroll = sixthPeriodReport.payrollId;

          let fifthApprover = sixthPeriodReport.hrDirectorI;

          let approverLevel = reportTransactionCycles.length ? reportTransactionCycles[0].approver_level : 0;
          let financial = 0;
          let executive = 0;

          if (reportTransactionCycles.length > 2) {
            //check if second last is fifthaprrover HR
            if (reportTransactionCycles[1].to_Employee_Id === fifthApprover) {
              financial = reportTransactionCycles[0].to_Employee_Id;
              //check if third last is fifthaprrover HR
            } else if (reportTransactionCycles[2].to_Employee_Id === fifthApprover) {
              executive = reportTransactionCycles[0].to_Employee_Id;
            }
          }
          let designation = approverDesignations[approverLevel];
          let { pretexts } = getPretextAndStatus(status, status, designation);

          let teacherName = "";
          try {
            let x = users.filter(u => u.Username === sixthPeriodReport.employee_id);
            if (x[0]?.Attributes) teacherName = getFullName(x[0]?.Attributes);
          } catch (e) {
            console.info(e)
          }

          let initiator = "";
          try {
            let x = users.filter(u => u.Username === sixthPeriodReport.created_by);
            if (x[0]?.Attributes) initiator = getFullName(x[0]?.Attributes);
          } catch (e) {
            console.info(e)
          }

          let adminUsers;
          let Assignee = "";
          if (reportTransactionCycles.length) {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            try {
              adminUsers = await cognito.adminGetUser({
                UserPoolId: awsmobile.aws_user_pools_id,
                Username: reportTransactionCycles[0].status === "Rejected" ? sixthPeriodReport.submited_by : reportTransactionCycles[0].to_Employee_Id,
              }).promise();
            } catch (e) {
              //console.log(e)
            }

            let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
            let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
            Assignee = userFirstName + " " + userLastName

          }

          let NewAssignee = status === "Acknowledged" || status === "Pending" ? "-" : Assignee;


          let obj = {
            id: sixthPeriodReport.id,
            srNo: i + 1,
            assignmentTitle: sixthPeriodReport.assignment_title,
            period: period,
            submittedOn: sixthPeriodReport.submited_at ? moment(sixthPeriodReport.submited_at, "YYYY-MM-DD").format("MM/DD/YYYY") : '',
            status: status,
            remark: remark,
            pretexts: pretexts,
            designation: designation,
            teacherName: teacherName,
            assigneeName: getAssigneeName(reportTransactionCycles),
            initiator: initiator,
            employeeCode: sixthPeriodReport.employee_id,
            assignmentAt: sixthPeriodReport.assighment_at,
            toDate: sixthPeriodReport.to_date,
            fromDate: sixthPeriodReport.from_date,
            subjectData: sixthPeriodReport.subject_area,
            totalStaffAllocation: sixthPeriodReport.total_staffing_allocation,
            accountCharged: sixthPeriodReport.account_charged,
            currentFTEUtilized: sixthPeriodReport.current_fte_utilized,
            particular_emp_reporting_manager: sixthPeriodReport.particular_emp_reporting_manager,
            budgetClerkId: sixthPeriodReport.budgetClerkId,
            budgetManagerId: sixthPeriodReport.budgetManagerId,
            updatedAt: sixthPeriodReport.updatedAt,
            hrDirectorId: sixthPeriodReport.hrDirectorI,
            submited_by: sixthPeriodReport.submited_by,
            payrollId: sixthPeriodReport.payrollId,
            Assignee: NewAssignee,
          };

          if (status === "Pending For Approval") {
            pendingCount++;
          } else if (status === "Approved") {
            approvedCount++;
          } else if (status === "Rejected") {
            rejectCount++;
          }

          approvalFinalData.push(obj);
          i = i + 1;
        } //condion ends for check report exists
      }

      //approvalFinalData.reverse();
      const approveCount = approvalFinalData.filter(obj => obj.status === "Approved");
      setApprovedCountForReqReports(approveCount.length);

      const rejectedCount = approvalFinalData.filter(obj => obj.status === "Rejected");
      setRejectCountForReqReports(rejectedCount.length);

      const pendingForApproverCount = approvalFinalData.filter(obj => obj.status === "Pending for Approval");
      setPendingForApprovalCountForReqReports(pendingForApproverCount.length);
      setApprovalReportRequest(approvalFinalData.sort((a, b) => b.updatedAt - a.updatedAt));
      setRequestedReportsLoading(false); //required for loader in requested reports tab
    }
    return groupedTransactionCycles;
  }

function getArchiveDesignation (currentItem) {
		let archiveDesignation = SIXTH_ARCHIVE_DESIG.Initiator;
		if (currentItem?.employee_id === loggedUserId) {
			archiveDesignation= SIXTH_ARCHIVE_DESIG.teacher
		}
		else if (currentItem?.particular_emp_reporting_manager === loggedUserId) {
			archiveDesignation= SIXTH_ARCHIVE_DESIG.site_admin
		} else if (currentItem?.budgetClerkId === loggedUserId) {
			archiveDesignation= SIXTH_ARCHIVE_DESIG.budgetApprover
		} else if (currentItem?.budgetManagerId === loggedUserId) {
			archiveDesignation= SIXTH_ARCHIVE_DESIG.budgetManagerApprover
		}else if (currentItem?.hrDirectorI === loggedUserId) {
			archiveDesignation= SIXTH_ARCHIVE_DESIG.hrDirector
		}else if (financeAnalyst?.userId === loggedUserId) {
			archiveDesignation= SIXTH_ARCHIVE_DESIG.financeAnalyst
		}else if (executiveDirector?.userId === loggedUserId) {
			archiveDesignation= SIXTH_ARCHIVE_DESIG.executiveDirector
		}else if (currentItem?.payrollId === loggedUserId) {
			archiveDesignation= SIXTH_ARCHIVE_DESIG.payrollHr
		}
		return archiveDesignation;
		
	}
	
  // This was BindList function. Separated it in three functions to fetch initiator, payroll and requested reports separately
  const processInitiatedReports = async () => {
    const loggedUserId = reactLocalStorage.get("loggedUserId");
    try {
      let sixPeriodInitiatorReportResponse = await fetchSixPeriodInitiatorReportResponse(
        sixPeriodIsSuperadmin,
        loggedUserId
      );
      if (sixPeriodInitiatorReportResponse) {
        let finalInitiateRequestData = [];
        let finalPushInitiator = [];
        let submitCount = 0;
        let approvedCount = 0;
        let rejectCount = 0;
        
        sixPeriodInitiatorReportResponse = sixPeriodInitiatorReportResponse.filter(item => item.isSoftDelete !== true);
        //sixPeriodInitiatorReportResponse = sixPeriodInitiatorReportResponse.filter(report => report.isArchived === true);
        sixPeriodInitiatorReportResponse = sixPeriodInitiatorReportResponse.sort((a, b) => b.updatedAt - a.updatedAt);
        let lent = sixPeriodInitiatorReportResponse.length;

        setTotalRecords(sixPeriodInitiatorReportResponse.length)

        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
		var index=0;
        try {
		outerLoop:
          for (let i = 0; i < sixPeriodInitiatorReportResponse.length; i++) {
            const currentReport = sixPeriodInitiatorReportResponse[i];
            let fromDate = moment(currentReport.from_date, "YYYY-MM-DD").format("MM/DD/YYYY");
            let toDate = moment(currentReport.to_date, "YYYY-MM-DD").format("MM/DD/YYYY");

            const period = `${fromDate} to ${toDate}`;
            let status = currentReport.submited_by ? "Submitted" : "Pending";
            let remark = "-";

            //get specific currentReport.id transaction cycle report data
            const reportTransactionCycles = await fetchReportTransactionCycles(currentReport.id);
            for (const transaction of reportTransactionCycles) {
              if (transaction.status === "ReviewedResubmitted") {
                status = "Reviewed & resubmitted";
              }

              if (transaction.status === "Closed") {
                status = "Acknowledge";
                break;
              }
            }
            let lastTransactionCycle = reportTransactionCycles[0] || {};

            let lastApproverLevel = lastTransactionCycle.approver_level || 'teacher';
            let designation = "";
            let pstatus = status;
            if (lastApproverLevel) {
              designation = approverDesignations[lastApproverLevel];
              pstatus = lastApproverLevel === "teacher" ? pstatus : "Approved";
            }
            if (lastTransactionCycle.status === "Rejected") { //If the report was rejected and sent back to Initiator
              status = "Rejected";
              pstatus = "Rejected";
            }
            const pretextAndStatus = getPretextAndStatus(pstatus, status, designation);
            pstatus = pretextAndStatus.pstatus;
            let pretexts = pretextAndStatus.pretexts;
            let teacherName = "";
            try {
              let x = users.filter(u => u.Username === currentReport.employee_id);
              if (x[0]?.Attributes) teacherName = getFullName(x[0]?.Attributes);
            } catch (e) {
              console.info(e)
            }

            let initiator = "";
            try {
              let x = users.filter(u => u.Username === currentReport.created_by);
              if (x[0]?.Attributes) initiator = getFullName(x[0]?.Attributes);
            } catch (e) {
              console.info(e)
            }

            //  Assignee column code

            let adminUsers;
            let Assignee = "";
            if (reportTransactionCycles.length) {
              const cognito = new AWS.CognitoIdentityServiceProvider();

              try {
                adminUsers = await cognito.adminGetUser({
                  UserPoolId: awsmobile.aws_user_pools_id,
                  Username: reportTransactionCycles[0]?.status === "Rejected" ? currentReport.created_by : reportTransactionCycles[0]?.to_Employee_Id,
                  // (reportTransactionCycles[reportTransactionCycles.length - 1].status == 'REJECTED' ? loggedUserId : reportTransactionCycles[reportTransactionCycles.length - 1].to_Employee_Id)
                }).promise();
              } catch (e) {
                //console.log(e)
              }

              let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
              let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
              Assignee = userFirstName + " " + userLastName

            }

            let NewAssignee = reportTransactionCycles[0]?.status === "Closed" || reportTransactionCycles[0]?.status === "Pending" ? "-" : Assignee;


            // Assignee column code End
			//console.log("currentReport", currentReport)

			let archiveDesignation = getArchiveDesignation(currentReport)
			if (currentReport?.isArchivedUsers) {
                    const archieveData=JSON.parse(currentReport?.isArchivedUsers);
					console.log("currentItem isArchive",archieveData)
				 //console.log("currentItem isArchive2",currentReport) 
                    let isArchive = CheckArchive(archieveData, archiveDesignation, loggedUserId);
					//console.log("currentItem archiveDesignation",archiveDesignation) 
					//console.log("currentItem loggedUserId",loggedUserId) 
					//console.log("currentItem isArchive4",isArchive) 
					if(!isArchive){
							continue outerLoop;
						}
						
					}else{
						continue outerLoop;
					}
					
			index = index+1
            // if()
            //code designation complete here
            let obj = {
              id: currentReport.id,
              srNo: index,
              assignmentTitle: currentReport.assignment_title,
              period: period,
			  archiveDesignation:archiveDesignation,
              submittedOn: currentReport.submited_at ? moment(currentReport.submited_at, "YYYY-MM-DD").format("MM/DD/YYYY") : '-',
              status: status,
              remark: remark,
              pstatus: pstatus,
              pretexts: pretexts,

              designation: designation,
              //data for pdf
              teacherName: teacherName,
              assigneeName: getAssigneeName(lastTransactionCycle),
              initiator: initiator,
              employeeName: "Empoyee NAme",
              employeeCode: currentReport.employee_id,
              assignmentAt: currentReport.assighment_at,
              toDate: currentReport.to_date,
              fromDate: currentReport.from_date,
              subjectData: currentReport.subject_area,
              totalStaffAllocation: currentReport.total_staffing_allocation,
              accountCharged: currentReport.account_charged,
              currentFTEUtilized: currentReport.current_fte_utilized,
              particular_emp_reporting_manager: currentReport.particular_emp_reporting_manager,
              budgetClerkId: currentReport.budgetClerkId,
              budgetManagerId: currentReport.budgetManagerId,
              hrDirectorId: currentReport.hrDirectorI,
              HandbookAssignee: currentReport.HandbookAssignee,
              submited_by: currentReport.submited_by,
              payrollId: currentReport.payrollId,
              updatedAt: currentReport.updatedAt,
              approverLevel: lastTransactionCycle.approver_level,
              Assignee: NewAssignee,
              assigneeId: reportTransactionCycles[0].to_Employee_Id,
            };

            //specific report category get approved,submitted and rejected count

            if (status === "Submitted") {
              submitCount++;
            } else if (status === "Approved") {
              approvedCount++;
            } else if (status === "Rejected") {
              rejectCount++;
            }


            finalInitiateRequestData.push(obj);
			
			//console.log("finalInitiateRequestData", finalInitiateRequestData)
			
          }

        } catch (e) { console.log("error", e) }

        setInitiatorReportList(finalInitiateRequestData);
        setInitiatorReportsLoading(false); //required for loader in initiator reports tab
        finalPushInitiator.reverse();
        setInitiatorCSVData(finalPushInitiator);

        setSubmitCount(submitCount);
        setApprovedCount(approvedCount);
        setRejectCount(rejectCount);
      }
    } catch (err) {
      console.error("Error in processInitiatedReports Function." + err);
    }

    let subjectCodeResponses = await fetchPaginatedRecords(
      queries.listSubjects,
      null,
      { field: "name", direction: "asc" },
      1000,
      'listSubjects',
    )


    //setSubjectCode(subjectCodeResponses);
    var myArray = [];
    myArray = ConvertResponseForSelectWithRefCodedropdown(subjectCodeResponses);
    setSubjectListDropdown(myArray);

    let schoolResponses = await fetchPaginatedRecords(
      queries.listSchools,
      null,
      { field: "name", direction: "asc" },
      1000,
      'listSchools',
    )


    var schoolArray = [];
    schoolArray = ConvertResponseForSelect(schoolResponses);
    setSchoolList(schoolArray);
  };
  //filter data
  const dt = useRef(null);

  const dtApp = useRef(null);

  const exportFilteredDataToCSV = async (fileName) => {
    const cognito = new AWS.CognitoIdentityServiceProvider();
    for (let i = 0; i < initiatorReportList.length; i++) {


      let teacher;
      let bugetClerk;
      if (initiatorReportList[i].budgetClerkId) {
        try {
          bugetClerk = await cognito
            .adminGetUser({
              UserPoolId: awsmobile.aws_user_pools_id,
              Username: initiatorReportList[i].budgetClerkId
            })
            .promise();
        } catch (e) {
          //console.log(e)
        }
      }
      let bugetClerkName = bugetClerk ? getFullName(bugetClerk.UserAttributes) : "";


      let bugetClerkMang;
      if (initiatorReportList[i].budgetManagerId) {
        try {
          bugetClerkMang = await cognito
            .adminGetUser({
              UserPoolId: awsmobile.aws_user_pools_id,
              Username: initiatorReportList[i].budgetManagerId
            })
            .promise();
        } catch (e) {
          //console.log(e)
        }
      }
      let bugetClerkMangName = bugetClerkMang ? getFullName(bugetClerkMang.UserAttributes) : "";

      let hrDir;
      if (initiatorReportList[i].hrDirectorId) {
        try {
          hrDir = await cognito
            .adminGetUser({
              UserPoolId: awsmobile.aws_user_pools_id,
              Username: initiatorReportList[i].hrDirectorId
            })
            .promise();
        } catch (e) {
          //console.log(e)
        }
      }
      let hrDirName = hrDir ? getFullName(hrDir.UserAttributes) : "";

      let payroll;
      if (initiatorReportList[i].payrollId) {
        try {
          hrDir = await cognito
            .adminGetUser({
              UserPoolId: awsmobile.aws_user_pools_id,
              Username: initiatorReportList[i].payrollId
            })
            .promise();
        } catch (e) {
          //console.log(e)
        }
      }
      let payrollName = payroll ? getFullName(payroll.UserAttributes) : "";



      teacher = initiatorReportList[i].teacherName

      initiatorReportList[i] = {
        ...initiatorReportList[i],
        //teacher:employeeName? employeeName.Value : '',
        //manager:managerName? managerName.Value:'',
        teacherNm: teacher,
        budgetclerk: bugetClerkName ? bugetClerkName.Value : '',
        budgetManager: bugetClerkMangName ? bugetClerkMangName.Value : '',
        hrdirector: hrDirName ? hrDirName.Value : '',
        payrollName: payrollName ? payrollName.Value : '',
      }
    }
    const dataToExport = initiatorReportList.map(({ srNo, assignmentTitle, period, submittedOn, status, remark, pretexts, assigneeName, initiator, employeeCode, assignmentAt, fromDate, toDate, subjectData, totalStaffAllocation, accountCharged, currentFTEUtilized, teacherNm, manager, budgetclerk, budgetManager, hrdirector, payroll }) => ({
      "Sl No": srNo, "Assignment Title": assignmentTitle, "Period": period, "Submitted On": submittedOn, "Status": status, "Remark": remark, "Display Status": pretexts, "Assignee Name": assigneeName, "Initiator": initiator, "Employee Code": employeeCode, "School": assignmentAt, "From Date": fromDate, "To Date": toDate, "Subject Area": subjectData, "Total Staff Allocation": totalStaffAllocation, "Account Charged": accountCharged, "Current FTE Utilized": currentFTEUtilized,
      "Teacher": teacherNm, "Site Admin/ Dept Head": manager, "Budget Clerk ": budgetclerk, "Budget Manager": budgetManager, "HR Director": hrdirector, "HR Technician": hrdirector
    }));

    const csvData = convertArrayOfObjectsToCSV(dataToExport);
    downloadCSV(csvData, fileName);


  };

  const exportFilteredDataToCSVApprover = (fileName) => {
    dtApp.current.exportCSV();
  };

  //initiate new report
  const initiateNewReport = async () => {
    //set edit data empty
    setEditMode(false);
    setEditRequestID("");
    setCurrentStatus("");
    setHRPayroll();
    //empty form
    setAssignmentTitle("");
    setSelectedEmployee("");
    setSelectedReportingManagerEmployee("");
    setSelectedSchool("");
    setStartDate("");
    setEndDate("");
    setSubjectCode("");
    setTotalStaffingAllocation("");
    setAccountCharged("");
    setFteUtilized("");

    setSelectedBudgetClerk("");
    setSelectedBudgetManager("");
    setSelectedHrDirector("");
    setSelectedPayroll("");

    const usersMap = users.map(user => getUserMap(user));

    // Get only those users without the "Admin" role and the logged-in user
    const loggedUserId = reactLocalStorage.get("loggedUserId");
    const usersWithoutAdmin = usersMap.filter(currentItem =>
      currentItem.role !== "Admin" && currentItem.userId !== loggedUserId
    );

    //set employee list
    // const finalEmpList = usersWithoutAdmin.map(({ name, userId, userCode }) => ({
    // name: `${name || ''} (${userCode})`,
    // code: userId,
    // label: name,
    // userCode: userCode
    // }));

    let finalEmpList = [];
    var employeeList = await fetchPaginatedRecords(
      queries.listEmployees,
      null,
      { field: "employee_name", direction: "asc" },
      1000,
      'listEmployees'
    );
    //employeeList = employeeList.filter(item => item._deleted !== true);
    employeeList = await getUniqueEmployeeList(employeeList)
    console.log(employeeList, "employeeList")
    employeeList.map((item) => {
      let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
      let obj = {
        name: name,
        code: item.user_Id,
        email: item.email,
        userCode: item.employee_code,
        role: item.role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : item.role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : item.role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,

      }
      finalEmpList.push(obj);

    })


    setEmpCodeList(finalEmpList);

    setAllEmployeeDetails(finalEmpList);  //usersWithoutAdmin
    //set employe list of cognito Users
    setEmpCodeListForRM(finalEmpList); //added for update in new
    setEmpCodeListForBC(finalEmpList);
    setEmpCodeListForBD(finalEmpList);
    setEmpCodeListForHRD(finalEmpList);
    //setEmpCodeListForHRT(finalEmpList);
    setShowNextPopUp(true);
  };

  //onSelect particular employye
  const selectedEmployeeFunction = async e => {
    console.log(e, "e11")
    console.log(empCodeList, "e11")
    // Remove specific employee from list
    const newEmpForRM = empCodeList.filter(item => item.code !== e.value.code);
    //comment for feedback update mis match issue
    //setEmpCodeListForRM(newEmpForRM);
    setSelectedEmployee(e.value);
    //console.log(e.value,"employee select")
    // Set selected id employee data

    const selectedDetails = allEmployeeDetails.find(item => item.userId === e.value.code);
    //const selectedDetails = sixPeriodEmployeeData.find(item => item.code === e.value.code);
    setSelectedEmployeeDetails(e.value);
    if (selectedDetails) {
      const reportingManager = empCodeList.find(item => item.code === selectedDetails.userReportingManager);
      //comment feedback update  for mis match issue
      //setSelectedReportingManagerEmployee(reportingManager || null);
    } else {
      //comment for feedback update  mis match issue
      //setSelectedReportingManagerEmployee(null);
    }
  };


  const approveAcknowledgeSelectedReport = async specificReportDetailsEdit => {
    setVisibleAgreementPopup(true);
  };

  const handleClickDisable = () => {
    setIsClickedApprove(true);
  };

  const updateRequestedReportList = (reportId, pstatus, status, designation) => {
    // Find the report with the given id
    const report = approvalReportRequestList.find(report => report.id === reportId);

    if (report) {
      // Create a copy of the report
      const pretextAndStatus = getPretextAndStatus(pstatus, status, designation);
      let updatedStatus = pretextAndStatus.pstatus;
      let updatedPretexts = pretextAndStatus.pretexts;

      setApprovalReportRequest((prevReports) =>
        prevReports.map((report) =>
          report.id === reportId
            ? { ...report, status: updatedStatus, pretexts: updatedPretexts }
            : report
        )
      );
    }
  };

  const updateTransactionCycleAndCreate = async (report, transactionCycle, loggedUserId, toId, isApprovedUpdate, isApprovedCreate, signaturePath, approverLevel, statusCreate, statusUpdate, remark) => {
    // Update the first transaction cycle
    await API.graphql({
      query: mutations.updateSixthPeriodReportTransactionCycle,
      variables: {
        input: {
          id: transactionCycle.id,
          isApproved: isApprovedUpdate,
          signature_File_Path: signaturePath,
          status: statusUpdate,
          _version: transactionCycle._version
        },
      },
    });

    // Add a new transaction cycle for reporting manager approval
    const addNewRowForRMReasponse = await API.graphql(
      graphqlOperation(mutations.createSixthPeriodReportTransactionCycle, {
        input: {
          report_Id: report.id,
          from_Employee_Id: loggedUserId,
          to_Employee_Id: toId,
          status: statusCreate,
          isApproved: isApprovedCreate,
          remark: remark,
          approver_level: approverLevel,
          date: getGraphqlFormattedDate(moment()),
        },
      })
    );

    if (addNewRowForRMReasponse) {
      const reportDetails = await buildReportDetails(addNewRowForRMReasponse?.data?.createSixthPeriodReportTransactionCycle, report.assignment_title, "Approved", report.submited_by, report.employee_id, loggedUserId, toId);
      await handleNotificationsOnStatusChange("Approved", reportDetails, "SIX_PERIOD");
      setRequestApprovalConfirmVisible(true);
      setCheckedSignature(false);
    }

    updateRequestedReportList(reportId, "Approved", "Approved", approverDesignations[approverLevel])
  }

  //approve report function
  const approveSelectedReport = async reportId => {

    const loggedUserId = reactLocalStorage.get("loggedUserId");

    // const SPReportingManager = reactLocalStorage.get("SPReportingManager");
    //get reporting manager from SixthPeriodAssignmentInitiateReport table
    try {
      const sixthPeriodAssignmentInitiateReport = await fetchInitiateReport(reportId)

      if (sixthPeriodAssignmentInitiateReport) {
        let reportTransactionCycles = await fetchReportTransactionCycles(reportId);
        let latestTransaction = reportTransactionCycles[0];

        if (reportTransactionCycles.length > 1) {
          //check for review resubmitted  only once for teacher   shailesh
          if (reportTransactionCycles[0].status === "ReviewedResubmitted") {
            // Update the first transaction cycle
            await updateTransactionCycleAndCreate(sixthPeriodAssignmentInitiateReport, latestTransaction, loggedUserId, sixthPeriodAssignmentInitiateReport.particular_emp_reporting_manager, true, false, signaturePath, "site_admin", "Open", latestTransaction.status, "")
          } else {
            const lastApproverLevel = reportTransactionCycles[0]?.approver_level;
            let toEmployeeId;
            let nextApproverLevel = approverLevels[approverLevels.indexOf(lastApproverLevel) + 1];
            if (lastApproverLevel) {
              switch (lastApproverLevel) {
                case approverLevels[0]:
                  toEmployeeId = sixthPeriodAssignmentInitiateReport.particular_emp_reporting_manager;
                  break;
                case approverLevels[1]:
                  toEmployeeId = sixthPeriodAssignmentInitiateReport.budgetClerkId;
                  if (!toEmployeeId || toEmployeeId.trim() === '') {
                    toEmployeeId = sixthPeriodAssignmentInitiateReport.hrDirectorI;
                    nextApproverLevel = approverLevels[4];
                  }
                  break;
                case approverLevels[2]:
                  toEmployeeId = sixthPeriodAssignmentInitiateReport.budgetManagerId;
                  if (!toEmployeeId || toEmployeeId.trim() === '') {
                    toEmployeeId = sixthPeriodAssignmentInitiateReport.hrDirectorI;
                    nextApproverLevel = approverLevels[4];
                  }
                  break;
                case approverLevels[3]:
                  toEmployeeId = sixthPeriodAssignmentInitiateReport.hrDirectorI;
                  break;
                case approverLevels[4]:
                  toEmployeeId = financeAnalyst?.userId || 0;
                  break;
                case approverLevels[5]:
                  toEmployeeId = executiveDirector?.userId || 0;
                  break;
                case approverLevels[6]:
                  toEmployeeId = sixthPeriodAssignmentInitiateReport.payrollId;
                  setSendToCc(defaultCcEmail);
                  break;
                default:
                  toEmployeeId = sixthPeriodAssignmentInitiateReport.payrollId;
                  setSendToCc(defaultCcEmail);
                  break;
              }
            }
            if (toEmployeeId !== "") {
              let toId, isApprovedUpdate, isApprovedCreate, statusCreate, statusUpdate, newApproverLevel, remark;
              if (toEmployeeId === "no_approval_needed") {
                toId = toEmployeeId;
                isApprovedUpdate = true;
                isApprovedCreate = false;
                statusUpdate = "Approved";
                statusCreate = "Open";
                newApproverLevel = approverLevels[approverLevels.length - 1];
                remark = "";
              } else {//second,third,fourth approver
                toId = toEmployeeId;
                isApprovedUpdate = true;
                isApprovedCreate = false;
                statusUpdate = "Approved";
                statusCreate = "Open";
                newApproverLevel = nextApproverLevel;
                remark = "";
              }
              await updateTransactionCycleAndCreate(sixthPeriodAssignmentInitiateReport, latestTransaction, loggedUserId, toId, isApprovedUpdate, isApprovedCreate, signaturePath, newApproverLevel, statusCreate, statusUpdate, remark)
            }
          }
        } else {
          //first Approver's Approve.
          let toId = sixthPeriodAssignmentInitiateReport.particular_emp_reporting_manager;
          await updateTransactionCycleAndCreate(sixthPeriodAssignmentInitiateReport, latestTransaction, loggedUserId, toId, true, false, signaturePath, approverLevels[1], "Open", "Approved", "")
        }
      }
      processRequestedReports();
      return false;

    } catch (err) {
      console.log("approveSelectedReport function while fetch report metadata", err);
    }
  };

  const acknowledgeSelectedReport = async (reportId) => {
    const loggedUserId = reactLocalStorage.get("loggedUserId");

    const report = await fetchInitiateReport(reportId);

    try {
      const original = await fetchReportTransactionCycles(reportId);

      if (original.length > 0) {
        const lastEntry = original[0];

        // Update the last transaction cycle to acknowledge the report
        await API.graphql({
          query: mutations.updateSixthPeriodReportTransactionCycle,
          variables: {
            input: {
              id: lastEntry.id,
              isApproved: true,
              status: "Closed",
              _version: lastEntry._version,
            },
          },
        });

        setVisiblePayrollReportEdit(false);

        // Build report details for notifications
        const reportDetails = await buildReportDetails(
          lastEntry,
          report?.assignment_title,
          "Open",
          report?.created_by,
          report?.employee_id,
          loggedUserId,
          null
        );
        processPayrollReports(reportId);
        // Handle notifications on status change
        handleNotificationsOnStatusChange("Acknowledge", reportDetails, "SIX_PERIOD");


        // Notify user
        toast.success("Report Acknowledged Successfully.");
      }
    } catch (err) {
      console.log("Error in HR Technician Acknowledgement Report.", err);
    }
  };


  //reject report function
  const rejectSelectedReport = async (reportId) => {
    if (rejectMsgValue === "") {
      toast.error("Please Add Reason For Rejection");
      return;
    }

    if (!fallBackApproverLevel) {
      toast.error("Please Select A Fall Back Approver");
      return;
    }

    const report = await fetchInitiateReport(reportId);

    try {
      const original = await fetchReportTransactionCycles(reportId);

      const filteredOriginal = original.filter(
        item => item.to_Employee_Id === loggedUserId
      );

      if (filteredOriginal.length > 0) {
        const currentItem = filteredOriginal[0];

        // Update the specific transaction cycle entry to rejected status
        await API.graphql({
          query: mutations.updateSixthPeriodReportTransactionCycle,
          variables: {
            input: {
              id: currentItem.id,
              status: "Rejected",
              remark: rejectMsgValue,
              _version: currentItem._version,
            }
          }
        });
        if (fallBackApproverLevel && fallBackApproverLevel?.approverLevel !== "initiator") {
          const addNewRowForRMResponse = await API.graphql(
            graphqlOperation(mutations.createSixthPeriodReportTransactionCycle, {
              input: {
                report_Id: reportId,
                from_Employee_Id: loggedUserId,
                to_Employee_Id: fallBackApproverLevel?.value,
                status: "Open",
                isApproved: false,
                approver_level: fallBackApproverLevel?.approverLevel,
                remark: "",
                date: getGraphqlFormattedDate(moment()),
              }
            })
          );

          if (addNewRowForRMResponse) {
            const responseRow = addNewRowForRMResponse.data.createSixthPeriodReportTransactionCycle;
            const reportDetails = await buildReportDetails(
              responseRow,
              report.assignment_title,
              "Rejected",
              report.submited_by,
              report.employee_id,
              loggedUserId,
              fallBackApprover
            );
            await handleNotificationsOnStatusChange("Rejected", reportDetails, "SIX_PERIOD");
            updateRequestedReportList(reportId, "Approved", "Approved", approverDesignations[approverLevels[fallBackApproverLevel - 1]]);
          }
        } else {
          const responseRow = { report_Id: reportId, date: report?.createdAt, status: "Rejected" };
          const reportDetails = await buildReportDetails(
            responseRow,
            report.assignment_title,
            "Rejected",
            report.submited_by,
            report.employee_id,
            loggedUserId,
            fallBackApprover
          );
          await handleNotificationsOnStatusChange("Rejected", reportDetails, "SIX_PERIOD");
          updateRequestedReportList(reportId, "Approved", "Rejected", approverDesignations[approverLevels[fallBackApproverLevel - 1]]);
        }
        setSendMsg(true);
      }
    } catch (err) {
      console.log("Error in reject specific report function", err);
    }
  };

  const statusItemTemplate = option => {
    return <Tag value={option} severity={TaskStatusSL(option)} />;
  };

  const checkApplicationAccessibility = async () => {
    //six-period
    let sixPeriodIsInitiator = reactLocalStorage.get("sixPeriodIsInitiator") == 1;
    let sixPeriodIsApprover = reactLocalStorage.get("sixPeriodIsApprover") == 1;
    let sixPeriodIsPayroll = reactLocalStorage.get("sixPeriodIsPayroll") == 1;
    let sixPeriodIsSuperadmin = reactLocalStorage.get("sixPeriodIsSuperadmin") == 1;

    setSixPeriodIsInitiator(sixPeriodIsInitiator);
    setSixPeriodIsApprover(sixPeriodIsApprover);
    setSixPeriodIsPayroll(sixPeriodIsPayroll);
    setSixPeriodIsSuperadmin(sixPeriodIsSuperadmin);

    if (sixPeriodIsInitiator) {
      setActiveIndex(0);
    }
    // if (sixPeriodIsApprover) {
    //   setActiveIndex(1);
    // }
    // if (sixPeriodIsPayroll) {
    //   setActiveIndex(2);
    // }
    // if (sixPeriodIsSuperadmin) {
    //   setActiveIndex(0);
    // }
  };


  useEffect(() => {
    let formTitle = '';

    //if (selectedEmployee) {

    formTitle = formTitle + (selectedEmployee ? selectedEmployee?.name : '(Employee)');

    if (startDate !== null && startDate !== 'undefined') {
      formTitle = formTitle + '- ' + (startDate ? moment(startDate).format("MM/DD/YYYY") : '(Start Date)');
    }
    if (endDate !== null && endDate !== 'undefined') {
      formTitle = formTitle + '- ' + (endDate ? moment(endDate).format("MM/DD/YYYY") : '(End Date)');
    }


    setAssignmentTitle(formTitle)
  }, [selectedEmployee, startDate, endDate]);
  //load employees
  const loadEmployees = async () => {
    let employees = await fetchPaginatedRecords(
      queries.listEmployees,
      null,
      { field: "employee_name", direction: "asc" },
      1000,
      'listEmployees'
    );
    employees = await getUniqueEmployeeList(employees)
    setSixPeriodEmployeeData(employees);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        await checkApplicationAccessibility();
        await onLoad();
        await loadUsers();
        await loadEmployees();
        const financeAnalystData = await fetchUsersByEmail(financeAnalystEmail);
        const financeAnalyst = buildUserDataFromCongntioResponse(financeAnalystData?.Users);
        setFinanceAnalyst(financeAnalyst?.[0]);
        const executiveDirectorData = await fetchUsersByEmail(executiveDirectorEmail);
        const executiveDirector = buildUserDataFromCongntioResponse(executiveDirectorData?.Users);
        setExecutiveDirector(executiveDirector?.[0]);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, [currentPage]);

  useEffect(() => {
    if (sixPeriodIsInitiator || sixPeriodIsSuperadmin) {
      processInitiatedReports();
    }
  }, [sixPeriodIsInitiator]);

  useEffect(() => {
    if (sixPeriodIsPayroll) {
		processInitiatedReports();
      //processPayrollReports();
    }
  }, [sixPeriodIsPayroll]);

  useEffect(() => {
    if (sixPeriodIsApprover) {
		processInitiatedReports();
     // processRequestedReports();
    }
  }, [sixPeriodIsApprover]);

  useEffect(() => {
    const approval_request = searchParams.get("approval_request");
    if (!approval_request) return;
    if (
      sixPeriodIsApprover == 1 &&
      approvalReportRequestList.length > 0 &&
      approval_request &&
      !visibleAgreementPopup
    ) {
      const request = approvalReportRequestList.find(request => request.id === approval_request);
      if (request) {
        onClickRequestedReportEditPopUp(request);
      }
    }
  }, [
    approvalReportRequestList,
    sixPeriodIsApprover,
    onClickRequestedReportEditPopUp,
    searchParams,
    visibleAgreementPopup
  ]);

  useEffect(() => {
    if (specificReportDetailsEdit?.id) {
      getRejectionUsers();
    }
  }, [specificReportDetailsEdit])

  useEffect(() => {
    if (addSignature) {
      handleAddSignature();
    }
  }, [addSignature])


  const statusRowFilterTemplate = options => {
    return (
      <Dropdown
        value={options.value}
        options={statuses}
        onChange={e => options.filterApplyCallback(e.value)}
        //onChange={e => callbackE(e.value)}
        itemTemplate={statusItemTemplate}
        placeholder="Select"
        className="p-column-filter custDropdown"
        showClear
        style={{ minWidth: "7rem" }}
      />
    );
  };


  const statusRowFilterTemplatePayroll = options => {
    return (
      <Dropdown
        value={options.value}
        options={statusesPayrolls}
        onChange={e => options.filterApplyCallback(e.value)}
        //onChange={e => callbackE(e.value)}
        itemTemplate={statusItemTemplate}
        placeholder="Select"
        className="p-column-filter custDropdown"
        showClear
        style={{ minWidth: "7rem" }}
      />
    );
  };

  const getObjectUntilUserIdMatch = (approversArray, userId) => {
    const result = {};
    for (const key in approversArray) {
      const value = approversArray[key];
      if (value === userId) {
        break;
      }
      result[key] = value;
    }
    return result;
  }

  const getRejectionUsers = async () => {
    //storing this for initiator role reference
    // let teacherDetails = specificReportDetailsEdit.approvalFinalData.find(item => item.approverLevel === 'teacher')
    let uniqApproversLevels = {} //Required to track unique list of approvers

    //Getting the list of fallBack approvers list, making sure this is not going past current approver level
    let pendingApproverLevel = specificReportDetailsEdit.approvalFinalData.find(item => item?.status?.toLowerCase() === "pending for approval")?.approverLevel
    let pendingApproverIndex = approverLevels.indexOf(pendingApproverLevel);
    const finalApproversList = pendingApproverIndex !== -1 ? approverLevels.slice(0, pendingApproverIndex) : approverLevels;
    //mapping this way to keep unique records for approvers. approvalFinalData can have duplicate records after rejection
    let approvers = finalApproversList.map(approverLevel => {
      if (!uniqApproversLevels[approverLevel]) {
        // If the approverLevel is not in the object, add it and return true (to keep the item)
        uniqApproversLevels[approverLevel] = true;
        let approverItem = specificReportDetailsEdit.approvalFinalData.find(item => item.approverLevel === approverLevel && item.status === "Approved")
        if (approverItem) {
          return { value: { label: approverItem.empName, value: approverItem.empId, approverLevel: approverItem.approverLevel }, label: approverItem.empTitle }
        }
      }
    }).filter(item => item);


    let initiator_id = specificReportDetailsEdit.initiator_id,
      initiatorData;
    const initiator = await fetchSpecificUserData(initiator_id);
    if (initiator) {
      //When report is routed to initiator for rejection, the flow starts from teacher approval.
      initiatorData = { value: { label: initiator.name, value: "", approverLevel: "initiator" }, label: 'Initiator' };
    }
    approvers.unshift(initiatorData); //add initiator to the list because initiator is not appearing in approval history

    setApproverLevelOptions(approvers.reverse()); //Set the list of approver levels to be displayed in the dropdown
    setFallBackApproverLevel(approvers[0].value); //Should select the last approver from the list by default and to be used to reject report
    setFallBackApprover(approvers[0].value); //Just to display the name of the approver in the dropdown. Not used anywhere else
    setFallBackUsersList([approvers[0].value]); //Should be only one option ie. selected option
  }

  const formatDateToMMDDYYYY = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = String(date.getFullYear());

    return `${month}/${day}/${year}`;
  }

  const uploadSignature = async (signature) => {

    const fileName = 'profile/' + loggedInUserData?.userId ?? loggedUserId + '/signature.png';

    const blob = await dataURLtoBlob(signature);

    try {
      toast.loading('Uploading please wait...');
      await Storage.put(fileName, blob, {
        resumable: true,
        completeCallback: (event) => {
          toast.dismiss();
          Auth.currentAuthenticatedUser()
            .then((user) => {
              return Auth.updateUserAttributes(user, {
                'custom:userSignature': fileName,
              });
            }).catch((err) => toast.error(err.message));
        },

        errorCallback: (err) => {
          toast.error(err.message);
        },

      });
      // setSignatureFileAwsPath(signature);
    } catch (error) {
      console.log('Error uploading file: ', error);
    }
    return fileName;
  }

  const handleSignatureSelection = async (image) => {
    setSignatureDialog(false);
    setSignatureFileAwsPath(null);
    const signatureFilePath = await uploadSignature(image);
    if (signatureFilePath.trim() !== '') {
      setSignaturePath(signatureFilePath);
      // loadSignatureFile(signatureFilePath);
      setSignatureFileAwsPath(image);
    } else {
      signatureFilePath(null);
    }
  }

  const loadSignatureFile = async (filePath) => {
    let file = null;
    try {

      await Storage.get(filePath)
        .then(result => {
          file = result;
        });

      if (file) {
        setSignatureFileAwsPath(file);
      }
    } catch (e) {
      setSignatureDialog(true);
    }

  }

  const handleAddSignature = async () => {
    const cognito = new AWS.CognitoIdentityServiceProvider();

    var params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };

    params['Filter'] = "sub ^=\"" + loggedUserId + "\"";
    await cognito.listUsers(params, (err, data) => {
      if (data) {
        let signature = data.Users[0].Attributes.find(attr => attr.Name === "custom:userSignature")?.Value;
        if (signature != null && signature.trim() !== '') {
          setSignaturePath(signature);
          loadSignatureFile(signature)
        } else {
          setSignatureDialog(true);
        }
      }
    });
  }

  const [hideLeftPanel, setHideLeftPanel] = useState(false);
  const [hideRightPanel, setHideRightPanel] = useState(false);

  const handleResize = () => {
    const screenWidth = window.innerWidth;
    const shouldHideLeftPanel = screenWidth <= 1279; // Adjust the breakpoint as per your needs
    const shouldHideRightPanel = screenWidth <= 1279; // Adjust the breakpoint as per your needs

    setHideLeftPanel(shouldHideLeftPanel);
    setHideRightPanel(shouldHideRightPanel);
  };

  useEffect(() => {
    // Call handleResize on initial mount
    handleResize();

    // Add event listener for window resizing
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener when the component is unmounted
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  async function onHideEditPopUp() {
    setShowNextPopUp(false)
    const original = await fetchInitiateReport(editRequestID)
    await updateEditable(original, true);
  }
  return isAuthenticated ? (
    <>
      <ReactFullscreen>
        {({ onToggle }) => (
          <Layout pageTitle="All Forms"
          IsSuperadmin={sixPeriodIsSuperAdminRole == 1 ? true : false}
            reDirectUrl={"/sixth_period_report_list"}
            reDirectUrlforSA={"/SixthPeriodSuperAdmin"}
            activeMenu="Archive" appId={"SIX_PERIOD"}
            IsArchive = {true}
            reDirectUrlforArchive={"/sixth_period_report_list/ArchiveReport"}
            >
            <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
              <div className="flex justify-end visible lg:hidden">
                <Button
                  icon="pi pi-bars"
                  onClick={toggleActive}
                  style={{
                    color: "#308B90",
                    background: "#ffffff00",
                    border: "1",
                    borderColor: "#308B90",
                    width: "38px",
                    padding: "6px 0",
                    borderRadius: "4px"
                  }}
                ></Button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
                <div className="relative z-10 col-span-12 lg:col-span-12" data-aos="fade-down" data-aos-duration="800">
                  <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]">
                    <div className="flex w-full items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                      <p className="text-[22px] xl:text-[0.938vw]  w-3/4 text-[#101828] font-medium">
                        6th Period Teaching Assignment
                      </p>

                      <div className="flex  w-1/2 xl:gap-[0.990vw] gap-2 items-center justify-end">
                        {activeIndex === 0 ? (
                          <>
                            {/* <span

                              className="w-3/4 emptyspace"

                            >
                              &nbsp;
                            </span> */}

                            {/* <Link
                              to="#"
                              className="w-auto text-center tableBtn blue radius8"
                              onClick={() => initiateNewReport()}
                            >
                              <i className="gusd-pluse-circle mx-1.5 "></i>
                              Initiate New Report
                            </Link> */}


                            <Link to="#" onClick={() => { exportFilteredDataToCSV("SixperiodInitiator.csv") }} className=" " > <i className="pi pi-download "></i></Link>


                          </>
                        ) :
                          <>
                            <span className="w-3/4 hidden md:block ">&nbsp;</span>
                            <Link to="#" onClick={() => { exportFilteredDataToCSVApprover("SixperiodApprover.csv") }} className=" "  ><i className="pi pi-download"></i></Link>
                          </>

                        }

                        <Link
                          onClick={() => {
                            onToggle();
                          }}
                          to=""
                        >
                          {" "}
                          <i className="gusd-expand"></i>
                        </Link>
                      </div>
                    </div>

                    <TabView
                      // activeIndex={sixPeriodIsInitiator == 1 ? activeIndex : 1} onTabChange={(e) => setActiveIndex(e.index)}>
                      activeIndex={activeIndex}
                      onTabChange={e => setActiveIndex(e.index)}
                    >
                      
                        <TabPanel index={0} header="Archive Reports">
                          <div
                            className={
                              initiatorReportList.length === 0
                                ? "datatableemptymessage arrowhide"
                                : "initiator  arrowshow"
                            }
                          >{
                            // initiatorReportList.length > 0 ? 
                            <DataTable
                            className="custpaginator custIcons custmBtnTable custTable"
                            scrollable
                            value={initiatorReportList}
                            paginator
                            rowsPerPageOptions={[10, 20, 30]}
                            filters={filters}
                            ref={dt}
                            exportFilename="sixperiodInitiator"
                            filterDisplay="row"
                            responsiveLayout="scroll"
                            paginatorTemplate="PrevPageLink PageLinks NextPageLink"
                            rows={pageSize}
                            totalRecords={totalRecords}
                            loading={initiatorReportsLoading}
                            // loadingIcon={<SpinnerLoader />}
                            emptyMessage="No Results found."
                            selection={selectedRows}
                          >
                            {/* <Column 
                              style={{ minWidth: "3rem" }}
                              header={<CheckboxHeader
                                queries={queries.listSixthPeriodAssignmentInitiateReports}
                                                        tableName={"getSixthPeriodAssignmentInitiateReport"}
                                                        mutations={mutations.updateSixthPeriodAssignmentInitiateReport}
                                data={initiatorReportList} selectedRows={selectedRows} setSelectedRows={setSelectedRows} 
                                // getMasterData={() => loadSubstituteCertificateRequest()} 
                                getMasterData={() => processInitiatedReports()} 
                                setReportLoading={setPayrollReportsLoading}   />}
                                body={(rowData) => <CheckboxColumn data={rowData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />}
                              /> */}
                            <Column field="srNo" header="SL#" style={{ minWidth: "3rem" }}></Column>
                            <Column
                              field="assignmentTitle"
                              header="Assignment Title"
                              filter
                              filterPlaceholder="Search"
                              sortable
                              style={{ minWidth: "5rem" }}
                            ></Column>
                            <Column
                              field="period"
                              filter
                              filterPlaceholder="Search"
                              header="Period"
                              sortable
                            ></Column>
                            {
                              sixPeriodIsSuperadmin === '1' ? (
                                [
                                  <Column
                                    field="initiator"
                                    filter
                                    filterPlaceholder="Search"
                                    header="Initiator Name"
                                    sortable
                                  ></Column>,
                                  <Column
                                    field="teacherName"
                                    header="Teacher Name"
                                    filter
                                    filterPlaceholder="Search"
                                    align="center"
                                    style={{ minWidth: "6rem" }}
                                  ></Column>,
                                  <Column
                                    field="assignmentAt"
                                    filter
                                    filterPlaceholder="Search"
                                    header="School/ Department"
                                    sortable
                                  ></Column>,
                                ]
                              ) : null
                            }
                            <Column
                              field="submittedOn"
                              header="Submitted On"
                              filter
                              filterPlaceholder="Search"
                              sortable
                              style={{ minWidth: "5rem" }}
                            ></Column>
                            <Column
                              header="Status"
                              field="pretexts"
                              filter
                              filterElement={statusRowFilterTemplate}
                              body={TaskStatusSLA}
                              sortable
                              style={{ minWidth: "8rem" }}
                            ></Column>
                            <Column
                              header="Assignee"
                              field="Assignee"
                              filter
                              filterPlaceholder="Search"
                              sortable
                              style={{ minWidth: "8rem" }}
                            ></Column>
                            {
                              sixPeriodIsSuperadmin === '1' ? (
                                [
                                  //employeeCode
                                  <Column
                                    field="assigneeName"
                                    header="Assignee Name"
                                    filter
                                    filterPlaceholder="Search"
                                    align="center"
                                    style={{ minWidth: "6rem" }}
                                  ></Column>
                                ]
                              ) : null
                            }
                            <Column
                              field="remark"
                              header="Remarks"
                              align="center"
                              style={{ minWidth: "6rem" }}
                            ></Column>
                            {
                              sixPeriodIsSuperadmin === '1' ? (
                                [
                                  <Column
                                    field="action"
                                    header="Actions"
                                    align="center"
                                    body={superAdminActions}
                                    style={{ minWidth: "12rem" }}
                                    exportable={false}
                                  ></Column>
                                ]
                              ) : <Column
                                field="action"
                                header="Action"
                                align="center"
                                body={initiateReportAction}
                                style={{ minWidth: "6rem" }}
                                exportable={false}
                                frozen alignFrozen="right"
                              ></Column>
                            }
                          </DataTable>
                          // : <h5>no data found</h5>
                          }
                            
                          </div>
                        </TabPanel>
                      

                   
                    </TabView>

                    <Dialog
                      className="relative reports-popup"
                      visible={visible}
                      position={position}
                      style={{ width: "65vw", height: "100%" }}
                      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                      onHide={() => {
                        setVisible(false);
                        setAddSignature(false);
                      }}
                      draggable={false}
                      resizable={false}
                    >
                      <div className="grid grid-cols-2 lg:grid-cols-12">
                        <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto" style={{ overflow: "auto" }}>
                          <div className="p-5">
                            <div onClick={() => {
                              setVisible(false);
                              setAddSignature(false);
                            }} className="py-3">
                              <Image src={sideBarRight} alt="user" width="24" height="24" />
                            </div>

                            {!fullViewForView ? (
                              <div>
                                <div className="text-center">
                                  <div className="text-[#000000] text-md lg:text-[0.833vw] font-bold">
                                    GLENDALE UNIFIED SCHOOL DISTRICT
                                  </div>
                                  <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">
                                    Request For Approval - Sixth Period Teaching Assignment
                                  </div>
                                </div>

                                <div className="pt-3">
                                  <p>Approval Status</p>
                                  <div className="py-3 emp-simple-tbl">
                                    <DataTable
                                      className="custpaginator custIcons custmBtnTable custTable"
                                      value={specificReportDetailsView.approvalFinalData}
                                    >
                                      <Column field="empTitle" header="Title"></Column>
                                      <Column field="empName" header="Name"></Column>
                                      <Column field="status" body={approvalStatusBody} header="Status"></Column>
                                    </DataTable>
                                  </div>
                                </div>
                              </div>
                            ) : null}

                            <div className=" rounded-[8px] p-3 mt-3">
                              <div className="flex justify-between">
                                <div className="text-[#344054] font-medium text-[20px] pb-3">
                                  <i className="mr-3 gusd-file-icon"></i>Sixth Period Teaching Assignment.pdf
                                </div>
                                <button
                                  onClick={() => {
                                    !fullViewForView ? setFullViewForView(true) : setFullViewForView(false);
                                  }}
                                  className="text-[#113699] font-medium text-[14px] pb-3"
                                >
                                  <i className="mt-2 mr-1 pi pi-calendar"></i>
                                  {!fullViewForView ? "View Full Screen" : "Exit Full Screen"}{" "}
                                </button>
                              </div>

                              {!fullViewEdit ? (
                                <div className="grid grid-cols-1 h-80">
                                  {/* <img src={pdfImageForEdit} alt='myImg' /> */}
                                  <HtmlToPdfSix
                                    data={{
                                      approvalFinalData: specificReportDetailsView.approvalFinalData,
                                      employeeName: specificReportDetailsView.employeeName,
                                      employeeId: specificReportDetailsView.employee_id,
                                      schoolName: specificReportDetailsView.assighment_at,
                                      dateFrom: specificReportDetailsView.from_date,
                                      dateTo: specificReportDetailsView.to_date,
                                      subjectName: specificReportDetailsView.subject_area,
                                      staffAllocation: specificReportDetailsView.total_staffing_allocation,
                                      accountCharged: specificReportDetailsView.account_charged,
                                      fteUtilized: specificReportDetailsView.current_fte_utilized,
                                      formName: ""
                                    }}
                                  />
                                </div>
                              ) : (
                                <div
                                  className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto"
                                  style={{ height: "581px" }}
                                >
                                  {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                  <HtmlToPdfSix
                                    data={{
                                      approvalFinalData: specificReportDetailsView.approvalFinalData,
                                      employeeName: specificReportDetailsView.employeeName,
                                      employeeId: specificReportDetailsView.employee_id,
                                      schoolName: specificReportDetailsView.assighment_at,
                                      dateFrom: specificReportDetailsView.from_date,
                                      dateTo: specificReportDetailsView.to_date,
                                      subjectName: specificReportDetailsView.subject_area,
                                      staffAllocation: specificReportDetailsView.total_staffing_allocation,
                                      accountCharged: specificReportDetailsView.account_charged,
                                      fteUtilized: specificReportDetailsView.current_fte_utilized,
                                      formName: ""
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* form history  */}
                        <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] min-h-[1145px] h-[800px]" >
                          {/* <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3">Form History</div>

                            <div className="card">

                              <Timeline value={events} opposite={(item) => <Tag
                                severity={approveStatusOptions(item)}
                                value={item.status}></Tag>} content={(item) => <div><small className="text-color-secondary text-sky-400/100">{item.empTitle}</small> <small className="text-color-secondary">{item.empName}</small></div>} />
                            </div>

                          </div> */}

                          <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3 mb-5 ">Form History</div>

                            <div className="card custTable">

                              <Timeline value={events}
                                opposite={(item) => <Tag
                                  severity={approveStatusOptions(item)} className="mr-2 relative d-tag top-[-5px]"
                                  value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                    <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                    <div className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</div>
                                    <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                    <div className="text-color-secondary text-[9px] ml-2">{item.status !== 'Pending For Approval' ? item.approvedDate : ''}</div>
                                  </div>} />

                            </div>
                          </div>
                        </div>
                      </div>
                    </Dialog>

                    {/* confirmation dialog */}
                    <Dialog
                      header=""
                      visible={confirmVisible}
                      style={{ width: "30vw" }}
                      onHide={() => {
                        setConfirmVisible(false);
                        setVisibleEdit(false);
                      }}
                      footer={footerContent}
                    >
                      <p className="m-0 text-[#0487C8]">
                        <i className="mr-2 pi pi-check-circle"></i>
                        <span className="font-medium text-[18px]">Your changes has been saved in this report</span>
                      </p>
                    </Dialog>
                    {/* edit popup end */}

                    {/* edit popup for requested report start */}
                    <Dialog
                      className="relative reports-popup"
                      visible={visibleRequestedReportEdit}
                      position="right"
                      style={{ width: `${fullViewEdit ? "70vw" : "60vw"}` }}
                      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                      onHide={() => {
                        setVisibleRequestedReportEdit(false);
                        setAddSignature(false);
                      }}
                      draggable={false}
                      resizable={false}
                    >
                      <div className="grid grid-cols-2 lg:grid-cols-12" style={{ height: "100%" }}>
                        <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] relative h-screen">
                          <div className="p-5 overflow-auto min-h-[980px]">
                            <a to="" onClick={() => {
                              setVisibleRequestedReportEdit(false);
                              setAddSignature(false);
                            }} className="py-3">
                              <Image src={sidebar} alt="user" width="24" height="24" />
                            </a>

                            {!fullViewEdit ? (
                              <div>
                                <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">
                                  6th Period Teaching Assignment
                                </div>
                                {/*<div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Sixth Period Teaching Assignment - Classified form</div> */}
                                <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                  <div className="mb-1">
                                    <label
                                      className="text-[#344054] text-[0.729vw] font-medium pb-1"
                                      htmlFor="username"
                                    >
                                      Approval Status
                                    </label>
                                    <div className="py-3 emp-simple-tbl">
                                      <DataTable
                                        className="custpaginator custIcons custmBtnTable custTable"
                                        value={specificReportDetailsEdit.approvalFinalData}
                                      >
                                        <Column field="empTitle" header="Title"></Column>
                                        <Column field="empName" header="Name"></Column>
                                        <Column field="status" body={approvalStatusBody} header="Status"></Column>
                                      </DataTable>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}

                            <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">
                              {!fullViewEdit ? (
                                <div className="flex justify-between">
                                  <div className="text-[#344054] font-medium text-[20px] pb-3">
                                    <i className="mr-3 gusd-document"></i>Sixth Period.pdf
                                  </div>
                                  <button
                                    onClick={() => setFullViewEdit(true)}
                                    className="text-[#113699] font-medium text-[14px] pb-3"
                                  >
                                    <i className="mt-2 mr-1 pi pi-calendar"></i>View Full Screen
                                  </button>
                                </div>
                              ) : (
                                <div className="flex justify-between">
                                  <div className="text-[#344054] font-medium text-[20px] pb-3">
                                    <i className="mr-3 gusd-document"></i>Sixth Period Teaching Assignment.pdf
                                  </div>
                                  <button
                                    onClick={() => setFullViewEdit(false)}
                                    className="text-[#113699] font-medium text-[14px] pb-3"
                                  >
                                    <i className="mt-2 mr-1 pi pi-calendar"></i>Exit Full Screen
                                  </button>
                                </div>
                              )}
                              {!fullViewEdit ? (
                                <div className="grid grid-cols-1 h-80">
                                  {/* <img src={pdfImageForEdit} alt='myImg' /> */}
                                  <HtmlToPdfSix
                                    data={{
                                      approvalFinalData: specificReportDetailsEdit.approvalFinalData,
                                      employeeName: specificReportDetailsEdit.employeeName,
                                      employeeId: specificReportDetailsEdit.employee_id,
                                      schoolName: specificReportDetailsEdit.assighment_at,
                                      dateFrom: specificReportDetailsEdit.from_date,
                                      dateTo: specificReportDetailsEdit.to_date,
                                      subjectName: specificReportDetailsEdit.subject_area,
                                      staffAllocation: specificReportDetailsEdit.total_staffing_allocation,
                                      accountCharged: specificReportDetailsEdit.account_charged,
                                      fteUtilized: specificReportDetailsEdit.current_fte_utilized,
                                      formName: ""
                                    }}
                                  />
                                </div>
                              ) : (
                                <div
                                  className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto"
                                  style={{ height: "800px" }}
                                >
                                  {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                  <HtmlToPdfSix
                                    data={{
                                      approvalFinalData: specificReportDetailsEdit.approvalFinalData,
                                      employeeName: specificReportDetailsEdit.employeeName,
                                      employeeId: specificReportDetailsEdit.employee_id,
                                      schoolName: specificReportDetailsEdit.assighment_at,
                                      dateFrom: specificReportDetailsEdit.from_date,
                                      dateTo: specificReportDetailsEdit.to_date,
                                      subjectName: specificReportDetailsEdit.subject_area,
                                      staffAllocation: specificReportDetailsEdit.total_staffing_allocation,
                                      accountCharged: specificReportDetailsEdit.account_charged,
                                      fteUtilized: specificReportDetailsEdit.current_fte_utilized,
                                      formName: ""
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="flex justify-between dialogpoput card">
                            {/* ----------------------------------------------------------------- */}
                          </div>

                          <div className="overflow-auto bg-[#F5F6F7]">
                            <div>
                              <Link to="#"
                                className="text-sm font-medium text-[#344054] py-2 px-2 mt-4 mr-5 rounded-[8px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] flex items-centerflex items-center float-right"
                                onClick={() => onClickHandleEdit(currentEditRow, "Pending for approval")}>
                                <i className="gusd-edit text-[#667085] text-[20px] font-meduim mr-1"></i> Edit Report
                              </Link>
                              <div className="pl-5 pt-5 text-[#344054] font-medium text-[20px] flex md:block">
                                <InputSwitch checked={addSignature} onChange={(e) => setAddSignature(e.value)} />
                                <label style={{ marginLeft: "2%" }}>Add Signature<span class="text-[red] pl-0.2">*</span></label>
                              </div>
                            </div>
                            {(addSignature && signatureFileAwsPath !== null) ?
                              <div className="py-3 px-5 rounded-[8px] mt-3">
                                <Card>
                                  <img className={"w-[20%] h-[15%]"}
                                    src={signatureFileAwsPath}
                                  />
                                </Card>
                              </div> : null}

                            <div className="p-10 bottom-10 grid grid-cols-3 gap-2 left-2 right-2 w-[100%]">
                              <Link
                                to="#"
                                onClick={() => {
                                  setVisibleRequestedReportEdit(false);
                                  setAddSignature(false);
                                }}
                                className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                              //  onClick={() => setVisibleCreteReportPopup(false)}
                              // onClick={() => setConfirmVisible(true)}
                              >
                                <i className="mr-1 gusd-close-circle" style={{ fontSize: "1rem" }}></i>Cancel
                              </Link>

                              {/* {
                                                            (!checkedSignature) ? */}
                              <Link
                                to=""
                                className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center text-[#D92D20]"
                                //  onClick={() => saveGroupInfo()}
                                onClick={() => {
                                  setRejectVisible(true);
                                  setSendMsg(false);
                                }}
                              >
                                <i className="mr-1 gusd-close" style={{ fontSize: "1rem" }}></i>Reject
                              </Link>


                              {enableApprover ? (
                                <button
                                  onClick={() => {
                                    if (signatureFileAwsPath !== null && addSignature) {
                                      approveAcknowledgeSelectedReport(specificReportDetailsEdit)
                                    }
                                  }}
                                  className={`${(signatureFileAwsPath === null || !addSignature) ? '' : "text-[#039855] "} text-center flex items-center tableBtn bg-white  border border-[#D0D5DD] radius8`}
                                  disabled={signatureFileAwsPath === null || !addSignature}
                                >
                                  <i className="mr-1 pi pi-check" style={{ fontSize: "1rem" }}></i>Acknowledge
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    if (signatureFileAwsPath !== null && addSignature) {
                                      handleClickDisable();
                                      approveSelectedReport(specificReportDetailsEdit.id);
                                    }
                                  }}
                                  disabled={isClickedApprove && (signatureFileAwsPath === null || !addSignature)}
                                  className={`${(signatureFileAwsPath === null || !addSignature) ? '' : "text-[#039855] "} text-center flex items-center tableBtn bg-white border border-[#D0D5DD] radius8`}
                                >
                                  <i className="mr-1 pi pi-check" style={{ fontSize: "1rem" }}></i>Approve
                                </button>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto min-h-[1145px]">
                          <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                            <div className="card custTable">

                              <Timeline value={events}
                                opposite={(item) => <Tag
                                  severity={approveStatusOptions(item)} className="mr-2 relative d-tag top-[-5px]"
                                  value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                    <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                    <div className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</div>
                                    <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                    <div className="text-color-secondary text-[9px] ml-2">{item.status !== 'Pending For Approval' ? item.approvedDate : ''}</div>
                                  </div>} />
                            </div>
                          </div>
                        </div>
                      </div>

                    </Dialog>

                    {/* edit popup for payroll start */}
                    <Dialog
                      className="relative reports-popup"
                      visible={visiblePayrollReportEdit}
                      position="right"
                      // style={{ width: `${fullViewEdit ? "65vw" : "30vw"}` }}
                      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                      style={{ width: "65vw" }}
                      onHide={() => setVisiblePayrollReportEdit(false)}
                      draggable={false}
                      resizable={false}
                    >
                      <div className="grid grid-cols-2 lg:grid-cols-12">
                        <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7]">
                          <div className="bg-[#F5F6F7] relative">
                            <div className="p-5 overflow-auto">
                              <a to="" onClick={() => setVisiblePayrollReportEdit(false)} className="py-3">
                                <Image src={sidebar} alt="user" width="24" height="24" />
                              </a>

                              {!fullViewEdit ? (
                                <div>
                                  <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">
                                    6th Period Teaching Assignment
                                  </div>
                                  {/*<div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Sixth Period Teaching Assignment - Classified form</div> */}
                                  <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                    <div className="mb-1">
                                      <label
                                        className="text-[#344054] text-[0.729vw] font-medium pb-1"
                                        htmlFor="username"
                                      >
                                        Approval Status
                                      </label>
                                      <div className="py-3 emp-simple-tbl">
                                        <DataTable
                                          className="custpaginator custIcons custmBtnTable custTable"
                                          value={specificReportDetailsEdit.approvalFinalData}
                                        >
                                          <Column field="empTitle" header="Title"></Column>
                                          <Column field="empName" header="Name"></Column>
                                          <Column field="status" body={approvalStatusBody} header="Status"></Column>
                                        </DataTable>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}

                              <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">
                                {!fullViewEdit ? (
                                  <div className="flex justify-between">
                                    <div className="text-[#344054] font-medium text-[20px] pb-3">
                                      <i className="mr-3 gusd-document"></i>Sixth Period.pdf
                                    </div>
                                    <button
                                      onClick={() => setFullViewEdit(true)}
                                      className="text-[#113699] font-medium text-[14px] pb-3"
                                    >
                                      <i className="mt-2 mr-1 pi pi-calendar"></i>View Full Screen
                                    </button>
                                  </div>
                                ) : (
                                  <div className="flex justify-between">
                                    <div className="text-[#344054] font-medium text-[20px] pb-3">
                                      <i className="mr-3 gusd-document"></i>Sixth Period Teaching Assignment.pdf
                                    </div>
                                    <button
                                      onClick={() => setFullViewEdit(false)}
                                      className="text-[#113699] font-medium text-[14px] pb-3"
                                    >
                                      <i className="mt-2 mr-1 pi pi-calendar"></i>Exit Full Screen
                                    </button>
                                  </div>
                                )}
                                {!fullViewEdit ? (
                                  <div className="grid grid-cols-1 h-80">
                                    {/* <img src={pdfImageForEdit} alt='myImg' /> */}
                                    <HtmlToPdfSix
                                      data={{
                                        approvalFinalData: specificReportDetailsEdit.approvalFinalData,
                                        employeeName: specificReportDetailsEdit.employeeName,
                                        employeeId: specificReportDetailsEdit.employee_id,
                                        schoolName: specificReportDetailsEdit.assighment_at,
                                        dateFrom: specificReportDetailsEdit.from_date,
                                        dateTo: specificReportDetailsEdit.to_date,
                                        subjectName: specificReportDetailsEdit.subject_area,
                                        staffAllocation: specificReportDetailsEdit.total_staffing_allocation,
                                        accountCharged: specificReportDetailsEdit.account_charged,
                                        fteUtilized: specificReportDetailsEdit.current_fte_utilized,
                                        formName: ""
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div
                                    className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto"
                                    style={{ height: "580px" }}
                                  >
                                    {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                    <HtmlToPdfSix
                                      data={{
                                        approvalFinalData: specificReportDetailsEdit.approvalFinalData,
                                        employeeName: specificReportDetailsEdit.employeeName,
                                        employeeId: specificReportDetailsEdit.employee_id,
                                        schoolName: specificReportDetailsEdit.assighment_at,
                                        dateFrom: specificReportDetailsEdit.from_date,
                                        dateTo: specificReportDetailsEdit.to_date,
                                        subjectName: specificReportDetailsEdit.subject_area,
                                        staffAllocation: specificReportDetailsEdit.total_staffing_allocation,
                                        accountCharged: specificReportDetailsEdit.account_charged,
                                        fteUtilized: specificReportDetailsEdit.current_fte_utilized,
                                        formName: ""
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>



                            <div className="flex justify-between dialogpoput card"></div>

                            <div className="overflow-auto">
                              <div className="pl-5 pt-5 text-[#344054] font-medium text-[20px] flex md:block">
                                <InputSwitch checked={addSignature} onChange={(e) => setAddSignature(e.value)} />
                                <label style={{ marginLeft: "2%" }}>Add Signature<span class="text-[red] pl-0.2">*</span></label>
                              </div>

                              {(addSignature && signatureFileAwsPath !== null) ?
                                <div className="py-3 px-5 rounded-[8px] mt-3">
                                  <Card>
                                    <img className={"w-[20%] h-[15%]"}
                                      src={signatureFileAwsPath}
                                    />
                                  </Card>
                                </div> : null}

                              <div className="bottom-0 grid grid-cols-2 gap-2 pt-10 p-2 left-2 right-2">
                                <Link
                                  to="#"
                                  onClick={() => {
                                    setVisiblePayrollReportEdit(false);
                                    setAddSignature(false);
                                  }}
                                  className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                                //  onClick={() => setVisibleCreteReportPopup(false)}
                                // onClick={() => setConfirmVisible(true)}
                                >
                                  <i className="mr-1 gusd-close-circle" style={{ fontSize: "1rem" }}></i>Cancel
                                </Link>
                                <button
                                  onClick={() => {
                                    if (signatureFileAwsPath !== null && addSignature) {
                                      acknowledgeSelectedReport(specificReportDetailsEdit.id)
                                    }
                                  }}
                                  className={` ${(signatureFileAwsPath === null || !addSignature) ? '' : "text-[#039855] "}text-center flex items-center tableBtn bg-white border border-[#D0D5DD] radius8`}
                                  disabled={signatureFileAwsPath === null || !addSignature}
                                >
                                  <i className="mr-1 pi pi-check" style={{ fontSize: "1rem" }}></i>Acknowledge
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1]">
                          <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3 mb-5 ">Form History</div>

                            <div className="card custTable">

                              <Timeline value={events}
                                opposite={(item) => <Tag
                                  severity={approveStatusOptions(item)} className="mr-2 relative d-tag top-[-5px]"
                                  value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                    <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                    <div className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</div>
                                    <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                    <div className="text-color-secondary text-[9px] ml-2">{item.status !== 'Pending For Approval' ? item.approvedDate : ''}</div>
                                  </div>} />

                            </div>
                          </div>
                        </div>
                      </div>
                    </Dialog>
                    {/* edit popup for payroll end */}

                    {/**Approver agreement ****/}

                    <Dialog
                      className="relative reports-popup"
                      visible={visibleAgreementPopup}
                      position="right"
                      style={{ width: `${fullViewEdit ? "50vw" : "100vw"}` }}
                      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                      onHide={() => {
                        setVisibleAgreementPopup(false);
                        setAddSignature(false);
                      }}
                      draggable={false}
                      resizable={false}
                    >
                      <SixperiodAgreement
                        specificReportDetailsEdit={specificReportDetailsEdit}
                        onClosePopup={() => {
                          setVisibleAgreementPopup(false);
                          setAddSignature(false);
                          if (searchParams.get("approval_request")) {
                            navigateTo("/sixth_period_report_list");
                          }
                        }}
                        onRejectPopup={() => setRejectVisible(true)}
                        // setRequestApprovalConfirmVisible={setRequestApprovalConfirmVisible}
                        // setCheckedSignature={setCheckedSignature}
                        onAcknowledge={() => {
                          approveSelectedReport(specificReportDetailsEdit?.id);
                        }}
                        addSignature={addSignature}
                        setAddSignature={setAddSignature}
                        signatureFileAwsPath={signatureFileAwsPath}
                      />
                    </Dialog>

                    <Dialog
                      header=""
                      visible={requestApprovalConfirmVisible}
                      style={{ width: "30vw" }}
                      closable={false}
                      onHide={() => {
                        setRequestApprovalConfirmVisible(false);
                        setVisibleEdit(false);
                      }}
                      footer={footerContentForReqApproval}
                    >
                      <p className="m-0 text-[#0487C8] text-center">
                        <i className="mr-2 pi pi-check-circle"></i>
                        <span className="font-medium text-[18px]">This report is Approved</span>
                      </p>
                    </Dialog>

                    {/* Reject dialog */}
                    <Dialog
                      header="Reject Report"
                      visible={rejectVisible}
                      style={{ width: "30vw" }}
                      //                      closable={false}
                      onHide={() => {
                        setRejectVisible(false);
                        // setVisibleEdit(false);
                      }}
                      footer={footerContentForReqReject}
                    >
                      <div className="m-0">
                        {sendMsg && <div className="font-medium text-[18px] text-[#249144] mb-6">Message Sent Successfully</div>}

                        <div className="font-medium text-[18px] mb-3">Select an approver level</div>
                        <Dropdown
                          value={fallBackApproverLevel}
                          options={approverLevelOptions}
                          onChange={(e) => { setFallBackApproverLevel(e.value); setFallBackUsersList([e.value]) }}
                          optionLabel="label"
                          placeholder="Select"
                          className="p-column-filter custDropdown w-full mb-6"
                        />

                        <div className="font-medium text-[18px] mb-3">Select an approver</div>

                        <Dropdown
                          value={fallBackApproverLevel?.value}
                          options={fallBackUsersList}
                          onChange={(e) => setFallBackApprover(e.value)}
                          optionLabel="label"
                          placeholder="Select"
                          className="p-column-filter custDropdown w-full mb-6"
                        />
                        <div className="font-medium text-[18px] mb-3">Enter the Reason for Rejection<span className="text-[red] pl-0.2">*</span></div>

                        <InputText
                          value={rejectMsgValue}
                          placeholder="Enter the Reason for Rejection"
                          onChange={e => setRejectValueMsg(e.target.value)}
                          className="w-full"
                        />
                      </div>
                    </Dialog>
                    {/* edit popup end */}
                    {/* edit popup for requested report end */}

                    {/* added notification remainer dialog start */}
                    <Dialog
                      header="Reminder"
                      visible={ReminderDialog}
                      style={{ width: "30vw" }}
                      onHide={() => {
                        setreminderDialog(false);
                      }}
                      closable={false}
                      footer={footerContentForReminder}
                    >
                      <p className="m-0 text-[#0487C8] text-center">
                        <i className="mr-2 pi pi-check-circle"></i>
                        <span className="font-medium text-[18px]">{`By clicking Yes, a reminder will be sent to ${ReminderData?.Assignee} to approve the form. Click No to cancel.`}</span>
                      </p>
                    </Dialog>
                    {/* added notification remainer dialog end */}



                    {/*  Signature dialog*/}

                    <SignatureDialog isVisible={signatureDialog}
                      onClickHandler={(image) => handleSignatureSelection(image)}
                      onCloseHandler={() => {
                        setSignatureDialog(false);
                        setAddSignature(false);
                      }}
                      username={loggedInUserData?.name} />

                  </div>

                  <Sidebar
                    visible={visibleRight}
                    position="right"
                    onHide={() => setVisibleRight(false)}
                    style={{ width: "35vw" }}
                    className="customesidebar1 responsivepoup"
                  >
                    <Editpopup
                      popupstate={() => setVisibleRight(false)}
                      fromDate={fromDate}
                      toDate={toDate}
                      schoolName={schoolName}
                      reportEmployeeList={reportEmployeeList}
                      status={status}
                      reportId={reportId}
                      // bindList={() => loadAbsenceReport()}
                      type={"Initior"}
                    />
                  </Sidebar>
                </div>
              </div>
            </div>

            {/* popup's */}
            <Dialog
              className="relative reports-popup"
              visible={visibleCreteReportPopup}
              position="right"
              style={{ width: "30vw" }}
              breakpoints={{ "960px": "75vw", "641px": "100vw" }}
              onHide={() => setVisibleCreteReportPopup(false)}
              draggable={false}
              resizable={false}
            >
              <div className="">
                <div className="bg-[#F5F6F7] relative h-screen">
                  <div className="p-5">
                    <a to="" onClick={() => {
                      setVisibleCreteReportPopup(false);
                      setAddSignature(false);
                    }} className="py-3">
                      <Image src={sidebar} alt="user" width="24" height="24" />
                    </a>
                    <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">
                      6th Period Teaching Assignment
                    </div>
                    {/* <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div> */}
                    <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                      <div className="mb-1">
                        <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">
                          Assignment Title
                        </label>
                        <div>
                          <InputText
                            value={groupName}
                            onChange={e => setGroupName(e.target.value)}
                            id="username"
                            placeholder="Type Here"
                            className="w-full placeholder:text-[#667085] "
                            aria-describedby="username-help"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="absolute grid grid-cols-2 gap-2 bottom-2 left-2 right-2 ">
                    <Link
                      to="#"
                      className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                      onClick={() => {
                        setVisibleCreteReportPopup(false);
                        setAddSignature(false);
                      }}
                    >
                      <i className="mr-1 pi pi-times" style={{ fontSize: "1rem" }}></i>Cancel
                    </Link>

                    <Link
                      to=""
                      className="flex items-center text-center tableBtn blue radius8"
                      onClick={() => {
                        setShowNextPopUp(true);
                        // saveGroupInfo();
                      }}
                    >
                      <i className="mr-1 pi pi-arrow-right" style={{ fontSize: "1rem" }}></i>Next
                    </Link>
                  </div>
                </div>
              </div>
            </Dialog>

            {/* next full popup */}
            <Dialog
              className="relative reports-popup"
              visible={showNextPopUp}
              position="right"
              style={{ width: "100vw" }}
              breakpoints={{ "960px": "100vw", "641px": "100vw" }}
              onHide={onHideEditPopUp}
              draggable={false}
              resizable={false}
            >
              {/* <div class="p-10"><a href="#" id="add-family-open-btn"><i class="gusd-edit text-2xl"></i></a></div> */}
              <div className="fixed inset-0 z-10 overflow-y-auto styled-select">
                <div className="flex items-start justify-center min-h-full h-full bg-[#FBFDFF]">
                  <div className="relative w-full overflow-hidden transition-all transform">
                    <div className="grid grid-cols-12 custmCols">
                      <div className={`h-full col-span-3 sideBarLeft openSideDiv ${hideLeftPanel ? 'hidden' : ''}`}>
                        <button
                          onClick={() => {
                            setShowPreviewPopUp(false);
                            onHideEditPopUp(editRequestID);
                          }}
                          type="button"
                          className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
                          id="add-family-cancel-btn"
                        >
                          <i className="gusd-arrow-line-right mr-[14px] xl:mr-[0.729vw]"></i> Back Home
                        </button>
                        <div className=" text-[#101828] text-[12px] mt-[7px] font-normal">
                          GUSD 6th Period Teaching Assignment
                        </div>
                        {/* <div className="mt-[10px] xl:mt-[0.533vw] text-[#101828] text-[20px] xl:text-[0.833vw] font-medium">Assignment 10102</div> */}
                        <div className="mt-[32px] xl:[1.667vw]">
                          <ul className="sideTabs">
                            <li>
                              <a
                                href="#"
                                onClick={() => setShowPreviewPopUp(false)}
                                className={`${showPreviewPopUp ? "tab-b active " : "tab-b active activeCheck"}`}
                                data-id="tab1"
                              >
                                <i className="gusd-check text-[16px] xl:text-[1.042vw]"></i>
                                Basic Info
                              </a>
                            </li>
                            <li>
                              <a
                                href="#"
                                // onClick={() =>
                                // setShowPreviewPopUp(true)
                                // }
                                className={`${showPreviewPopUp ? "tab-b active activeCheck" : ""}`}
                                data-id="tab2"
                              >
                                <i className="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i> Preview & Edit
                              </a>
                            </li>
                            {/* <li><a href="javascript:void(0);" class="tab-b" data-id="tab3"><i class="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i> Report Options</a></li> */}
                          </ul>
                        </div>
                        <div className="fixed top-0 left-0 openBtn xl:hidden">
                          <button
                            type="button"
                            className="sideDivBtn inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#3366FF] border border-[#EFF8FF] rounded-r-md"
                          >
                            <i className="gusd-arrow-line-right"></i>
                          </button>
                        </div>
                      </div>
                      {/*<div className={`centerContent col-span-12 ${hideLeftPanel ? 'ml-[20%]' : ''} ${hideRightPanel ? 'mr-[20%]' : ''}`}>*/}
                      <div className="col-span-12 overflow-auto xl:col-span-6 mScrollCstm ">
                        <div className="pt-10 tab-c tab-active p-lr-110 xl:pt-0" data-id="tab1">
                          <div className="text-[24px] xl:text-[1.250vw] font-medium">
                            {showPreviewPopUp ? "Preview & Edit" : "Basic Info"}
                          </div>
                          <div className="mCustomScrollbar scroll-w-10 max-h-100">
                            {!showPreviewPopUp ? (
                              <div className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]">
                                <form>
                                  <div className="space-y-[32px] xl:space-y-[1.667vw]">
                                    {currentStatus === "Rejected" && editMode ? (
                                      <div className="">
                                        <div className=" mt-10  flex flex-wrap xl:flex-nowrap gap-4 mt-5 xl:gap-[0.938vw] xl:mt-[1.250vw] w-1/2">
                                          <h3 className="text-[#113699]  py-4 font-semibold -tracking-[0.02em] text-xl xl:text-[1.042vw]">
                                            Remark
                                          </h3>

                                          <textarea
                                            placeholder=""
                                            value={editRemark}
                                            rows="2"
                                            cols="40"
                                            type="text"
                                            readOnly={true}
                                            className=" text-[#344054] text-[16px] a rounded-lg disabled bg-[#fff] flex-1 appearance-none border border-[#D0D5DD]  py-2 px-4 bg-grey text-gray-700 placeholder-gray-500 shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 mt-1.5 placeholder:text-[#667085] dark:bg-[#333231] dark:border-[#333231] dark:text-[#8E8E8E]"
                                          ></textarea>
                                        </div>
                                      </div>
                                    ) : null}

                                    <div>
                                      <div>
                                        <div className='border px-8 certificate-six'>
                                          <div className='font-bold grid justify-end'>Form C</div>
                                          <center><b>CERTIFICATE</b></center>
                                          <center style={{ marginTop: '10px' }}>GLENDALE UNIFIED SCHOOL DISTRICT
                                            <div>Certificated Personnel Office</div>
                                            <div style={{ marginTop: '20px' }}><b>REQUEST FOR APPROVAL - SIXTH PERIOD TEACHING ASSIGNMENT</b></div>
                                          </center>
                                          <div className='mt-4 border-4 p-4'>
                                            <div className='font-light text-xs'>DIRECTIONS: This form should be completed and sent to the offices indicted below for approval. After all necessary approvals, the form should be forwarded to the Human Resources office which will submit the recommendation to the Board of Education for final approval. This form must be received by the Human Resources office prior to commencement of the sixth period assignment.</div>
                                          </div>
                                          <div>
                                            <div className='mt-2.5 leading-10' style={{ fontSize: "15px" }}>

                                              {/* Employee Selection */}
                                              <div className="flex items-center mb-2 flex-wrap space-x-2">
                                                <span>It is requested that approval be granted to assign, on a voluntary basis,</span>
                                              </div>

                                              <div className="flex items-center mb-2 flex-wrap space-x-2">
                                                {(currentStatus === "Pending for approval")
                                                  ? <input
                                                    value={selectedEmployee?.name}
                                                    id="eid"
                                                    onChange={e => e.preventDefault()}
                                                    placeholder="ID"
                                                    className="md:w-[21rem] h-11 rounded-md border border-[#E4E7EC] placeholder:text-[#667085] mx-2 pl-2"
                                                    disabled={true}
                                                  />
                                                  : <div className="flex">
                                                    <Dropdown
                                                      options={empCodeList}
                                                      onChange={e => selectedEmployeeFunction(e)}
                                                      value={selectedEmployee}
                                                      onKeyDown={e => {
                                                        setEmpList(e, "Employee")
                                                      }}
                                                      optionLabel="name"
                                                      placeholder="Select an Employee"
                                                      filter
                                                      showClear={selectedEmployee}
                                                      // showClear
                                                      className="md:w-[21rem] h-11 rounded-md border border-[#E4E7EC] placeholder:text-[#667085] mr-2"
                                                    />
                                                    <div onClick={(e) => setOpenNewEmployee(true)} className='cursor-pointer text-[30px] '>
                                                      <Tooltip target=".icon-tooltip" content="Add Employee" position="top" className="custom-tooltip-content" />
                                                      <i className='icon-tooltip gusd-pluse-circle' style={{ color: "lightgray", fontSize: "20px", margin: "3px", position: "relative", bottom: "6px" }}></i>
                                                    </div>
                                                  </div>
                                                }
                                                <span>EID</span>
                                                <input
                                                  value={selectedEmployee?.userCode}
                                                  id="eid"
                                                  onChange={e => e.preventDefault()}
                                                  placeholder="ID"
                                                  className="md:w-[9.5rem] h-11 rounded-md border border-[#E4E7EC] placeholder:text-[#667085] mx-2 pl-2"
                                                  disabled={true}
                                                />
                                              </div>
                                              {/* Add New Employee Popup */}
                                              <Dialog
                                                header="Add New Employee" draggable={false} className='add_New_Employee'
                                                visible={openNewEmployee}
                                                style={{ width: "30vw" }}

                                                onHide={() => {
                                                  setOpenNewEmployee(false);

                                                }}
                                              // footer={footerContentForReqReject}
                                              >
                                                <div className="m-0">

                                                  <div className="font-medium text-sm mb-2 mt-3">School/Department <span className="text-[red] pl-0.2">*</span></div>
                                                  <Dropdown id="dept" value={NewEmployeeSchool}
                                                    onChange={(e) => { setNewEmployeeSchool(e.value) }}
                                                    filter
                                                    showClear={NewEmployeeSchool}
                                                    options={schoolList} optionLabel="name" placeholder="Select School/Department" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                  />
                                                  {/* <div className="font-medium text-[18px] mb-2 mt-3">Employee Name <span className="text-[red] pl-0.2">*</span></div>
                                                  <InputText
                                                    value={NewEmployeeName}
                                                    placeholder=""
                                                    onChange={e => { setNewEmployeeName(e.target.value) }}
                                                    className="w-full"
                                                  /> */}
                                                  <div className="font-medium text-sm mb-2 mt-3">First Name <span className="text-[red] pl-0.2">*</span></div>
                                                  <InputText
                                                    value={newEmpFirstName}
                                                    placeholder="Enter First Name"
                                                    onChange={e => { setNewEmpFirstName(e.target.value) }}
                                                    className="w-full"
                                                  />
                                                  <div className="font-medium text-sm mb-2 mt-3">Last Name <span className="text-[red] pl-0.2">*</span></div>
                                                  <InputText
                                                    value={newEmpLastName}
                                                    placeholder="Enter Last Name"
                                                    onChange={e => { setNewEmpLastName(e.target.value) }}
                                                    className="w-full"
                                                  />
                                                  {/* <div className="font-medium text-[18px] mb-2 mt-3">Select Role 
                                                  <span className="text-[red] pl-0.2">*</span>
                                                  </div>
                                                  <Dropdown value={newEmpSelectedRole} onChange={(e) => setNewEmpSelectedRole(e.value)} options={rolesArray} optionLabel="name"
                                                    placeholder="Select a Role" className="w-full md:w-14rem" />

                                                  <div className="font-medium text-[18px] mb-2 mt-3">Designation<span className="text-[red] pl-0.2">*</span></div>
                                                  <Dropdown value={newEmpSelectedDesignation} onChange={(e) => setNewEmpSelectedDesignation(e.value)} options={designationForAllApps} optionLabel="name"
                                                    placeholder="Select a Designation" className="w-full md:w-14rem" /> */}
                                                  {/* -------------------------------- */}


                                                  <div className="font-medium text-sm mb-2 mt-3">Employee Code <span className="text-[red] pl-0.2">*</span></div>
                                                  <InputText
                                                    value={NewEmployeeCode}
                                                    placeholder="Enter Employee Code"
                                                    onChange={e => { setNewEmployeeCode(e.target.value) }}
                                                    className="w-full"
                                                  />

                                                  <div className="font-medium text-sm mb-2 mt-3 ">Employee Email Address <span className="text-[red] pl-0.2">*</span></div>
                                                  <InputText
                                                    value={NewEmployeeEmail}
                                                    placeholder="Enter Employee Email Address"
                                                    onChange={e => { setNewEmployeeEmail(e.target.value) }}
                                                    className="w-full"
                                                  />
                                                </div>
                                                <div className='flex justify-between gap-2 mt-3'>
                                                  <Link to="" onClick={() => { setOpenNewEmployee(false); }}
                                                    className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                                    <i class="pi pi-times"></i><span>Cancel</span></Link>

                                                  <Link to="" onClick={() => { AddNewEmployee() }}
                                                    className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                                    <i class="pi pi-check"></i><span>Add</span></Link>

                                                </div>
                                              </Dialog>

                                              <div className="flex flex-wrap items-start md:items-center mb-2 space-y-4 md:space-y-0 md:space-x-2">
                                                <span>Assign to a sixth period teaching assignment at</span>
                                              </div>

                                              <div className="flex flex-wrap items-start md:items-center mb-4 space-y-4 md:space-y-0 md:space-x-2">
                                                <Dropdown
                                                  id="dept"
                                                  value={schoolSelect}
                                                  onChange={e => {
                                                    setSelectedSchool(e.target.value);
                                                  }}
                                                  filter
                                                  showClear={schoolSelect}
                                                  options={schoolList}
                                                  optionLabel="name"
                                                  placeholder="Select School"
                                                  className="md:w-[33.3rem] h-11 rounded-md border border-[#E4E7EC] placeholder:text-[#667085]"
                                                  style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
                                                />
                                              </div>

                                              <div className="flex flex-wrap items-start md:items-center mb-4 space-y-4 md:space-y-0 md:space-x-2">
                                                <span>For the period from</span>
                                                <div className="relative md:w-40 ml-3 mr-5">
                                                  <i className="gusd-calendar text-[#667085] text-sm absolute left-3 top-1/2 transform -translate-y-1/2 z-10"></i>
                                                  <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-4 top-1/2 transform -translate-y-1/2 z-10"></i>
                                                  <div className="flex card justify-content-center">
                                                    <Calendar
                                                      onChange={(e) => {
                                                        setStartDate(e.target.value);
                                                      }}
                                                      value={startDate || null}
                                                      placeholder="Start Date"
                                                      className="w-full h-11 pl-8"
                                                    />
                                                  </div>
                                                </div>

                                                <span>To</span>
                                                <div className="relative md:w-40 mx-3">
                                                  <i className="gusd-calendar text-[#667085] text-sm absolute left-3 top-1/2 transform -translate-y-1/2 z-10"></i>
                                                  <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-4 top-1/2 transform -translate-y-1/2 z-10"></i>
                                                  <div className="flex card justify-content-center">
                                                    <Calendar
                                                      onChange={(e) => {
                                                        setEndDate(e.target.value);
                                                      }}
                                                      value={endDate || null}
                                                      minDate={startDate}
                                                      placeholder="End Date"
                                                      className="w-full h-11 pl-8"
                                                    />
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="flex flex-wrap items-start md:items-center mb-4 space-y-4 md:space-y-0 md:space-x-2">
                                                <span className='flex items-center space-x-2'>
                                                  <span>Subject Area Added</span>
                                                  <input
                                                    value={subjectCode}
                                                    onChange={(e) => { setSubjectCode(e.target.value) }}
                                                    type="text"

                                                    className="md:w-[6.4rem] h-11 pl-1 text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                                    placeholder="Subject"
                                                  />

                                                </span>
                                                <span className='flex items-center space-x-2'>
                                                  <span>Total Staffing Allocation</span>
                                                  <input
                                                    value={totalStaffingAllocationectedRole}
                                                    onChange={e => setTotalStaffingAllocation(e.target.value)}
                                                    type="text"
                                                    name="staffingAllocation"
                                                    className="md:w-[5.3rem] h-11 pl-1 text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                                    placeholder="Type here"
                                                  />
                                                </span>
                                              </div>

                                              <div className="flex flex-wrap items-start md:items-center mb-4 space-y-4 md:space-y-0 md:space-x-2">
                                                <span className='flex items-center space-x-2'>
                                                  <span>Account Charged</span>
                                                  <input
                                                    value={accountCharged}
                                                    onChange={e => setAccountCharged(e.target.value)}
                                                    type="text"
                                                    name=""
                                                    placeholder="Type here"
                                                    className="h-11 md:w-[25rem] text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                                  />
                                                </span>
                                              </div>

                                              <div className="flex flex-wrap items-start md:items-center mb-4 space-y-4 md:space-y-0 md:space-x-2">
                                                <span className='flex items-center space-x-2'>
                                                  <span>Current FTE Utilized</span>
                                                  <input
                                                    value={fteUtilized}
                                                    onChange={e => setFteUtilized(e.target.value)}
                                                    type="number"
                                                    name=""
                                                    className="h-11  md:w-[24rem] text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]"
                                                    placeholder="Type here"
                                                  />
                                                </span>
                                              </div>

                                            </div>

                                            <div className='my-8 border-b-4 border-[black]'></div>

                                            <div className='mt-2.5 leading-10' style={{ fontSize: "15px" }}>

                                              <div className="flex flex-wrap items-start md:items-center mb-4 space-y-4 md:space-y-0 md:space-x-2">
                                                <span>I accept, on a voluntary basis, a sixth period teaching assignment at</span>
                                              </div>

                                              <div className="flex flex-wrap items-start md:items-center mb-4 space-y-4 md:space-y-0 md:space-x-2">
                                                <InputText
                                                  value={schoolSelect?.name}
                                                  onChange={e => e.preventDefault()}
                                                  placeholder="School"
                                                  className="md:w-[23rem] h-11 rounded-md border border-[#E4E7EC] placeholder:text-[#667085] placeholder-y-[0.2rem]"
                                                  disabled={true}
                                                />
                                                <span>for the period from</span>
                                              </div>

                                              <div className="flex flex-wrap items-start md:items-center mb-4 space-y-4 md:space-y-0 md:space-x-2">
                                                <InputText
                                                  value={startDate ? formatDateToMMDDYYYY(startDate) : null}
                                                  onChange={e => e.preventDefault()}
                                                  placeholder="Start Date"
                                                  className="md:w-[13rem] h-11 rounded-md border border-[#E4E7EC] placeholder:text-[#667085] placeholder-y-[0.2rem]"
                                                  disabled={true}
                                                />
                                                <span>to</span>
                                                <InputText
                                                  value={endDate ? formatDateToMMDDYYYY(endDate) : null}
                                                  onChange={e => e.preventDefault()}
                                                  placeholder="End Date"
                                                  className="md:w-[13rem] h-11 rounded-md border border-[#E4E7EC] placeholder:text-[#667085] placeholder-y-[0.2rem]"
                                                  disabled={true}
                                                />
                                              </div>
                                            </div>

                                            <div className='mt-2.5 leading-10'>
                                              I understand and accept this assignment under the following provisions:
                                            </div>
                                            <ul/* style={{listStyleType:'lower-alpha'}} */ className='list-decimal mt-2.5 leading-10 pl-20'
                                            >
                                              <li>Payment for the sixth period teaching assignment shall be at my hourly rate of pay,determined by dividing my daily rate of pay by five (5).</li>
                                              <li>The sixth period teaching assignment will not interfere with my regularly assigned duties.</li>
                                              <li>The sixth period teaching assignment replaces my normal preparation/conference period,which will then be scheduled <u>immediately preceding or concluding the normal worksite day</u>.</li>
                                              <li>This assignment is contingent on funding and enrollment.</li>
                                            </ul>
                                            <br />
                                            <br />
                                            <br />

                                            <div className="col">
                                              <span>Assignment Title<span className="text-[red] pl-0.2">*</span></span>
                                              <InputText disabled
                                                value={assignmentTitle}
                                                onChange={e => setAssignmentTitle(e.target.value)}
                                                id="username"
                                                placeholder="Type Here"
                                                className="w-full placeholder:text-[#667085] "
                                                aria-describedby="username-help"
                                              />
                                            </div>
                                            <br />

                                            <div className={"mb-8"}>
                                              <div style={{ marginTop: '10px' }} className=" border sixPeriodDisableText">
                                                <div>
                                                  <table style={{ width: "100%", fontSize: "14px" }}>
                                                    <tbody>
                                                      <tr>
                                                        <td style={{ border: "1px solid #d0d0d0", padding: "10px" }}>Site Admin/ Dept Head (Second App.)<span className="text-[red] pl-0.2">*</span></td>
                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>
                                                          { /*!selectedEmployee ? (
                                                            <Dropdown
                                                              disabled
                                                              placeholder="Select an Site Admin/ Dept Head"
                                                              className="w-full md:w-14rem"
                                                              showClear
                                                            />
                                                          ) : */

                                                            (
                                                              <Dropdown
                                                                disabled={!pendingApprovers.includes('site_admin')}
                                                                value={selectedReportingManagerEmployee}
                                                                onChange={e => {
                                                                  setSelectedReportingManagerEmployee(e.value);
                                                                  handleClearButtonClick(e, empCodeListForRM, "SiteAdmin")
                                                                }}
                                                                options={empCodeListForRM}
                                                                onKeyDown={e => {
                                                                  setEmpList(e, "SiteAdmin")
                                                                }}
                                                                optionLabel="name"
                                                                placeholder="Select an Site Admin/ Dept Head"
                                                                filter
                                                                showClear={selectedReportingManagerEmployee}
                                                                className="w-full md:w-14rem"
                                                              />
                                                            )}
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td style={{ border: "1px solid #d0d0d0", padding: "10px" }}>Budget Clerk (Third App.)</td>
                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>
                                                          <Dropdown
                                                            disabled={!pendingApprovers.includes('budget_clerk')}
                                                            value={selectedBudgetClerk}
                                                            onChange={e => { setSelectedBudgetClerk(e.value); handleClearButtonClick(e, empCodeListForBC, "BudgetClerk"); }}
                                                            options={empCodeListForBC}
                                                            onKeyDown={e => {
                                                              setEmpList(e, "BudgetClerk")
                                                            }}
                                                            optionLabel="name"
                                                            placeholder="Select a Budget Clerk"
                                                            filter
                                                            showClear={selectedBudgetClerk}
                                                            // valueTemplate={selectedCountryTemplate}
                                                            className="w-full md:w-14rem"
                                                          />
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td style={{ border: "1px solid #d0d0d0", padding: "10px" }}>Budget Director (Fourth App.)</td>
                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>
                                                          {!selectedBudgetClerk ? (
                                                            <Dropdown
                                                              disabled
                                                              placeholder="Select a Budget Director"
                                                              className="w-full md:w-14rem"
                                                              showClear
                                                            />
                                                          ) : (
                                                            <Dropdown
                                                              disabled={!pendingApprovers.includes('budget_director')}
                                                              value={selectedBudgetManager}
                                                              onChange={e => {
                                                                setSelectedBudgetManager(e.value); handleClearButtonClick(e, empCodeListForBD, "BudgetDirector");
                                                              }}
                                                              onKeyDown={e => {
                                                                setEmpList(e, "BudgetDirector")
                                                              }}
                                                              options={empCodeListForBD}
                                                              optionLabel="name"
                                                              placeholder="Select a Budget Manager"
                                                              filter
                                                              showClear={selectedBudgetManager}
                                                              className="w-full md:w-14rem"
                                                            />
                                                          )}
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td style={{ border: "1px solid #d0d0d0", padding: "10px" }}>HR Director (Fifth App.)<span className="text-[red] pl-0.2">*</span></td>
                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>
                                                          <Dropdown
                                                            disabled={!pendingApprovers.includes('hr_director')}
                                                            value={selectedHrDirector}
                                                            onChange={e => { setSelectedHrDirector(e.value); handleClearButtonClick(e, empCodeListForHRD, "HRdirector"); }}
                                                            options={empCodeListForHRD}
                                                            onKeyDown={e => {
                                                              setEmpList(e, "HRdirector")
                                                            }}
                                                            optionLabel="name"
                                                            placeholder="Select an HR Director"
                                                            filter
                                                            showClear={selectedHrDirector}
                                                            // valueTemplate={selectedCountryTemplate}
                                                            className="w-full md:w-14rem"
                                                          />
                                                        </td>
                                                      </tr>

                                                      <tr>
                                                        <td style={{ border: "1px solid #d0d0d0", padding: "10px" }}>HR Technician (Last App.)<span className="text-[red] pl-0.2">*</span></td>
                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>
                                                          <Dropdown disabled
                                                            value={selectedPayroll}
                                                            onChange={e => {
                                                              setSelectedPayroll(e.value);
                                                            }}
                                                            onKeyDown={e => {
                                                              setEmpList(e, "HRtechnician")
                                                            }}
                                                            options={empCodeListForHRT}
                                                            optionLabel="name"
                                                            placeholder="Select an HR Technician"
                                                            filter
                                                            showClear={empCodeListForHRT}
                                                            className="w-full md:w-14rem"
                                                          />
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            ) : (
                              <div className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]">
                                {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                <HtmlToPdfSix
                                  data={{
                                    approvalFinalData: [],
                                    appName: "Sixth Period Teaching Assignment",
                                    employeeName: selectedEmployeeDetails?.name,
                                    employeeId: selectedEmployeeDetails?.userCode,
                                    schoolName: schoolSelect.name,
                                    dateFrom: startDate ? startDate : '', //moment(startDate).format("YYYY-DD-MM"),
                                    dateTo: endDate ? endDate : '',  //moment(endDate).format("YYYY-DD-MM"),
                                    subjectName: subjectCode,
                                    staffAllocation: totalStaffingAllocationectedRole,
                                    accountCharged: accountCharged,
                                    fteUtilized: fteUtilized,
                                    formName: ""
                                  }}
                                />
                              </div>
                            )}
                          </div>

                          <div className="grid grid-cols-2 mt-[40px] xl:mt-[2.083vw]">
                            <div>
                              {showPreviewPopUp ? (
                                <a
                                  href="#"
                                  onClick={() => (showPreviewPopUp ? setShowPreviewPopUp(false) : null)}
                                  className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                                >
                                  <i className="mr-1 gusd-arrow-line-right"></i>Previous
                                </a>
                              ) : (
                                <a
                                  href="#"
                                  onClick={() => {
                                    setShowPreviewPopUp(false);
                                    onHideEditPopUp();
                                  }}
                                  className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                                >
                                  <i className="mr-1 gusd-arrow-line-right"></i>Previous
                                </a>
                              )}
                            </div>
                            <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                              {editMode ? (
                                currentStatus === "Pending" ? (
                                  <a
                                    onClick={(e) => {
                                      confirm(e, () => {
                                        saveBasicEditInfo(e, "saveas", currentStatus);
                                        setShowPreviewPopUp(false);
                                      });
                                    }}
                                    href="#"
                                    className="inline-block text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium border border-[#D0D5DD] bg-[#EFF8FF] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                                  >
                                    <i className="mr-1 pi pi-save" style={{ fontSize: "0.8rem" }}></i>Save
                                  </a>
                                ) : null
                              ) : (
                                <a
                                  onClick={(e) => {
                                    confirm(e, () => {
                                      saveBasicInfo("save");
                                      setShowPreviewPopUp(false);
                                    });
                                  }}
                                  href="#"
                                  className="inline-block text-[#2D5BE5] text-[16px] xl:text-[0.833vw] font-medium border border-[#D0D5DD] bg-[#EFF8FF] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"
                                >
                                  <i className="mr-1 pi pi-save" style={{ fontSize: "0.8rem" }}></i>Save
                                </a>
                              )}


                              {!showPreviewPopUp ? (
                                editMode ? (
                                  <a
                                    href="#"
                                    disabled={reportSubmitting}
                                    onClick={(e) => {
                                      confirm(e, () => {
                                        saveBasicEditInfo(e, "save", currentStatus);

                                      });
                                    }}
                                    className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                  >
                                    <i className="mr-1 gusd-check"></i>Submit
                                  </a>
                                ) : (
                                  <a
                                    href="#"
                                    disabled={reportSubmitting}
                                    onClick={(e) => {
                                      confirm(e, () => {
                                        setReportSubmitting(true);
                                        saveBasicInfo("submit");
                                      });
                                    }}
                                    className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                  >
                                    <i className="mr-1 gusd-check"></i>Submit
                                  </a>
                                )
                              ) : null}




                              <ConfirmPopup />
                              {showPreviewPopUp ? (
                                editMode ? (
                                  <a
                                    href="#"
                                    disabled={reportSubmitting}
                                    onClick={(e) => {
                                      confirm(e, () => {
                                        saveBasicEditInfo(e, "save", currentStatus);

                                      });
                                    }}
                                    className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                  >
                                    <i className="mr-1 gusd-check"></i>Submit
                                  </a>
                                ) : (
                                  <a
                                    href="#"
                                    disabled={reportSubmitting}
                                    onClick={(e) => {
                                      confirm(e, () => {
                                        setReportSubmitting(true);
                                        saveBasicInfo("submit");
                                      });
                                    }}
                                    className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                  >
                                    <i className="mr-1 gusd-check"></i>Submit
                                  </a>
                                )
                              ) : !editMode ? (
                                <a
                                  href="#"
                                  onClick={() => {
                                    //first we check mandatory fields are filled or not

                                    if (assignmentTitle === "") {
                                      toast.error("Please enter Assighment Title");
                                      return;
                                    } else if (selectedEmployee === "" || selectedEmployee === null) {
                                      toast.error("Please Select Employee Id");
                                      return;
                                    } else if (
                                      selectedReportingManagerEmployee === "" ||
                                      selectedReportingManagerEmployee === null
                                    ) {
                                      toast.error("Please Select Reporting Manager");
                                      return;
                                    } else if (selectedHrDirector === "" || selectedHrDirector === null) {
                                      toast.error("Please Select HR Director");
                                      return;
                                    } else if (selectedPayroll === "" || selectedPayroll === null) {
                                      toast.error("Please Select HR Technician");
                                      return;
                                    } else if (schoolSelect === "") {
                                      toast.error("Please Select Assignment At");
                                      return;
                                    } else if (startDate === null) {
                                      toast.error("Please enter From Date");
                                      return;
                                    } else if (endDate === null) {
                                      toast.error("Please enter To Date");
                                      return;
                                    } else if (subjectCode === null) {
                                      toast.error("Please enter To Date");
                                      return;
                                    }

                                    setShowPreviewPopUp(true);
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium border-[#D0D5DD] bg-[#3366FF] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="mr-1 gusd-eye"></i>Preview
                                </a>
                              ) : editMode ? (
                                <a
                                  href="#"
                                  onClick={() => {
                                    //first we check mandatory fields are filled or not

                                    setShowPreviewPopUp(true);
                                  }}
                                  className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium border-[#D0D5DD] bg-[#3366FF] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] "
                                >
                                  <i className="mr-1 gusd-eye"></i>Preview
                                </a>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* confirmation dialog */}

                      <Dialog
                        header=""
                        visible={confirmVisible2}
                        style={{ width: "30vw" }}
                        closable={false}
                        onHide={() => {
                          setConfirmVisible2(false);
                          setVisibleEdit(false);
                        }}
                        footer={footerContent1}
                      >
                        <p className="m-0 text-[#0487C8]">
                          <i className="mr-2 pi pi-check-circle"></i>
                          <span className="font-medium text-[18px]">This Report Has been Successfully Created</span>
                        </p>
                      </Dialog>
                      <div className={`h-full col-span-3 openSideDiv sideBarRight ${hideRightPanel ? 'hidden' : ''}`}>
                        {/*<div className="col-span-3 sideBarRight openSideDiv">*/}
                        <div className="relative h-full">
                          <div className="text-[24px] xl:text-[1.250vw] font-medium">Employee Details</div>
                          <div className="mt-[15px] lg:mt-[32px] xl:[1.667vw]">
                            {selectedEmployee ? (
                              <div className="grid grid-cols-12 gap-4 ">
                                {/* <Avatar className='col-span-3' image="/images/avatar/amyelsner.png" size="xlarge" shape="circle" /> */}
                                <div className="col-span-7">
                                  <label
                                    className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block"
                                    for="username"
                                  >
                                    Name
                                  </label>
                                  <div className="text-[#101828] text-[12px] font-medium">
                                    {selectedEmployeeDetails?.name}
                                  </div>
                                </div>
                                {/* <i className='col-span-2 gusd-edit'></i> */}
                              </div>
                            ) : null}

                            <div className="absolute bottom-[20px] left-0 right-0 xl:bottom-[2.083vw] -z-[1]">
                              <img src={empDetailsImg} class=" mx-auto" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Dialog>

            {
              (isVisibleDelete) ?
                <RestoreDialog
                  isVisibleDelete={isVisibleDelete}
                  setIsVisibleDelete={setIsVisibleDelete}
                  isVisibleDeleteID={isVisibleDeleteID}
				  restoreData={restoreData}
				loggedUserId={loggedUserId}
                  getMasterData={() => processInitiatedReports()}
                  setIsLoadData={() => setInitiatorReportsLoading(true)}
                  queries={queries.getSixthPeriodAssignmentInitiateReport}
                  tableName={"getSixthPeriodAssignmentInitiateReport"}
                  mutations={mutations.updateSixthPeriodAssignmentInitiateReport}
                /> : null
            }

          </Layout>
        )}
      </ReactFullscreen>
    </>
  ) : (
    <Login sessionExpired={1} />
  );
}
